import InputLabel from "@mui/material/InputLabel";
import { motion } from "framer-motion";
import { useCallback, useContext, useEffect, useState } from "react";
import CategoriaContainer from "../../../../components/CategoriaContainer/CategoriaContainer.js";
import CustomButton from "../../../../components/CustomButton/CustomButton";
import ModalAtualizar from "../../../../components/ModalAtualizar/ModalAtualizar.tsx";
import NavbarV3 from "../../../../components/NavbarV3/NavbarV3.tsx";
import Text from "../../../../components/Text/Text";
import ToastErro from "../../../../components/Toast/ToastErro/ToastErro.tsx";
import ToastSucesso from "../../../../components/Toast/ToastSucesso/ToastSucesso.tsx";
import MenusRedux from "../../../../contexts/Menus";
import { useProfile } from "../../../../contexts/ProfileContext.tsx";
import MotionSemAutorizacao from "../../../../core/components/MotionSemAutorizacao.tsx";
import { editaEmpresa } from "../../../../services/ModuloGerenciador/Administrativo";
import { editaUsuarioTabelaPorId } from "../../../../services/ModuloGerenciador/UsuarioTabela";
import "./ConfiguracoesColunas.css";

function ConfiguracoesColunas() {
	const {
		profile,
		hasRegra,
		tabelaEmpresa,
		setTabelaEmpresa,
		setTabelaUsuario,
		coresEmpresa,
	} = useProfile();

	const { setDadosMenusRedux } = useContext(MenusRedux);

	const [jaPassou, setJaPassou] = useState(false);

	const [showCidadeEstado, setShowCidadeEstado] = useState(false);

	const [showEmbalagem, setShowEmbalagem] = useState(false);

	const [showMotivoOnTime, setShowMotivoOnTime] = useState(false);

	const [showGrupoCarga, setShowGrupoCarga] = useState(false);

	const [showEmbarcador, setShowEmbarcador] = useState(false);

	const [showEmbarque, setShowEmbarque] = useState(false);

	const [showEmpresaSub, setShowEmpresaSub] = useState(false);

	const [showFilial, setShowFilial] = useState(false);

	const [showMeioPagamento, setShowMeioPagamento] = useState(false);

	const [showMercadoria, setShowMercadoria] = useState(false);

	const [showMotorista, setShowMotorista] = useState(false);

	const [showNotificacao, setShowNotificacao] = useState(false);

	const [showPedido, setShowPedido] = useState(false);

	const [showProprietario, setShowProprietario] = useState(false);

	const [showRota, setShowRota] = useState(false);

	const [showSolicitacao, setShowSolicitacao] = useState(false);

	const [showStatus, setShowStatus] = useState(false);

	const [showTaxaIcms, setShowTaxaIcms] = useState(false);

    const [showDivergenciasSat, setShowDivergenciasSat] = useState(false);

	const [showUnidadeEmbarque, setShowUnidadeEmbarque] = useState(false);

	const [showUsuarioGeren, setShowUsuarioGeren] = useState(false);

	const [showMotivo, setShowMotivo] = useState(false);

	const [showVeiculo, setShowVeiculo] = useState(false);

	const [showCaminhao, setShowCaminhao] = useState(false);

	const [showCarreta, setShowCarreta] = useState(false);

	const [showAvisos, setShowAvisos] = useState(false);

	const [showTipoCheckagem, setShowTipoCheckagem] = useState(false);

	const [showCheckagem, setShowCheckagem] = useState(false);

	const [showTipoRastreamento, setShowTipoRastreamento] = useState(false);

	const [showGrupoClientes, setShowGrupoClientes] = useState(false);

	const [showCockpit, setShowCockpit] = useState(false);

	const [showGrupoComClientes, setShowGrupoComClientes] = useState(false);

	const [showGrupoCargaVinculo, setShowGrupoCargaVinculo] = useState(false);

	const [showCotacao, setShowCotacao] = useState(false);

	const [showRastreamento, setShowRastreamento] = useState(false);

	const [showGrupoPrecificacao, setShowGrupoPrecificacao] = useState(false);

	const [showValorEmbarque, setShowValorEmbarque] = useState(false);

	const [showTipoVeiculo, setShowTipoVeiculo] = useState(false);

	const [showTipoCarroceria, setShowTipoCarroceria] = useState(false);

	const [showMotivoCotacao, setShowMotivoCotacao] = useState(false);

	const [showSegmentoCliente, setShowSegmentoCliente] = useState(false);

	const [showOcorrencia, setShowOcorrencia] = useState(false);

	const [showTipoOcorrencia, setShowTipoOcorrencia] = useState(false);

	const [showSubTipoOcorrencia, setShowSubTipoOcorrencia] = useState(false);

	const [showSorteio, setShowSorteio] = useState(false);

	const [showConfiguracaoEmpresa, setShowConfiguracaoEmpresa] = useState(false);

	const [showDocumentacao, setShowDocumentacao] = useState(false);

	const [showTipoDocumento, setShowTipoDocumento] = useState(false);

	const [showTipoContato, setShowTipoContato] = useState(false);

	const [showTipoObservacao, setShowTipoObservacao] = useState(false);

	const [showStatusDiaria, setShowStatusDiaria] = useState(false);

	const [showMotivoEstadia, setShowMotivoEstadia] = useState(false);

	const [showEstadia, setShowEstadia] = useState(false);

	const [cidadeValue, setCidadeValue] = useState(tabelaEmpresa.CidadeEstado[0]);

	const [estadoValue, setEstadoValue] = useState(tabelaEmpresa.CidadeEstado[1]);

	const [abreviacaoValue, setAbreviacaoValue] = useState(
		tabelaEmpresa.CidadeEstado[2]
	);

	const [embalagemValue, setEmbalagemValue] = useState(
		tabelaEmpresa.Embalagem[0]
	);

	const [nomeFantasiaValue, setNomeFantasiaValue] = useState(
		tabelaEmpresa.Cliente[0]
	);

	const [razaoSocialValue, setRazaoSocialValue] = useState(
		tabelaEmpresa.Cliente[1]
	);

	const [cnpjClienteValue, setCnpjClienteValue] = useState(
		tabelaEmpresa.Cliente[2]
	);

	const [enderecoValue, setEnderecoValue] = useState(tabelaEmpresa.Cliente[3]);

	const [apelidoValue, setApelidoValue] = useState(tabelaEmpresa.Cliente[4]);

	const [diFreteFiscalValue, setDiFreteFiscalValue] = useState(
		tabelaEmpresa.Cliente[5]
	);

	const [diPedagioValue, setDiPedagioValue] = useState(
		tabelaEmpresa.Cliente[6]
	);

	const [diClassificacaoValue, setDiClassificacaoValue] = useState(
		tabelaEmpresa.Cliente[7]
	);

	const [tempoDiariaMinutosClienteValue, setTempoDiariaMinutosClientesValue] =
		useState(tabelaEmpresa.Cliente[8]);

	const [usuarioClienteValue, setUsuarioClienteValue] = useState(
		tabelaEmpresa.Cliente[9]
	);

	const [descricaoValue, setDescricaoValue] = useState(
		tabelaEmpresa.Embarque[0]
	);

	const [unidEmbarqueValue, setUnidEmbarqueValue] = useState(
		tabelaEmpresa.Embarque[1]
	);

	const [empresaValue, setEmpresaValue] = useState(tabelaEmpresa.Embarque[2]);

	const [filialValue, setFilialValue] = useState(tabelaEmpresa.Embarque[3]);

	const [rotaEmbarqueValue, setRotaEmbarqueValue] = useState(
		tabelaEmpresa.Embarque[4]
	);

	const [pedidoValue, setPedidoValue] = useState(tabelaEmpresa.Embarque[5]);

	const [cteValue, setCteValue] = useState(tabelaEmpresa.Embarque[6]);

	const [previsaoEmbarqueValue, setPrevisaoEmbarqueValue] = useState(
		tabelaEmpresa.Embarque[7]
	);

	const [previsaoEntregaValue, setPrevisaoEntregaValue] = useState(
		tabelaEmpresa.Embarque[8]
	);

	const [dataHoraChegadaEmbarqueValue, setDataHoraChegadaEmbarqueValue] =
		useState(tabelaEmpresa.Embarque[9]);

	const [dataHoraEmbarcadoValue, setDataHoraEmbarcadoValue] = useState(
		tabelaEmpresa.Embarque[10]
	);

	const [dataHoraChegadaEntregaValue, setDataHoraChegadaEntregaValue] =
		useState(tabelaEmpresa.Embarque[11]);

	const [dataHoraEntregueValue, setDataHoraEntregueValue] = useState(
		tabelaEmpresa.Embarque[12]
	);

	const [aceiteValue, setAceiteValue] = useState(tabelaEmpresa.Embarque[13]);

	const [statusValue, setStatusValue] = useState(tabelaEmpresa.Embarque[14]);

	const [placaCavaloValue, setPlacaCavaloValue] = useState(
		tabelaEmpresa.Embarque[15]
	);

	const [placaCarretaValue, setPlacaCarretaValue] = useState(
		tabelaEmpresa.Embarque[16]
	);

	const [placaCarreta2Value, setPlacaCarreta2Value] = useState(
		tabelaEmpresa.Embarque[17]
	);

	const [proprietarioValue, setProprietarioValue] = useState(
		tabelaEmpresa.Embarque[18]
	);

	const [motoristaValue, setMotoristaValue] = useState(
		tabelaEmpresa.Embarque[19]
	);

	const [freteFiscalValue, setFreteFiscalValue] = useState(
		tabelaEmpresa.Embarque[20]
	);

	const [icmsValue, setIcmsValue] = useState(tabelaEmpresa.Embarque[21]);

	const [freteMotoristaValue, setFreteMotoristaValue] = useState(
		tabelaEmpresa.Embarque[22]
	);

	const [adicionalEmpresaValue, setAdicionalEmpresaValue] = useState(
		tabelaEmpresa.Embarque[23]
	);

	const [adicionalMotoristaValue, setAdicionalMotoristaValue] = useState(
		tabelaEmpresa.Embarque[24]
	);

	const [numeroEixosEmbarqueValue, setNumeroEixosEmbarqueValue] = useState(
		tabelaEmpresa.Embarque[25]
	);

	const [pedagioValue, setPedagioValue] = useState(tabelaEmpresa.Embarque[26]);

	const [classificacaoValue, setClassificacaoValue] = useState(
		tabelaEmpresa.Embarque[27]
	);

	const [margemValue, setMargemValue] = useState(tabelaEmpresa.Embarque[28]);

	const [adiantamentoValue, setAdiamentoValue] = useState(
		tabelaEmpresa.Embarque[29]
	);

	const [saldoValue, setSaldoValue] = useState(tabelaEmpresa.Embarque[30]);

	const [meioPagamentoValue, setMeioPagamentoValue] = useState(
		tabelaEmpresa.Embarque[31]
	);

	const [meioPagamento2Value, setMeioPagamento2Value] = useState(
		tabelaEmpresa.Embarque[32]
	);

	const [kmValue, setKmValue] = useState(tabelaEmpresa.Embarque[33]);

	const [clienteValue, setClienteValue] = useState(tabelaEmpresa.Embarque[34]);

	const [embarcadorEmbValue, setEmbarcadorEmbValue] = useState(
		tabelaEmpresa.Embarque[35]
	);

	const [destinatarioEmbValue, setDestinatarioEmbValue] = useState(
		tabelaEmpresa.Embarque[36]
	);

	const [loadValue, setLoadValue] = useState(tabelaEmpresa.Embarque[37]);

	const [mercadoriaValue, setMercadoriaValue] = useState(
		tabelaEmpresa.Embarque[38]
	);

	const [pesoValue, setPesoValue] = useState(tabelaEmpresa.Embarque[39]);

	const [embalagemEmbValue, setEmbalagemEmbValue] = useState(
		tabelaEmpresa.Embarque[40]
	);

	const [observacaoValue, setObservacaoValue] = useState(
		tabelaEmpresa.Embarque?.[41]
	);

	const [frotaValue, setFrotaValue] = useState(tabelaEmpresa.Embarque?.[42]);

	const [canceladoValue, setCanceladoValue] = useState(
		tabelaEmpresa.Embarque?.[43]
	);

	const [motivoEmbarqueValue, setMotivoEmbarqueValue] = useState(
		tabelaEmpresa.Embarque?.[44]
	);

	const [usuarioResponsavelValue, setUsuarioResponsavelValue] = useState(
		tabelaEmpresa.Embarque?.[45]
	);

	const [nEntregasValue, setNEntregasValue] = useState(
		tabelaEmpresa.Embarque?.[46]
	);

	const [comprovanteValue, setComprovanteValue] = useState(
		tabelaEmpresa.Embarque?.[47]
	);

	const [checkinValue, setCheckinValue] = useState(
		tabelaEmpresa.Embarque?.[48]
	);

	const [quebraTabelaEmbarque, setQuebraTabelaEmbarqueValue] = useState(
		tabelaEmpresa.Embarque?.[49]
	);

	const [nomeValue, setNomeValue] = useState(tabelaEmpresa.EmpresaSub[0]);

	const [cnpjValue, setCnpjValue] = useState(tabelaEmpresa.EmpresaSub[1]);

	const [cidadeEmpresaSubValue, setCidadeEmpresaSubValue] = useState(
		tabelaEmpresa.EmpresaSub[2]
	);

	const [regimeTributarioValue, setegimeTributarioValue] = useState(
		tabelaEmpresa.EmpresaSub[3]
	);

	const [nomeSocialValue, setNomeSocialValue] = useState(
		tabelaEmpresa.EmpresaSub?.[4]
	);

	const [enderecoEmpresaSubValue, setEnderecoEmpresaSubValue] = useState(
		tabelaEmpresa.EmpresaSub?.[5]
	);

	const [nomeFiliaValue, setNomeFilialValue] = useState(
		tabelaEmpresa.Filial[0]
	);

	const [complementoLocalizacaoValue, setComplementoLocalizacaoValue] =
		useState(tabelaEmpresa.Filial[1]);

	const [responsavelValue, setResponsavelValue] = useState(
		tabelaEmpresa.Filial[2]
	);

	const [telefoneValue, setTelefoneValue] = useState(tabelaEmpresa.Filial[3]);

	const [emailValue, setEmailValue] = useState(tabelaEmpresa.Filial[4]);

	const [cidadeFilialValue, setCidadeFilialValue] = useState(
		tabelaEmpresa.Filial[5]
	);

	const [nomeMeioPagamentoValue, setNomeMeioPagamentoValue] = useState(
		tabelaEmpresa.MeioPagamento[0]
	);

	const [mercadoriaNomeValue, setMercadoriaNomeValue] = useState(
		tabelaEmpresa.Mercadoria[0]
	);

	const [nomeMotoristaValue, setNomeMotoristaValue] = useState(
		tabelaEmpresa.Motorista?.[0]
	);

	const [numeroDocumentoValue, setNumeroDocumentoValue] = useState(
		tabelaEmpresa.Motorista?.[1]
	);

	const [tipoDocumentoValue, setTipoDocumentoValue] = useState(
		tabelaEmpresa.Motorista?.[2]
	);

	const [telefoneMotoristaValue, setTelefoneMotoristaValue] = useState(
		tabelaEmpresa.Motorista?.[3]
	);

	const [nomeEmergenciaValue, setNomeEmergenciaValue] = useState(
		tabelaEmpresa.Motorista?.[4]
	);

	const [telefoneEmergenciaValue, setTelefoneEmergenciaValue] = useState(
		tabelaEmpresa.Motorista?.[5]
	);

	const [enderecoMotoristaValue, setEnderecoMotoristaValue] = useState(
		tabelaEmpresa.Motorista?.[6]
	);

	const [frotaMotoristaValue, setFrotaMotoristaValue] = useState(
		tabelaEmpresa.Motorista?.[7]
	);

	const [usuarioMotoristaValue, setUsuarioMotoristaValue] = useState(
		tabelaEmpresa.Motorista?.[8]
	);

	const [bloqueadoValue, setBloqueadoValue] = useState(
		tabelaEmpresa.Motorista?.[9]
	);

	const [motivoBloqueadoValue, setMotivoBloqueadoValue] = useState(
		tabelaEmpresa.Motorista?.[10]
	);

	const [tituloNotificaoValue, setTituloNotificaoValue] = useState(
		tabelaEmpresa.Notificacao[0]
	);

	const [mensagemNotificacaoValue, setMensagemNotificacaoValue] = useState(
		tabelaEmpresa.Notificacao[1]
	);

	const [acaoNotificacaoValue, setAcaoNotificacaoValue] = useState(
		tabelaEmpresa.Notificacao[2]
	);

	const [
		numeroVisualizacoesNotificacaoValue,
		setNumeroVisualizacoesNotificacaoValueValue,
	] = useState(tabelaEmpresa.Notificacao[3]);

	const [dataNotificacaoValue, setDataNotificacaoValuValue] = useState(
		tabelaEmpresa.Notificacao[4]
	);

	const [pedidoPValue, setPedidoPValue] = useState(tabelaEmpresa.Pedido[0]);

	const [tipoRotaValue, setTipoRotaValue] = useState(tabelaEmpresa.Pedido[1]);

	const [freteFiscalPValue, setFreteFiscalPValue] = useState(
		tabelaEmpresa.Pedido[2]
	);

	const [icmsPValue, setIcmsPValue] = useState(tabelaEmpresa.Pedido[3]);

	const [pedagioPValue, setPedagioPValue] = useState(tabelaEmpresa.Pedido[4]);

	const [classificacaoPValue, setClassificacaoPValue] = useState(
		tabelaEmpresa.Pedido[5]
	);

	const [kmPValue, setKmPValue] = useState(tabelaEmpresa.Pedido[6]);

	const [clientePValue, setClientePValue] = useState(tabelaEmpresa.Pedido[7]);

	const [embarcadorPValue, setEmbarcadorPValue] = useState(
		tabelaEmpresa.Pedido[8]
	);

	const [destinatarioPValue, setDestinatarioPValue] = useState(
		tabelaEmpresa.Pedido[9]
	);

	const [freteMotoristaPValue, setFreteMotoristaPValue] = useState(
		tabelaEmpresa.Pedido[10]
	);

	const [observacaoPValue, setObservacaoPValue] = useState(
		tabelaEmpresa.Pedido[11]
	);

	const [permiteAlterarFreteFiscalValue, setPermiteAlterarFreteFiscalValue] =
		useState(tabelaEmpresa.Pedido?.[12]);

	const [valorEmbarquePedidoValue, setValorEmbarquePedidoValue] = useState(
		tabelaEmpresa.Pedido[13]
	);

	const [icmsEmbutido, setIcmsEmbutidoValue] = useState(
		tabelaEmpresa.Pedido[14]
	);

	const [icmsEmbarcador, setIcmsEmbarcadorValue] = useState(
		tabelaEmpresa.Pedido[15]
	);

	const [freteNormal, setFreteNormalValue] = useState(tabelaEmpresa.Pedido[16]);

	const [quebraTabelaPedido, setQuebraTabelaPedidoValue] = useState(
		tabelaEmpresa.Pedido[17]
	);

	const [proprietarioNomeValue, setProprietarioNomeValue] = useState(
		tabelaEmpresa.Proprietario[0]
	);

	const [cnpjProprietarioValue, setCnpjProprietarioValue] = useState(
		tabelaEmpresa.Proprietario[1]
	);

	const [usuarioProprietarioValue, setUsuarioProprietarioValue] = useState(
		tabelaEmpresa.Proprietario[2]
	);

	const [tipoProprietarioValue, setTipoProprietarioValue] = useState(
		tabelaEmpresa.Proprietario[3]
	);

	const [nomeRotaValue, setNomeRotaValue] = useState(tabelaEmpresa.Rota[0]);

	const [motivoValue, setMotivoValues] = useState(tabelaEmpresa.Motivo[0]);

	const [cidadeOrigemRotaValue, setCidadeOrigemRotaValue] = useState(
		tabelaEmpresa.Rota[1]
	);

	const [estadoOrigemRotaValue, setEstadoOrigemRotaValue] = useState(
		tabelaEmpresa.Rota[2]
	);

	const [cidadeDestinoRotaValue, setCidadeDestinoRotaValue] = useState(
		tabelaEmpresa.Rota[3]
	);

	const [estadoDestinoRotaValue, setEstadoDestinoRotaValue] = useState(
		tabelaEmpresa.Rota[4]
	);

	const [usuarioSolicitacaoValue, setUsuarioSolicitacaoValue] = useState(
		tabelaEmpresa.Solicitacoes[0]
	);

	const [emailSolicitacaoValue, setEmailSolicitacaoValue] = useState(
		tabelaEmpresa.Solicitacoes[1]
	);

	const [telefoneSolicitacaoValue, setTelefoneSolicitacaoValue] = useState(
		tabelaEmpresa.Solicitacoes[2]
	);

	const [nascimentoSolicitacaoValue, setNascimentoSolicitacaoValue] = useState(
		tabelaEmpresa.Solicitacoes[3]
	);

	const [aceitarSolicitacaoValue, setAceitarSolicitacaoValue] = useState(
		tabelaEmpresa.Solicitacoes[4]
	);

	const [recusarSolicitacaoValue, setRecusarSolicitacaoValue] = useState(
		tabelaEmpresa.Solicitacoes[5]
	);

	const [nomeStatusValue, setNomeStatusValue] = useState(
		tabelaEmpresa.Status[0]
	);

	const [taxaIcmsValue, setTaxaIcmsValue] = useState(tabelaEmpresa.TaxaIcms[0]);

	const [ufOrigemTaxaValue, setUfOrigemTaxaValue] = useState(
		tabelaEmpresa.TaxaIcms[1]
	);

	const [ufDestinoTaxaValue, setUfDestinoTaxaValue] = useState(
		tabelaEmpresa.TaxaIcms[2]
	);

	const [nomeUnidadeEmbarqueValue, setNomeUnidadeEmbarqueValue] = useState(
		tabelaEmpresa.UnidadeEmbarque[0]
	);

	const [cidadeUnidadeEmbarqueValue, setCidadeUnidadeEmbarqueValue] = useState(
		tabelaEmpresa.UnidadeEmbarque[1]
	);

	const [frotaUnidadeEmbarqueValue, setFrotaUnidadeEmbarqueValue] = useState(
		tabelaEmpresa.UnidadeEmbarque[2]
	);

	const [nomeUsuarioGerenValue, setNomeUsuarioGerenValue] = useState(
		tabelaEmpresa.UsuarioGeren[0]
	);

	const [senhaUsuarioGerenValue, setSenhaUsuarioGerenValue] = useState(
		tabelaEmpresa.UsuarioGeren[1]
	);

	const [emailUsuarioGerenValue, setEmailUsuarioGerenValue] = useState(
		tabelaEmpresa.UsuarioGeren[2]
	);

	const [telefoneUsuarioGerenValue, setTelefoneUsuarioGerenValue] = useState(
		tabelaEmpresa.UsuarioGeren[3]
	);

	const [cargoUsuarioGerenValue, setCargoUsuarioGerenValue] = useState(
		tabelaEmpresa.UsuarioGeren[4]
	);

	const [nascimentoUsuarioGerenValue, setNascimentoUsuarioGerenValue] =
		useState(tabelaEmpresa.UsuarioGeren[5]);

	const [permissoesUsuarioGerenValue, setPermissoesUsuarioGerenValue] =
		useState(tabelaEmpresa.UsuarioGeren[6]);

	const [ultimoLoginValue, setUltimoLoginValue] = useState(
		tabelaEmpresa.UsuarioGeren[7]
	);

	const [ultimoLogoutValue, setUltimoLogoutValue] = useState(
		tabelaEmpresa.UsuarioGeren[8]
	);

	const [placaCavaloVeiculoValue, setPlacaCavaloVeiculoValue] = useState(
		tabelaEmpresa.Veiculo[0]
	);

	const [placaCarretaVeiculoValue, setPlacaCarretaVeiculoValue] = useState(
		tabelaEmpresa.Veiculo[1]
	);

	const [placaCarreta2VeiculoValue, setPlacaCarreta2VeiculoValue] = useState(
		tabelaEmpresa.Veiculo[2]
	);

	const [proprietarioVeiculoValue, setProprietarioVeiculoValue] = useState(
		tabelaEmpresa.Veiculo[3]
	);

	const [motoristaVeiculoValue, setMotoristaVeiculoValue] = useState(
		tabelaEmpresa.Veiculo[4]
	);

	const [motorista2VeiculoValue, setMotorista2VeiculoValue] = useState(
		tabelaEmpresa.Veiculo[5]
	);

	const [eixosValue, setEixosValue] = useState(tabelaEmpresa.Veiculo?.[6]);

	const [tipoVeiculoValue, setTipoVeiculoValue] = useState(
		tabelaEmpresa.Veiculo?.[7]
	);

	const [tipoCarroceriaValue, setTipoCarroceriaValue] = useState(
		tabelaEmpresa.Veiculo?.[8]
	);

	const [tipoVeiculoConjuntosValue, setTipoVeiculoConjuntosValue] = useState(
		tabelaEmpresa.Veiculo?.[9]
	);

	const [ativoDiariaValue, setAtivoDiariaValue] = useState(
		tabelaEmpresa.Veiculo?.[10]
	);

	const [elegivelBrfValue, setElegivelBrfValue] = useState(
		tabelaEmpresa.Veiculo?.[11]
	);

	const [cidadeEstadoConjuntoValue, setCidadeEstadoConjuntoValue] = useState(
		tabelaEmpresa.Veiculo?.[12]
	);

	const [dataAtualizacaoLocalizacaoValue, setDataAtualizacaoLocalizacaoValue] =
		useState(tabelaEmpresa.Veiculo?.[13]);

	const [agregadoValue, setAgregadoValue] = useState(
		tabelaEmpresa.Veiculo?.[14]
	);

	const [telemetriaValue, setTelemetriaValue] = useState(
		tabelaEmpresa.Veiculo?.[15]
	);

	const [placaCaminhaoValue, setPlacaCaminhaoValue] = useState(
		tabelaEmpresa.Caminhao[0]
	);

	const [anoCaminhaoValue, setAnoCaminhaoValue] = useState(
		tabelaEmpresa.Caminhao[1]
	);

	const [renavamCaminhaoValue, setRenavamCaminhaoValue] = useState(
		tabelaEmpresa.Caminhao[2]
	);

	const [marcaCaminhaoValue, setMarcaCaminhaoValue] = useState(
		tabelaEmpresa.Caminhao[3]
	);

	const [modeloCaminhaoValue, setModeloCaminhaoValue] = useState(
		tabelaEmpresa.Caminhao[4]
	);

	const [frotaCaminhaoValue, setFrotaCaminhaoValue] = useState(
		tabelaEmpresa.Caminhao[5]
	);

	const [kmCaminhaoValue, setKmCaminhaoValue] = useState(
		tabelaEmpresa.Caminhao?.[6]
	);

	const [eixosCaminhaoValue, setEixosCaminhaoValue] = useState(
		tabelaEmpresa.Caminhao?.[7]
	);

	const [placaCarretaCaminhaoValue, setPlacaCarretaCaminhaoValue] = useState(
		tabelaEmpresa.Carreta[0]
	);

	const [anoCarretaCaminhaoValue, setAnoCarretaCaminhaoValue] = useState(
		tabelaEmpresa.Carreta[1]
	);

	const [renavamCarretaCaminhaoValue, setRenavamCarretaCaminhaoValue] =
		useState(tabelaEmpresa.Carreta[2]);

	const [marcaCarretaCaminhaoValue, setMarcaCarretaCaminhaoValue] = useState(
		tabelaEmpresa.Carreta[3]
	);

	const [modeloCarretaCaminhaoValue, setModeloCarretaCaminhaoValue] = useState(
		tabelaEmpresa.Carreta[4]
	);

	const [frotaCarretaValue, setFrotaCarretaValue] = useState(
		tabelaEmpresa.Carreta[5]
	);

	const [kmCarretaValue, setKmCarretaValue] = useState(
		tabelaEmpresa.Carreta?.[6]
	);

	const [eixosCarretaValue, setEixosCarretaValue] = useState(
		tabelaEmpresa.Carreta?.[7]
	);

	const [mensagemAvisoValue, setMensagemAvisoValue] = useState(
		tabelaEmpresa.Avisos?.[0]
	);

	const [dataAvisoValue, setDataAvisoValue] = useState(
		tabelaEmpresa.Avisos?.[1]
	);

	const [nomeTipoCheckagemValue, setNomeTipoCheckagemValue] = useState(
		tabelaEmpresa.TipoCheckagem?.[0]
	);

	const [notificarAutomaticoValue, setNotificarAutomaticoValue] = useState(
		tabelaEmpresa.TipoCheckagem?.[1]
	);

	const [tipoNotificacaoValue, setTipoNotificacaoValue] = useState(
		tabelaEmpresa.TipoCheckagem?.[2]
	);

	const [notificarACadaDataValue, setNotificarACadaDataValue] = useState(
		tabelaEmpresa.TipoCheckagem?.[3]
	);

	const [notificarACadaKmValue, setNotificarACadaKMValue] = useState(
		tabelaEmpresa.TipoCheckagem?.[4]
	);

	const [dadosCheckagemValue, setDadosCheckagemValue] = useState(
		tabelaEmpresa.Checkagem?.[0]
	);

	const [dataCheckagemValue, setDataCheckagemValue] = useState(
		tabelaEmpresa.Checkagem?.[1]
	);

	const [observacaoCheckagemValue, setObservacaoCheckagemValue] = useState(
		tabelaEmpresa.Checkagem?.[2]
	);

	const [kmCheckagemValue, setKmCheckagemValue] = useState(
		tabelaEmpresa.Checkagem?.[3]
	);

	const [localCheckagemValue, setLocalCheckagemValue] = useState(
		tabelaEmpresa.Checkagem?.[4]
	);

	const [tipoManutencaoCheckagemValue, setTipoManutencaoCheckagemValue] =
		useState(tabelaEmpresa.Checkagem?.[5]);

	const [proximaRevisaoDataValue, setProximaRevisaoDataValue] = useState(
		tabelaEmpresa.Checkagem?.[6]
	);

	const [proximaRevisaoKMValue, setProximaRevisaoKMValue] = useState(
		tabelaEmpresa.Checkagem?.[7]
	);

	const [tipoCheckValue, setTipoCheckValue] = useState(
		tabelaEmpresa.Checkagem?.[8]
	);

	const [nomeTipoRastreamentoValue, setNomeTipoRastreamentoValue] = useState(
		tabelaEmpresa.TipoRastreamento?.[0]
	);

	const [ipValue, setIpValue] = useState(tabelaEmpresa.TipoRastreamento?.[1]);

	const [usuarioRastreamentoValue, setUsuarioRastreamentoValue] = useState(
		tabelaEmpresa.Rastreamento?.[0]
	);

	const [senhaRastreamentoValue, setSenhaRastreamentoValue] = useState(
		tabelaEmpresa.Rastreamento?.[1]
	);

	const [tipoVeiculoRastreamentoValue, setTipoVeiculoRastreamentoValue] =
		useState(tabelaEmpresa.Rastreamento?.[2]);

	const [tipoRastreamentoValue, setTipoRastreamentoValue] = useState(
		tabelaEmpresa.Rastreamento?.[3]
	);

	const [veiculoRastreamentoValue, setVeiculoRastreamentoValue] = useState(
		tabelaEmpresa.Rastreamento?.[4]
	);

	const [fabricanteRastreamentoValue, setFabricanteRastreamentoValue] =
		useState(tabelaEmpresa.Rastreamento?.[5]);

	const [numeroRastreadorValue, setNumeroRastreadorValue] = useState(
		tabelaEmpresa.Rastreamento?.[6]
	);

	const [nomeGrupoClienteValue, setNomeGrupoClienteValue] = useState(
		tabelaEmpresa.GrupoClientes?.[0]
	);

	const [projetadoValue, setProjetadoValue] = useState(
		tabelaEmpresa.Cockpit?.[0]
	);

	const [estadoOrigemCockpitValue, setEstadoOrigemCockpitValue] = useState(
		tabelaEmpresa.Cockpit?.[1]
	);

	const [estadoDestinoCockpitValue, setEstadoDestinoCockpitValue] = useState(
		tabelaEmpresa.Cockpit?.[2]
	);

	const [grupoClienteCockpitValue, setGrupoClienteCockpitValue] = useState(
		tabelaEmpresa.Cockpit?.[3]
	);

	const [clienteVinculoValue, setClienteVinculoValue] = useState(
		tabelaEmpresa.GrupoComClientes?.[0]
	);

	const [grupoClienteVinculoValue, setGrupoClienteVinculoValue] = useState(
		tabelaEmpresa.GrupoComClientes?.[1]
	);

	const [grupoPrecificacaoValue, setGrupoPrecificacaoValue] = useState(
		tabelaEmpresa.GrupoPrecificacao?.[0]
	);

	const [eixosValorEmbarqueValue, setEixosValorEmbarqueValue] = useState(
		tabelaEmpresa.ValorEmbarque?.[0]
	);

	const [kmValorEmbarqueValue, setKmValorEmbarqueValue] = useState(
		tabelaEmpresa.ValorEmbarque?.[1]
	);

	const [valorEixoValorEmbarqueValue, setValorEixoValorEmbarqueValue] =
		useState(tabelaEmpresa.ValorEmbarque?.[2]);

	const [
		adicionalCargaDescargaValorEmbarqueValue,
		setAdicionalCargaDescargaValorEmbarqueValue,
	] = useState(tabelaEmpresa.ValorEmbarque?.[3]);

	const [motoristaValorEmbarqueValue, setMotoristaValorEmbarqueValue] =
		useState(tabelaEmpresa.ValorEmbarque?.[4]);

	const [empresaValorEmbarqueValue, setEmpresaValorEmbarqueValue] = useState(
		tabelaEmpresa.ValorEmbarque?.[5]
	);

	const [icmsValorEmbarqueValue, setIcmsValorEmbarqueValue] = useState(
		tabelaEmpresa.ValorEmbarque?.[6]
	);

	const [descargaValorEmbarqueValue, setDescargaValorEmbarqueValue] = useState(
		tabelaEmpresa.ValorEmbarque?.[7]
	);

	const [pedagioValorEmbarqueValue, setPedagioValorEmbarqueValue] = useState(
		tabelaEmpresa.ValorEmbarque?.[8]
	);

	const [freteFiscalValorEmbarqueValue, setFreteFiscalValorEmbarqueValue] =
		useState(tabelaEmpresa.ValorEmbarque?.[9]);

	const [rotaValorEmbarqueValue, setRotaValorEmbarqueValue] = useState(
		tabelaEmpresa.ValorEmbarque?.[10]
	);

	const [clienteValorEmbarqueValue, setClienteValorEmbarqueValue] = useState(
		tabelaEmpresa.ValorEmbarque?.[11]
	);

	const [
		grupoPrecificacaoValorEmbarqueValue,
		setGrupoPrecificacaoValorEmbarqueValue,
	] = useState(tabelaEmpresa.ValorEmbarque?.[12]);

	const [motivoOnTimeValue, setMotivoOnTimeValue] = useState(
		tabelaEmpresa.MotivoOnTime?.[0]
	);

	const [grupoCargaValue, setGrupoCargaValue] = useState(
		tabelaEmpresa.GrupoCarga?.[0]
	);

	const [grupoCargaVinculoValue, setGrupoCargaVinculoValue] = useState(
		tabelaEmpresa.GrupoCargaVinculo?.[0]
	);

	const [
		motoristaGrupoCargaVinculoVinculoValue,
		setMotoristaGrupoCargaVinculoValue,
	] = useState(tabelaEmpresa.GrupoCargaVinculo?.[1]);

	const [
		proprietarioGrupoCargaVinculoVinculoValue,
		setProprietarioGrupoCargaVinculoValue,
	] = useState(tabelaEmpresa.GrupoCargaVinculo?.[2]);

	const [unidadeEmbarqueCotacaoValue, setUnidadeEmbarqueCotacaoValue] =
		useState(tabelaEmpresa.Cotacao?.[0]);

	const [rotaCotacaoValue, setRotaCotacaoValue] = useState(
		tabelaEmpresa.Cotacao?.[1]
	);

	const [clienteCotacaoValue, setClienteCotacaoValue] = useState(
		tabelaEmpresa.Cotacao?.[2]
	);

	const [valorCotacaoValue, setValorCotacaoValue] = useState(
		tabelaEmpresa.Cotacao?.[3]
	);

	const [icmsCotacaoValue, setIcmsCotacaoValue] = useState(
		tabelaEmpresa.Cotacao?.[4]
	);

	const [pedagioCotacaoValue, setPedagioCotacaoValue] = useState(
		tabelaEmpresa.Cotacao?.[5]
	);

	const [distanciaKmCotacaoValue, setDistanciaKmCotacaoValue] = useState(
		tabelaEmpresa.Cotacao?.[6]
	);

	const [valorPorKmCotacaoValue, setValorPorKmCotacaoValue] = useState(
		tabelaEmpresa.Cotacao?.[7]
	);

	const [
		valorDesejavelMotoristaCotacaoValue,
		setValorDesejavelMotoristaCotacaoValue,
	] = useState(tabelaEmpresa.Cotacao?.[8]);

	const [descricaoRotaCotacaoValue, setDescricaoRotaCotacaoValue] = useState(
		tabelaEmpresa.Cotacao?.[9]
	);

	const [foiCarregadoCotacaoValue, setFoiCarregadoCotacaoValue] = useState(
		tabelaEmpresa.Cotacao?.[10]
	);

	const [tipoVeiculoCotacaoValue, setTipoVeiculoCotacaoValue] = useState(
		tabelaEmpresa.Cotacao?.[11]
	);

	const [tipoCarroceriaCotacaoValue, setTipoCarroceriaCotacaoValue] = useState(
		tabelaEmpresa.Cotacao?.[12]
	);

	const [segmentoCliente, setSegmentoCliente] = useState(
		tabelaEmpresa.Cotacao?.[13]
	);

	const [motivoCotacao, setMotivoCotacao] = useState(
		tabelaEmpresa.Cotacao?.[14]
	);

	const [dataCotacaoValue, setDataCotacaoValue] = useState(
		tabelaEmpresa.Cotacao?.[15]
	);

	const [usuarioResponsavelCotacaoValue, setUsuarioResponsavelCotacaoValue] =
		useState(tabelaEmpresa.Cotacao?.[16]);

	const [nomeContatoCotacaoValue, setNomeContatoCotacaoValue] = useState(
		tabelaEmpresa.Cotacao?.[17]
	);

	const [telefoneContatoCotacaoValue, setTelefoneContatoCotacaoValue] =
		useState(tabelaEmpresa.Cotacao?.[18]);

	const [emailContatoCotacaoValue, setEmailContatoCotacaoValue] = useState(
		tabelaEmpresa.Cotacao?.[19]
	);

	const [observacaoCotacaoValue, setObservacaoCotacaoValue] = useState(
		tabelaEmpresa.Cotacao?.[20]
	);

	const [nomeTipoVeiculo, setNomeTipoVeiculo] = useState(
		tabelaEmpresa.TipoVeiculo?.[0]
	);

	const [nomeTipoCarroceria, setNomeTipoCarroceria] = useState(
		tabelaEmpresa.TipoCarroceria?.[0]
	);

	const [motivoCotacaoValue, setMotivoCotacaoValue] = useState(
		tabelaEmpresa.MotivoCotacao?.[0]
	);

	const [segmentoClienteValue, setSegmentoClienteValue] = useState(
		tabelaEmpresa.SegmentoCliente?.[0]
	);

	const [ocorrenciaValue, setOcorrenciaValue] = useState(
		tabelaEmpresa.Ocorrencia?.[0]
	);

	const [tipoOcorrenciaValue, setTipoOcorrenciaValue] = useState(
		tabelaEmpresa.TipoOcorrencia?.[0]
	);

	const [subTipoOcorrenciaValue, setSubTipoOcorrenciaValue] = useState(
		tabelaEmpresa.SubTipoOcorrencia?.[0]
	);

	const [tipoOcorrenciaSubValue, setTipoOcorrenciaSubValue] = useState(
		tabelaEmpresa.SubTipoOcorrencia?.[1]
	);

	const [nomeSorteioValue, setNomeSorteioValue] = useState(
		tabelaEmpresa.Sorteio?.[0]
	);

	const [apenasCpfValue, setApenasCpfValue] = useState(
		tabelaEmpresa.Sorteio?.[1]
	);

	const [cupomsValue, setCupomsValue] = useState(tabelaEmpresa.Sorteio?.[2]);

	const [cuponsPorViagem, setCuponsPorViagemValue] = useState(
		tabelaEmpresa.Sorteio?.[3]
	);

	const [dataSorteioValue, setDataSorteioValue] = useState(
		tabelaEmpresa.Sorteio?.[4]
	);

	const [encerradoValue, setEncerradoValue] = useState(
		tabelaEmpresa.Sorteio?.[5]
	);

	const [fimBuscaValue, setFimBuscaValue] = useState(
		tabelaEmpresa.Sorteio?.[6]
	);

	const [inicioBuscaValue, setInicioBuscaValue] = useState(
		tabelaEmpresa.Sorteio?.[7]
	);

	const [motoristasValue, setMotoristasValue] = useState(
		tabelaEmpresa.Sorteio?.[8]
	);

	const [numerosKmPorCupomValue, setNumerosKmPorCupomValue] = useState(
		tabelaEmpresa.Sorteio?.[9]
	);

	const [proprietariosValue, setProprietariosValue] = useState(
		tabelaEmpresa.Sorteio?.[10]
	);

	const [sorteadosValue, setSorteadosValue] = useState(
		tabelaEmpresa.Sorteio?.[11]
	);

	const [tempoDiariaMinutosValue, setTempoDiariaMinutosValue] = useState(
		tabelaEmpresa.ConfiguracaoEmpresa?.[0]
	);

	const [grupoClienteDiariaValue, setGrupoClienteDiariaValue] = useState(
		tabelaEmpresa.ConfiguracaoEmpresa?.[1]
	);

	const [diariaEmbarqueValue, setDiariaEmbarqueValue] = useState(
		tabelaEmpresa.ConfiguracaoEmpresa?.[2]
	);

	const [diariaEntregaValue, setDiariaEntregaValue] = useState(
		tabelaEmpresa.ConfiguracaoEmpresa?.[3]
	);

	const [somaDiariasValue, setSomaDiariasValue] = useState(
		tabelaEmpresa.ConfiguracaoEmpresa?.[4]
	);

	const [placaDocumentacaoValue, setPlacaDocumentacaoValue] = useState(
		tabelaEmpresa.Documentacao?.[0]
	);

	const [proprietarioDocumentacaoValue, setProprietarioDocumentacaoValue] =
		useState(tabelaEmpresa.Documentacao?.[1]);

	const [motoristaDocumentacaoValue, setMotoristaDocumentacaoValue] = useState(
		tabelaEmpresa.Documentacao?.[2]
	);

	const [nomeTipoDocValue, setNomeTipoDocValue] = useState(
		tabelaEmpresa.TipoDocumento?.[0]
	);

	const [tipoDocValue, setTipoDocValue] = useState(
		tabelaEmpresa.TipoDocumento?.[1]
	);

	const [contatoValue, setContatoValue] = useState(
		tabelaEmpresa.TipoContato?.[0]
	);

	const [tipoContatoValue, setTipoContatoValue] = useState(
		tabelaEmpresa.TipoContato?.[1]
	);

	const [proprietarioContatoValue, setProprietarioContatoValue] = useState(
		tabelaEmpresa.TipoContato?.[2]
	);

	const [motoristaContatoValue, setMotoristaContatoValue] = useState(
		tabelaEmpresa.TipoContato?.[3]
	);

	const [nomeContatoValue, setNomeContatoValue] = useState(
		tabelaEmpresa.TipoContato?.[4]
	);

	const [observacaoContatoValue, setObservacaoContatoValue] = useState(
		tabelaEmpresa.TipoContato?.[5]
	);

	const [tipoObservacaoValue, setTipoObservacaoValue] = useState(
		tabelaEmpresa.TipoObservacao?.[0]
	);

	const [statusDiariaValue, setStatusDiariaValue] = useState(
		tabelaEmpresa.StatusDiaria?.[0]
	);

	const [motivoEstadiaValue, setMotivoEstadiaValue] = useState(
		tabelaEmpresa.MotivoEstadia?.[0]
	);

	const [statusDiariaEstadiaValue, setStatusDiariaEstadiaValue] = useState(
		tabelaEmpresa.Estadia?.[9]
	);

	const [motivoEstadiaEstadiaValue, setMotivoEstadiaEstadiaValue] = useState(
		tabelaEmpresa.Estadia?.[10]
	);

	const [tipoVeiculoEstadiaValue, setTipoVeiculoEstadiaValue] = useState(
		tabelaEmpresa.Estadia?.[11]
	);

	const [dasteEstadiaValue, setDasteEstadiaValue] = useState(
		tabelaEmpresa.Estadia?.[12]
	);

	const [observacaoEstadiaValue, setObservacaoEstadiaValue] = useState(
		tabelaEmpresa.Estadia?.[13]
	);

	const [cteComplementarEstadiaValue, setCteComplementarEstadiaValue] =
		useState(tabelaEmpresa.Estadia?.[14]);

	const [tipoEstadiaEstadiaValue, setTipoEstadiaEstadiaValue] = useState(
		tabelaEmpresa.Estadia?.[15]
	);

	const [freteEmpresaEstadiaValue, setFreteEmpresaEstadiaValue] = useState(
		tabelaEmpresa.Estadia?.[16]
	);

	const [freteMotoristaEstadiaValue, setFreteMotoristaEstadiaValue] = useState(
		tabelaEmpresa.Estadia?.[17]
	);

	const [cteDivergenciasValue, setCteDivergenciasValue] = useState(
		tabelaEmpresa.DivergenciasSAT[0]
	);
    
	const [
		freteMotoristaGerenciadorDivergenciasValue,
		setFreteMotoristaGerenciadorDivergenciasValue,
	] = useState(tabelaEmpresa.DivergenciasSAT[1]);

	const [
		freteMotoristaSatDivergenciasValue,
		setFreteMotoristaSatDivergenciasValue,
	] = useState(tabelaEmpresa.DivergenciasSAT[2]);

	const [
		freteFiscalGerenciadorDivergenciasValue,
		setFreteFiscalGerenciadorDivergenciasValue,
	] = useState(tabelaEmpresa.DivergenciasSAT[3]);

	const [freteFiscalSatDivergenciasValue, setFreteFiscalSatDivergenciasValue] =
		useState(tabelaEmpresa.DivergenciasSAT[4]);

	const [
		pedagioGerenciadorDivergenciasValue,
		setPedagioGerenciadorDivergenciasValue,
	] = useState(tabelaEmpresa.DivergenciasSAT[5]);

	const [pedagioSatDivergenciasValue, setPedagioSatDivergenciasValue] =
		useState(tabelaEmpresa.DivergenciasSAT[6]);

	const [
		icmsGerenciadorDivergenciasValue,
		setIcmsGerenciadorDivergenciasValue,
	] = useState(tabelaEmpresa.DivergenciasSAT[7]);

	const [icmsSatDivergenciasValue, setIcmsSatDivergenciasValue] = useState(
		tabelaEmpresa.DivergenciasSAT[8]
	);

	const [
		usuarioResponsavelGerenciadorDivergenciasValue,
		setUsuarioResponsavelGerenciadorDivergenciasValue,
	] = useState(tabelaEmpresa.DivergenciasSAT[9]);

	const [temDiferencaDivergenciasValue, setTemDiferencaDivergenciasValue] =
		useState(tabelaEmpresa.DivergenciasSAT[10]);

	const [
		dataUltimaVerificacaoDivergenciasValue,
		setDataUltimaVerificacaoDivergenciasValue,
	] = useState(tabelaEmpresa.DivergenciasSAT[11]);

	const [open, setOpen] = useState(false);

	const [loading, setLoading] = useState(false);

	const [openToastSucesso, setOpenToastSucesso] = useState(false);

	const [openToastErro, setOpenToastErro] = useState(false);

	const [textoSucesso, setTextoSucesso] = useState("");

	const [textoErro, setTextoErro] = useState("");

	const handleCloseToastSucesso = (value) => {
		setOpenToastSucesso(false);
	};

	const handleCloseToastErro = (value) => {
		setOpenToastErro(false);
	};

	const handleClose = (value) => {
		setOpen(false);
	};

	const valorInicialVisivel = () => {
		return {
			Embarque: [
				{
					nomeColuna: descricaoValue?.nomeColuna,
					field: "descricao",
					visivel: "true",
				},
				{
					nomeColuna: unidEmbarqueValue.nomeColuna,
					field: "unidEmbarque",
					visivel: "true",
				},
				{
					nomeColuna: empresaValue.nomeColuna,
					field: "empresa",
					visivel: "true",
				},
				{
					nomeColuna: filialValue.nomeColuna,
					field: "filial",
					visivel: "true",
				},
				{
					nomeColuna: rotaEmbarqueValue.nomeColuna,
					field: "rota",
					visivel: "true",
				},
				{
					nomeColuna: pedidoValue.nomeColuna,
					field: "pedido",
					visivel: "true",
				},
				{
					nomeColuna: cteValue.nomeColuna,
					field: "cte",
					visivel: "true",
				},
				{
					nomeColuna: previsaoEmbarqueValue.nomeColuna,
					field: "previsaoEmbarque",
					visivel: "true",
				},
				{
					nomeColuna: previsaoEntregaValue.nomeColuna,
					field: "previsaoEntrega",
					visivel: "true",
				},
				{
					nomeColuna: dataHoraChegadaEmbarqueValue.nomeColuna,
					field: "dataHoraChegadaEmbarque",
					visivel: "true",
				},
				{
					nomeColuna: dataHoraEmbarcadoValue.nomeColuna,
					field: "dataHoraEmbarcado",
					visivel: "true",
				},
				{
					nomeColuna: dataHoraChegadaEntregaValue.nomeColuna,
					field: "dataHoraChegadaEntrega",
					visivel: "true",
				},
				{
					nomeColuna: dataHoraEntregueValue.nomeColuna,
					field: "dataHoraEntregue",
					visivel: "true",
				},
				{
					nomeColuna: aceiteValue.nomeColuna,
					field: "aceite",
					visivel: "true",
				},
				{
					nomeColuna: statusValue.nomeColuna,
					field: "status",
					visivel: "true",
				},
				{
					nomeColuna: placaCavaloValue.nomeColuna,
					field: "placaCavalo",
					visivel: "true",
				},
				{
					nomeColuna: placaCarretaValue.nomeColuna,
					field: "placaCarreta",
					visivel: "true",
				},
				{
					nomeColuna: placaCarreta2Value.nomeColuna,
					field: "placaCarreta2",
					visivel: "true",
				},
				{
					nomeColuna: proprietarioValue.nomeColuna,
					field: "proprietario",
					visivel: "true",
				},
				{
					nomeColuna: motoristaValue.nomeColuna,
					field: "veiculoMotorista",
					visivel: "true",
				},
				{
					nomeColuna: freteFiscalValue.nomeColuna,
					field: "freteFiscal",
					visivel: "true",
					tipo: "number",
				},
				{
					nomeColuna: icmsValue.nomeColuna,
					field: "icms",
					visivel: "true",
					tipo: "number",
				},
				{
					nomeColuna: freteMotoristaValue.nomeColuna,
					field: "freteMotorista",
					visivel: "true",
					tipo: "number",
				},
				{
					nomeColuna: adicionalEmpresaValue.nomeColuna,
					field: "adicionalEmpresa",
					visivel: "true",
					tipo: "number",
				},
				{
					nomeColuna: adicionalMotoristaValue.nomeColuna,
					field: "adicionalMotorista",
					visivel: "true",
					tipo: "number",
				},
				{
					nomeColuna: numeroEixosEmbarqueValue.nomeColuna,
					field: "numeroEixos",
					visivel: "true",
					tipo: "number",
				},
				{
					nomeColuna: pedagioValue.nomeColuna,
					field: "pedagio",
					visivel: "true",
					tipo: "number",
				},
				{
					nomeColuna: classificacaoValue.nomeColuna,
					field: "classificacao",
					visivel: "true",
					tipo: "number",
				},
				{
					nomeColuna: margemValue.nomeColuna,
					field: "margem",
					visivel: "true",
				},
				{
					nomeColuna: adiantamentoValue.nomeColuna,
					field: "adiantamento",
					visivel: "true",
					tipo: "number",
				},
				{
					nomeColuna: saldoValue.nomeColuna,
					field: "saldo",
					visivel: "true",
					tipo: "number",
				},
				{
					nomeColuna: meioPagamentoValue.nomeColuna,
					field: "meioPagamento",
					visivel: "true",
				},
				{
					nomeColuna: meioPagamento2Value.nomeColuna,
					field: "meioPagamento2",
					visivel: "true",
				},
				{
					nomeColuna: kmValue.nomeColuna,
					field: "km",
					visivel: "true",
					tipo: "number",
				},
				{
					nomeColuna: clienteValue.nomeColuna,
					field: "cliente",
					visivel: "true",
				},
				{
					nomeColuna: embarcadorEmbValue.nomeColuna,
					field: "embarcador",
					visivel: "true",
				},
				{
					nomeColuna: destinatarioEmbValue.nomeColuna,
					field: "destinatario",
					visivel: "true",
				},
				{
					nomeColuna: loadValue.nomeColuna,
					field: "load",
					visivel: "true",
				},
				{
					nomeColuna: mercadoriaValue.nomeColuna,
					field: "mercadoria",
					visivel: "true",
				},
				{
					nomeColuna: pesoValue?.nomeColuna,
					field: "peso",
					visivel: "true",
					tipo: "number",
				},
				{
					nomeColuna: embalagemEmbValue?.nomeColuna,
					field: "embalagem",
					visivel: "true",
				},
				{
					nomeColuna: observacaoValue?.nomeColuna,
					field: "observacao",
					visivel: "true",
				},
				{
					nomeColuna: frotaValue?.nomeColuna,
					field: "frota",
					visivel: "true",
				},
				{
					nomeColuna: canceladoValue?.nomeColuna,
					field: "cancelado",
					visivel: "true",
				},
				{
					nomeColuna: motivoEmbarqueValue?.nomeColuna,
					field: "motivo",
					visivel: "true",
				},
				{
					nomeColuna: usuarioResponsavelValue?.nomeColuna,
					field: "usuarioResponsavel",
					visivel: "true",
				},
				{
					nomeColuna: nEntregasValue?.nomeColuna,
					field: "nEntregas",
					visivel: "true",
				},
				{
					nomeColuna: comprovanteValue?.nomeColuna,
					field: "comprovante",
					visivel: "true",
				},
				{
					nomeColuna: checkinValue?.nomeColuna,
					field: "checkInFeito",
					visivel: "true",
				},
				{
					quebraColunaEmbarque: quebraTabelaEmbarque?.quebraColunaEmbarque,
				},
			],
			ModeloEmbarque: [
				{
					nomeColuna: descricaoValue?.nomeColuna,
					field: "descricao",
					visivel: "true",
				},
				{
					nomeColuna: unidEmbarqueValue.nomeColuna,
					field: "unidEmbarque",
					visivel: "true",
				},
				{
					nomeColuna: empresaValue.nomeColuna,
					field: "empresa",
					visivel: "true",
				},
				{
					nomeColuna: filialValue.nomeColuna,
					field: "filial",
					visivel: "true",
				},
				{
					nomeColuna: rotaEmbarqueValue.nomeColuna,
					field: "rota",
					visivel: "true",
				},
				{
					nomeColuna: pedidoValue.nomeColuna,
					field: "pedido",
					visivel: "true",
				},
				{
					nomeColuna: cteValue.nomeColuna,
					field: "cte",
					visivel: "true",
				},
				{
					nomeColuna: previsaoEmbarqueValue.nomeColuna,
					field: "previsaoEmbarque",
					visivel: "true",
				},
				{
					nomeColuna: previsaoEntregaValue.nomeColuna,
					field: "previsaoEntrega",
					visivel: "true",
				},
				{
					nomeColuna: dataHoraChegadaEmbarqueValue.nomeColuna,
					field: "dataHoraChegadaEmbarque",
					visivel: "true",
				},
				{
					nomeColuna: dataHoraEmbarcadoValue.nomeColuna,
					field: "dataHoraEmbarcado",
					visivel: "true",
				},
				{
					nomeColuna: dataHoraChegadaEntregaValue.nomeColuna,
					field: "dataHoraChegadaEntrega",
					visivel: "true",
				},
				{
					nomeColuna: dataHoraEntregueValue.nomeColuna,
					field: "dataHoraEntregue",
					visivel: "true",
				},
				{
					nomeColuna: aceiteValue.nomeColuna,
					field: "aceite",
					visivel: "true",
				},
				{
					nomeColuna: statusValue.nomeColuna,
					field: "status",
					visivel: "true",
				},
				{
					nomeColuna: placaCavaloValue.nomeColuna,
					field: "placaCavalo",
					visivel: "true",
				},
				{
					nomeColuna: placaCarretaValue.nomeColuna,
					field: "placaCarreta",
					visivel: "true",
				},
				{
					nomeColuna: placaCarreta2Value.nomeColuna,
					field: "placaCarreta2",
					visivel: "true",
				},
				{
					nomeColuna: proprietarioValue.nomeColuna,
					field: "proprietario",
					visivel: "true",
				},
				{
					nomeColuna: motoristaValue.nomeColuna,
					field: "veiculoMotorista",
					visivel: "true",
				},
				{
					nomeColuna: freteFiscalValue.nomeColuna,
					field: "freteFiscal",
					visivel: "true",
					tipo: "number",
				},
				{
					nomeColuna: icmsValue.nomeColuna,
					field: "icms",
					visivel: "true",
					tipo: "number",
				},
				{
					nomeColuna: freteMotoristaValue.nomeColuna,
					field: "freteMotorista",
					visivel: "true",
					tipo: "number",
				},
				{
					nomeColuna: adicionalEmpresaValue.nomeColuna,
					field: "adicionalEmpresa",
					visivel: "true",
					tipo: "number",
				},
				{
					nomeColuna: adicionalMotoristaValue.nomeColuna,
					field: "adicionalMotorista",
					visivel: "true",
					tipo: "number",
				},
				{
					nomeColuna: numeroEixosEmbarqueValue.nomeColuna,
					field: "numeroEixos",
					visivel: "true",
					tipo: "number",
				},
				{
					nomeColuna: pedagioValue.nomeColuna,
					field: "pedagio",
					visivel: "true",
					tipo: "number",
				},
				{
					nomeColuna: classificacaoValue.nomeColuna,
					field: "classificacao",
					visivel: "true",
					tipo: "number",
				},
				{
					nomeColuna: margemValue.nomeColuna,
					field: "margem",
					visivel: "true",
				},
				{
					nomeColuna: adiantamentoValue.nomeColuna,
					field: "adiantamento",
					visivel: "true",
					tipo: "number",
				},
				{
					nomeColuna: saldoValue.nomeColuna,
					field: "saldo",
					visivel: "true",
					tipo: "number",
				},
				{
					nomeColuna: meioPagamentoValue.nomeColuna,
					field: "meioPagamento",
					visivel: "true",
				},
				{
					nomeColuna: meioPagamento2Value.nomeColuna,
					field: "meioPagamento2",
					visivel: "true",
				},
				{
					nomeColuna: kmValue.nomeColuna,
					field: "km",
					visivel: "true",
					tipo: "number",
				},
				{
					nomeColuna: clienteValue.nomeColuna,
					field: "cliente",
					visivel: "true",
				},
				{
					nomeColuna: embarcadorEmbValue.nomeColuna,
					field: "embarcador",
					visivel: "true",
				},
				{
					nomeColuna: destinatarioEmbValue.nomeColuna,
					field: "destinatario",
					visivel: "true",
				},
				{
					nomeColuna: loadValue.nomeColuna,
					field: "load",
					visivel: "true",
				},
				{
					nomeColuna: mercadoriaValue.nomeColuna,
					field: "mercadoria",
					visivel: "true",
				},
				{
					nomeColuna: pesoValue?.nomeColuna,
					field: "peso",
					visivel: "true",
					tipo: "number",
				},
				{
					nomeColuna: embalagemEmbValue?.nomeColuna,
					field: "embalagem",
					visivel: "true",
				},
				{
					nomeColuna: observacaoValue?.nomeColuna,
					field: "observacao",
					visivel: "true",
				},
				{
					nomeColuna: frotaValue?.nomeColuna,
					field: "frota",
					visivel: "true",
				},
				{
					nomeColuna: canceladoValue?.nomeColuna,
					field: "cancelado",
					visivel: "true",
				},
				{
					nomeColuna: motivoEmbarqueValue?.nomeColuna,
					field: "motivo",
					visivel: "true",
				},
				{
					nomeColuna: usuarioResponsavelValue?.nomeColuna,
					field: "usuarioResponsavel",
					visivel: "true",
				},
				{
					nomeColuna: nEntregasValue?.nomeColuna,
					field: "nEntregas",
					visivel: "true",
				},
				{
					nomeColuna: comprovanteValue?.nomeColuna,
					field: "comprovante",
					visivel: "true",
				},
				{
					nomeColuna: checkinValue?.nomeColuna,
					field: "checkInFeito",
					visivel: "true",
				},
				{
					quebraColunaEmbarque: quebraTabelaEmbarque?.quebraColunaEmbarque,
				},
			],
			Pedido: [
				{
					nomeColuna: pedidoPValue.nomeColuna,
					field: "pedido",
					visivel: "true",
				},
				{
					nomeColuna: tipoRotaValue.nomeColuna,
					field: "tipoRota",
					visivel: "true",
				},
				{
					nomeColuna: freteFiscalPValue.nomeColuna,
					field: "freteFiscal",
					visivel: "true",
					tipo: "number",
				},
				{
					nomeColuna: icmsPValue.nomeColuna,
					field: "icms",
					visivel: "true",
					tipo: "number",
				},
				{
					nomeColuna: pedagioPValue.nomeColuna,
					field: "pedagio",
					visivel: "true",
					tipo: "number",
				},
				{
					nomeColuna: classificacaoPValue.nomeColuna,
					field: "classificacao",
					visivel: "true",
					tipo: "number",
				},
				{
					nomeColuna: kmPValue.nomeColuna,
					field: "km",
					visivel: "true",
					tipo: "number",
				},
				{
					nomeColuna: clientePValue.nomeColuna,
					field: "cliente",
					visivel: "true",
				},
				{
					nomeColuna: embarcadorPValue.nomeColuna,
					field: "embarcador",
					visivel: "true",
				},
				{
					nomeColuna: destinatarioPValue.nomeColuna,
					field: "destinatario",
					visivel: "true",
				},
				{
					nomeColuna: freteMotoristaPValue.nomeColuna,
					field: "freteMotorista",
					visivel: "true",
					tipo: "number",
				},
				{
					nomeColuna: observacaoPValue.nomeColuna,
					field: "observacao",
					visivel: "true",
				},
				{
					nomeColuna: permiteAlterarFreteFiscalValue.nomeColuna,
					field: "permiteAlterarFreteFiscal",
					visivel: "true",
				},
				{
					nomeColuna: valorEmbarquePedidoValue?.nomeColuna,
					field: "valorEmbarque",
					objetoValorEmbarque: "true",
					visivel: "true",
				},
				{
					nomeColuna: icmsEmbutido?.nomeColuna,
					field: "icmsEmbutido",
					visivel: "true",
				},
				{
					nomeColuna: icmsEmbarcador?.nomeColuna,
					field: "icmsEmbarcador",
					visivel: "true",
				},
				{
					nomeColuna: freteNormal?.nomeColuna,
					field: "freteNormal",
					visivel: "true",
				},
				{
					quebraColunaPedido: quebraTabelaPedido?.quebraColunaPedido,
				},
			],
		};
	};

	const valorInicial = () => {
		return {
			CidadeEstado: [
				{
					nomeColuna: cidadeValue.nomeColuna,
					field: "cidade",
				},
				{
					nomeColuna: estadoValue.nomeColuna,
					field: "estado",
				},
				{
					nomeColuna: "Abreviação",
					field: "abreviacao",
				},
			],
			Embalagem: [
				{
					nomeColuna: embalagemValue.nomeColuna,
					field: "nome",
				},
			],
			Cliente: [
				{
					nomeColuna: nomeFantasiaValue?.nomeColuna,
					field: "nomeFantasia",
				},
				{
					nomeColuna: razaoSocialValue?.nomeColuna,
					field: "razaoSocial",
				},
				{
					nomeColuna: cnpjClienteValue?.nomeColuna,
					field: "cnpj",
				},
				{
					nomeColuna: enderecoValue?.nomeColuna,
					field: "endereco",
					objetoEndereco: "true",
				},
				{
					nomeColuna: apelidoValue?.nomeColuna,
					field: "apelido",
				},
				{
					nomeColuna: diFreteFiscalValue?.nomeColuna,
					field: "diFreteFiscal",
				},
				{
					nomeColuna: diPedagioValue?.nomeColuna,
					field: "diPedagio",
				},
				{
					nomeColuna: diClassificacaoValue?.nomeColuna,
					field: "diClassificacao",
				},
				{
					nomeColuna: tempoDiariaMinutosClienteValue?.nomeColuna,
					field: "tempoDiariaMinutos",
				},
				{
					nomeColuna: usuarioClienteValue?.nomeColuna,
					field: "usuarioClientes",
					objetoUsuarios: "true",
				},
			],
			Embarque: [
				{
					nomeColuna: descricaoValue?.nomeColuna,
					field: "descricao",
				},
				{
					nomeColuna: unidEmbarqueValue.nomeColuna,
					field: "unidEmbarque",
				},
				{
					nomeColuna: empresaValue.nomeColuna,
					field: "empresa",
				},
				{
					nomeColuna: filialValue.nomeColuna,
					field: "filial",
				},
				{
					nomeColuna: rotaEmbarqueValue.nomeColuna,
					field: "rota",
				},
				{
					nomeColuna: pedidoValue.nomeColuna,
					field: "pedido",
				},
				{
					nomeColuna: cteValue.nomeColuna,
					field: "cte",
				},
				{
					nomeColuna: previsaoEmbarqueValue.nomeColuna,
					field: "previsaoEmbarque",
				},
				{
					nomeColuna: previsaoEntregaValue.nomeColuna,
					field: "previsaoEntrega",
				},
				{
					nomeColuna: dataHoraChegadaEmbarqueValue.nomeColuna,
					field: "dataHoraChegadaEmbarque",
				},
				{
					nomeColuna: dataHoraEmbarcadoValue.nomeColuna,
					field: "dataHoraEmbarcado",
				},
				{
					nomeColuna: dataHoraChegadaEntregaValue.nomeColuna,
					field: "dataHoraChegadaEntrega",
				},
				{
					nomeColuna: dataHoraEntregueValue.nomeColuna,
					field: "dataHoraEntregue",
				},
				{
					nomeColuna: aceiteValue.nomeColuna,
					field: "aceite",
				},
				{
					nomeColuna: statusValue.nomeColuna,
					field: "status",
				},
				{
					nomeColuna: placaCavaloValue.nomeColuna,
					field: "placaCavalo",
				},
				{
					nomeColuna: placaCarretaValue.nomeColuna,
					field: "placaCarreta",
				},
				{
					nomeColuna: placaCarreta2Value.nomeColuna,
					field: "placaCarreta2",
				},
				{
					nomeColuna: proprietarioValue.nomeColuna,
					field: "proprietario",
				},
				{
					nomeColuna: motoristaValue.nomeColuna,
					field: "motorista",
				},
				{
					nomeColuna: freteFiscalValue.nomeColuna,
					field: "freteFiscal",
					tipo: "number",
				},
				{
					nomeColuna: icmsValue.nomeColuna,
					field: "icms",
					tipo: "number",
				},
				{
					nomeColuna: freteMotoristaValue.nomeColuna,
					field: "freteMotorista",
					tipo: "number",
				},
				{
					nomeColuna: adicionalEmpresaValue.nomeColuna,
					field: "adicionalEmpresa",
					tipo: "number",
				},
				{
					nomeColuna: adicionalMotoristaValue.nomeColuna,
					field: "adicionalMotorista",
					tipo: "number",
				},
				{
					nomeColuna: numeroEixosEmbarqueValue.nomeColuna,
					field: "numeroEixos",
					tipo: "number",
				},
				{
					nomeColuna: pedagioValue.nomeColuna,
					field: "pedagio",
					tipo: "number",
				},
				{
					nomeColuna: classificacaoValue.nomeColuna,
					field: "classificacao",
					tipo: "number",
				},
				{
					nomeColuna: margemValue.nomeColuna,
					field: "margem",
				},
				{
					nomeColuna: adiantamentoValue.nomeColuna,
					field: "adiantamento",
					tipo: "number",
				},
				{
					nomeColuna: saldoValue.nomeColuna,
					field: "saldo",
					tipo: "number",
				},
				{
					nomeColuna: meioPagamentoValue.nomeColuna,
					field: "meioPagamento",
				},
				{
					nomeColuna: meioPagamento2Value.nomeColuna,
					field: "meioPagamento2",
				},
				{
					nomeColuna: kmValue.nomeColuna,
					field: "km",
					tipo: "number",
				},
				{
					nomeColuna: clienteValue.nomeColuna,
					field: "cliente",
				},
				{
					nomeColuna: embarcadorEmbValue.nomeColuna,
					field: "embarcador",
				},
				{
					nomeColuna: destinatarioEmbValue.nomeColuna,
					field: "destinatario",
				},
				{
					nomeColuna: loadValue.nomeColuna,
					field: "load",
				},
				{
					nomeColuna: mercadoriaValue.nomeColuna,
					field: "mercadoria",
				},
				{
					nomeColuna: pesoValue?.nomeColuna,
					field: "peso",
					tipo: "number",
				},
				{
					nomeColuna: embalagemEmbValue?.nomeColuna,
					field: "embalagem",
				},
				{
					nomeColuna: observacaoValue?.nomeColuna,
					field: "observacao",
				},
				{
					nomeColuna: frotaValue?.nomeColuna,
					field: "frota",
				},
				{
					nomeColuna: canceladoValue?.nomeColuna,
					field: "cancelado",
				},
				{
					nomeColuna: motivoEmbarqueValue?.nomeColuna,
					field: "motivo",
				},
				{
					nomeColuna: usuarioResponsavelValue?.nomeColuna,
					field: "usuarioResponsavel",
				},
				{
					nomeColuna: nEntregasValue?.nomeColuna,
					field: "nEntregas",
				},
				{
					nomeColuna: comprovanteValue?.nomeColuna,
					field: "comprovante",
				},
				{
					nomeColuna: checkinValue?.nomeColuna,
					field: "checkInFeito",
				},
				{
					quebraColunaEmbarque: quebraTabelaEmbarque?.quebraColunaEmbarque,
				},
			],
			ModeloEmbarque: [
				{
					nomeColuna: descricaoValue?.nomeColuna,
					field: "descricao",
				},
				{
					nomeColuna: unidEmbarqueValue.nomeColuna,
					field: "unidEmbarque",
				},
				{
					nomeColuna: empresaValue.nomeColuna,
					field: "empresa",
				},
				{
					nomeColuna: filialValue.nomeColuna,
					field: "filial",
				},
				{
					nomeColuna: rotaEmbarqueValue.nomeColuna,
					field: "rota",
				},
				{
					nomeColuna: pedidoValue.nomeColuna,
					field: "pedido",
				},
				{
					nomeColuna: cteValue.nomeColuna,
					field: "cte",
				},
				{
					nomeColuna: previsaoEmbarqueValue.nomeColuna,
					field: "previsaoEmbarque",
				},
				{
					nomeColuna: previsaoEntregaValue.nomeColuna,
					field: "previsaoEntrega",
				},
				{
					nomeColuna: dataHoraChegadaEmbarqueValue.nomeColuna,
					field: "dataHoraChegadaEmbarque",
				},
				{
					nomeColuna: dataHoraEmbarcadoValue.nomeColuna,
					field: "dataHoraEmbarcado",
				},
				{
					nomeColuna: dataHoraChegadaEntregaValue.nomeColuna,
					field: "dataHoraChegadaEntrega",
				},
				{
					nomeColuna: dataHoraEntregueValue.nomeColuna,
					field: "dataHoraEntregue",
				},
				{
					nomeColuna: aceiteValue.nomeColuna,
					field: "aceite",
				},
				{
					nomeColuna: statusValue.nomeColuna,
					field: "status",
				},
				{
					nomeColuna: placaCavaloValue.nomeColuna,
					field: "placaCavalo",
				},
				{
					nomeColuna: placaCarretaValue.nomeColuna,
					field: "placaCarreta",
				},
				{
					nomeColuna: placaCarreta2Value.nomeColuna,
					field: "placaCarreta2",
				},
				{
					nomeColuna: proprietarioValue.nomeColuna,
					field: "proprietario",
				},
				{
					nomeColuna: motoristaValue.nomeColuna,
					field: "motorista",
				},
				{
					nomeColuna: freteFiscalValue.nomeColuna,
					field: "freteFiscal",
					tipo: "number",
				},
				{
					nomeColuna: icmsValue.nomeColuna,
					field: "icms",
					tipo: "number",
				},
				{
					nomeColuna: freteMotoristaValue.nomeColuna,
					field: "freteMotorista",
					tipo: "number",
				},
				{
					nomeColuna: adicionalEmpresaValue.nomeColuna,
					field: "adicionalEmpresa",
					tipo: "number",
				},
				{
					nomeColuna: adicionalMotoristaValue.nomeColuna,
					field: "adicionalMotorista",
					tipo: "number",
				},
				{
					nomeColuna: numeroEixosEmbarqueValue.nomeColuna,
					field: "numeroEixos",
					tipo: "number",
				},
				{
					nomeColuna: pedagioValue.nomeColuna,
					field: "pedagio",
					tipo: "number",
				},
				{
					nomeColuna: classificacaoValue.nomeColuna,
					field: "classificacao",
					tipo: "number",
				},
				{
					nomeColuna: margemValue.nomeColuna,
					field: "margem",
				},
				{
					nomeColuna: adiantamentoValue.nomeColuna,
					field: "adiantamento",
					tipo: "number",
				},
				{
					nomeColuna: saldoValue.nomeColuna,
					field: "saldo",
					tipo: "number",
				},
				{
					nomeColuna: meioPagamentoValue.nomeColuna,
					field: "meioPagamento",
				},
				{
					nomeColuna: meioPagamento2Value.nomeColuna,
					field: "meioPagamento2",
				},
				{
					nomeColuna: kmValue.nomeColuna,
					field: "km",
					tipo: "number",
				},
				{
					nomeColuna: clienteValue.nomeColuna,
					field: "cliente",
				},
				{
					nomeColuna: embarcadorEmbValue.nomeColuna,
					field: "embarcador",
				},
				{
					nomeColuna: destinatarioEmbValue.nomeColuna,
					field: "destinatario",
				},
				{
					nomeColuna: loadValue.nomeColuna,
					field: "load",
				},
				{
					nomeColuna: mercadoriaValue.nomeColuna,
					field: "mercadoria",
				},
				{
					nomeColuna: pesoValue?.nomeColuna,
					field: "peso",
					tipo: "number",
				},
				{
					nomeColuna: embalagemEmbValue?.nomeColuna,
					field: "embalagem",
				},
				{
					nomeColuna: observacaoValue?.nomeColuna,
					field: "observacao",
				},
				{
					nomeColuna: frotaValue?.nomeColuna,
					field: "frota",
				},
				{
					nomeColuna: canceladoValue?.nomeColuna,
					field: "cancelado",
				},
				{
					nomeColuna: motivoEmbarqueValue?.nomeColuna,
					field: "motivo",
				},
				{
					nomeColuna: usuarioResponsavelValue?.nomeColuna,
					field: "usuarioResponsavel",
				},
				{
					nomeColuna: nEntregasValue?.nomeColuna,
					field: "nEntregas",
				},
				{
					nomeColuna: comprovanteValue?.nomeColuna,
					field: "comprovante",
				},
				{
					nomeColuna: checkinValue?.nomeColuna,
					field: "checkInFeito",
				},
				{
					quebraColunaEmbarque: quebraTabelaEmbarque?.quebraColunaEmbarque,
				},
			],
			EmpresaSub: [
				{
					nomeColuna: nomeValue.nomeColuna,
					field: "nome",
				},
				{
					nomeColuna: cnpjValue.nomeColuna,
					field: "cnpj",
				},
				{
					nomeColuna: cidadeEmpresaSubValue.nomeColuna,
					field: "cidade",
					objetoUnidadeEmbarque: "true",
				},
				{
					nomeColuna: regimeTributarioValue.nomeColuna,
					field: "regimeTributario",
				},
				{
					nomeColuna: nomeSocialValue.nomeColuna,
					field: "nomeSocial",
				},
				{
					nomeColuna: enderecoEmpresaSubValue.nomeColuna,
					field: "enderecoEmpresaSub",
					objetoEndereco: "true",
				},
			],
			Filial: [
				{
					nomeColuna: filialValue.nomeColuna,
					field: "nome",
				},
				{
					nomeColuna: complementoLocalizacaoValue.nomeColuna,
					field: "complementoLocalizacao",
				},
				{
					nomeColuna: responsavelValue.nomeColuna,
					field: "responsavel",
				},
				{
					nomeColuna: telefoneValue.nomeColuna,
					field: "telefone",
				},
				{
					nomeColuna: emailValue.nomeColuna,
					field: "email",
				},
				{
					nomeColuna: "Cidade/UF",
					field: "cidade",
					objetoUnidadeEmbarque: "true",
				},
			],
			Motivo: [
				{
					nomeColuna: motivoValue?.nomeColuna,
					field: "motivo",
				},
			],
			MeioPagamento: [
				{
					nomeColuna: nomeMeioPagamentoValue.nomeColuna,
					field: "nome",
				},
			],
			Mercadoria: [
				{
					nomeColuna: mercadoriaNomeValue?.nomeColuna,
					field: "nome",
				},
			],
			Motorista: [
				{
					nomeColuna: nomeMotoristaValue?.nomeColuna,
					field: "nome",
				},
				{
					nomeColuna: numeroDocumentoValue?.nomeColuna,
					field: "numeroDocumento",
				},
				{
					nomeColuna: tipoDocumentoValue?.nomeColuna,
					field: "tipoDocumento",
				},
				{
					nomeColuna: telefoneMotoristaValue?.nomeColuna,
					field: "telefone",
				},
				{
					nomeColuna: nomeEmergenciaValue?.nomeColuna,
					field: "nomeEmergencia",
				},
				{
					nomeColuna: telefoneEmergenciaValue?.nomeColuna,
					field: "telefoneEmergencia",
				},

				{
					nomeColuna: enderecoMotoristaValue?.nomeColuna,
					field: "endereco",
					objetoEndereco: "true",
				},
				{
					nomeColuna: frotaMotoristaValue?.nomeColuna,
					field: "frota",
				},
				{
					nomeColuna: usuarioMotoristaValue?.nomeColuna,
					field: "usuarioClientes",
					objetoUsuarios: "true",
				},
				{
					nomeColuna: bloqueadoValue?.nomeColuna,
					field: "bloqueado",
				},
				{
					nomeColuna: motivoBloqueadoValue?.nomeColuna,
					field: "motivo",
				},
			],
			Notificacao: [
				{
					nomeColuna: tituloNotificaoValue?.nomeColuna,
					field: "titulo",
				},
				{
					nomeColuna: mensagemNotificacaoValue?.nomeColuna,
					field: "mensagem",
				},
				{
					nomeColuna: acaoNotificacaoValue?.nomeColuna,
					field: "acao",
				},
				{
					nomeColuna: numeroVisualizacoesNotificacaoValue?.nomeColuna,
					field: "numeroVisualizacoes",
				},
				{
					nomeColuna: dataNotificacaoValue?.nomeColuna,
					field: "data",
				},
			],
			Pedido: [
				{
					nomeColuna: pedidoPValue.nomeColuna,
					field: "pedido",
				},
				{
					nomeColuna: tipoRotaValue.nomeColuna,
					field: "tipoRota",
				},
				{
					nomeColuna: freteFiscalPValue.nomeColuna,
					field: "freteFiscal",
					tipo: "number",
				},
				{
					nomeColuna: icmsPValue.nomeColuna,
					field: "icms",
					tipo: "number",
				},
				{
					nomeColuna: pedagioPValue.nomeColuna,
					field: "pedagio",
					tipo: "number",
				},
				{
					nomeColuna: classificacaoPValue.nomeColuna,
					field: "classificacao",
					tipo: "number",
				},
				{
					nomeColuna: kmPValue.nomeColuna,
					field: "km",
					tipo: "number",
				},
				{
					nomeColuna: clientePValue.nomeColuna,
					field: "cliente",
				},
				{
					nomeColuna: embarcadorPValue.nomeColuna,
					field: "embarcador",
				},
				{
					nomeColuna: destinatarioPValue.nomeColuna,
					field: "destinatario",
				},
				{
					nomeColuna: freteMotoristaPValue.nomeColuna,
					field: "freteMotorista",
					tipo: "number",
				},
				{
					nomeColuna: observacaoPValue.nomeColuna,
					field: "observacao",
				},
				{
					nomeColuna: permiteAlterarFreteFiscalValue.nomeColuna,
					field: "permiteAlterarFreteFiscal ",
				},
				{
					nomeColuna: valorEmbarquePedidoValue?.nomeColuna,
					field: "valorEmbarque",
					objetoValorEmbarque: "true",
				},
				{
					nomeColuna: icmsEmbutido?.nomeColuna,
					field: "icmsEmbutido",
				},
				{
					nomeColuna: icmsEmbarcador?.nomeColuna,
					field: "icmsEmbarcador",
				},
				{
					nomeColuna: freteNormal?.nomeColuna,
					field: "freteNormal",
				},
				{
					quebraColunaPedido: quebraTabelaPedido?.quebraColunaPedido,
				},
			],
			Proprietario: [
				{
					nomeColuna: proprietarioNomeValue?.nomeColuna,
					field: "nome",
				},
				{
					nomeColuna: cnpjProprietarioValue?.nomeColuna,
					field: "cnpj",
				},
				{
					nomeColuna: usuarioProprietarioValue?.nomeColuna,
					field: "usuarioClientes",
					objetoUsuarios: "true",
				},
				{
					nomeColuna: tipoProprietarioValue?.nomeColuna,
					field: "tipoProprietario",
				},
			],
			Rota: [
				{
					nomeColuna: nomeRotaValue.nomeColuna,
					field: "nome",
				},
				{
					nomeColuna: cidadeOrigemRotaValue.nomeColuna,
					field: "cidadeOrigem",
				},
				{
					nomeColuna: estadoOrigemRotaValue.nomeColuna,
					field: "estadoOrigem",
				},
				{
					nomeColuna: cidadeDestinoRotaValue.nomeColuna,
					field: "cidadeDestino",
				},
				{
					nomeColuna: estadoDestinoRotaValue.nomeColuna,
					field: "estadoDestino",
				},
			],
			Solicitacoes: [
				{
					nomeColuna: usuarioSolicitacaoValue?.nomeColuna,
					field: "usuario",
				},
				{
					nomeColuna: emailSolicitacaoValue?.nomeColuna,
					field: "email",
				},
				{
					nomeColuna: telefoneSolicitacaoValue?.nomeColuna,
					field: "telefone",
				},
				{
					nomeColuna: nascimentoSolicitacaoValue?.nomeColuna,
					field: "nascimento",
				},
				{
					nomeColuna: aceitarSolicitacaoValue?.nomeColuna,
					field: "aceitar",
				},
				{
					nomeColuna: recusarSolicitacaoValue?.nomeColuna,
					field: "recusar",
				},
			],
			Status: [
				{
					nomeColuna: nomeStatusValue.nomeColuna,
					field: "nome",
				},
			],
			TaxaIcms: [
				{
					nomeColuna: taxaIcmsValue?.nomeColuna,
					field: "taxa",
					tipo: "number",
				},
				{
					nomeColuna: ufOrigemTaxaValue?.nomeColuna,
					field: "ufOrigem",
				},
				{
					nomeColuna: ufDestinoTaxaValue?.nomeColuna,
					field: "ufDestino",
				},
			],
			UnidadeEmbarque: [
				{
					nomeColuna: nomeUnidadeEmbarqueValue.nomeColuna,
					field: "nome",
				},
				{
					nomeColuna: cidadeUnidadeEmbarqueValue.nomeColuna,
					field: "usuario",
					objetoUnidadeEmbarque: "true",
				},
				{
					nomeColuna: frotaUnidadeEmbarqueValue?.nomeColuna,
					field: "frota",
				},
			],
			UsuarioGeren: [
				{
					nomeColuna: nomeUsuarioGerenValue.nomeColuna,
					field: "usuario",
				},
				{
					nomeColuna: senhaUsuarioGerenValue.nomeColuna,
					field: "",
				},
				{
					nomeColuna: emailUsuarioGerenValue.nomeColuna,
					field: "email",
				},
				{
					nomeColuna: telefoneUsuarioGerenValue.nomeColuna,
					field: "telefone",
				},
				{
					nomeColuna: cargoUsuarioGerenValue.nomeColuna,
					field: "cargo",
				},
				{
					nomeColuna: nascimentoUsuarioGerenValue.nomeColuna,
					field: "nascimento",
				},
				{
					nomeColuna: permissoesUsuarioGerenValue.nomeColuna,
					field: "permissoes",
				},
				{
					nomeColuna: ultimoLoginValue?.nomeColuna,
					field: "ultimoLogin",
				},
				{
					nomeColuna: ultimoLogoutValue?.nomeColuna,
					field: "ultimoLogout",
				},
			],
			Veiculo: [
				{
					nomeColuna: placaCavaloVeiculoValue.nomeColuna,
					field: "placaCavalo",
				},
				{
					nomeColuna: placaCarretaVeiculoValue.nomeColuna,
					field: "placaCarreta",
				},
				{
					nomeColuna: placaCarreta2VeiculoValue.nomeColuna,
					field: "placaCarreta2",
				},
				{
					nomeColuna: proprietarioVeiculoValue.nomeColuna,
					field: "proprietario",
				},
				{
					nomeColuna: motoristaVeiculoValue.nomeColuna,
					field: "motorista",
				},
				{
					nomeColuna: motorista2VeiculoValue.nomeColuna,
					field: "motorista2",
				},
				{
					nomeColuna: eixosValue?.nomeColuna,
					field: "numeroEixos",
				},
				{
					nomeColuna: tipoVeiculoValue?.nomeColuna,
					field: "tipoVeiculo",
				},
				{
					nomeColuna: tipoCarroceriaValue?.nomeColuna,
					field: "tipoCarroceria",
					objetoTipoCarroceria: "true",
				},
				{
					nomeColuna: tipoVeiculoConjuntosValue?.nomeColuna,
					field: "tipoVeiculoConjuntos",
					objetoTipoVeiculo: "true",
				},
				{
					nomeColuna: ativoDiariaValue?.nomeColuna,
					field: "ativoDiaria",
				},
				{
					nomeColuna: elegivelBrfValue?.nomeColuna,
					field: "elegivelBrf",
				},
				{
					nomeColuna: cidadeEstadoConjuntoValue?.nomeColuna,
					field: "cidadeEstado",
					objetoCidadeEstado: "true",
				},
				{
					nomeColuna: dataAtualizacaoLocalizacaoValue?.nomeColuna,
					field: "dataAtualizacaoLocalizacao",
				},
				{
					nomeColuna: agregadoValue?.nomeColuna,
					field: "agregado",
				},
				{
					nomeColuna: telemetriaValue?.nomeColuna,
					field: "telemetria",
				},
			],
			Caminhao: [
				{
					nomeColuna: placaCaminhaoValue.nomeColuna,
					field: "placa",
				},
				{
					nomeColuna: anoCaminhaoValue.nomeColuna,
					field: "ano",
				},
				{
					nomeColuna: renavamCaminhaoValue.nomeColuna,
					field: "renavam",
				},
				{
					nomeColuna: marcaCaminhaoValue.nomeColuna,
					field: "marca",
				},
				{
					nomeColuna: modeloCaminhaoValue.nomeColuna,
					field: "modelo",
				},
				{
					nomeColuna: frotaCaminhaoValue.nomeColuna,
					field: "frota",
				},
				{
					nomeColuna: kmCaminhaoValue?.nomeColuna,
					field: "km",
				},
				{
					nomeColuna: eixosCaminhaoValue?.nomeColuna,
					field: "numeroEixos",
				},
			],
			Carreta: [
				{
					nomeColuna: placaCarretaCaminhaoValue.nomeColuna,
					field: "placa",
				},
				{
					nomeColuna: anoCarretaCaminhaoValue.nomeColuna,
					field: "ano",
				},
				{
					nomeColuna: renavamCarretaCaminhaoValue.nomeColuna,
					field: "renavam",
				},
				{
					nomeColuna: marcaCarretaCaminhaoValue.nomeColuna,
					field: "marca",
				},
				{
					nomeColuna: modeloCarretaCaminhaoValue.nomeColuna,
					field: "modelo",
				},
				{
					nomeColuna: frotaCarretaValue.nomeColuna,
					field: "frota",
				},
				{
					nomeColuna: kmCarretaValue?.nomeColuna,
					field: "km",
				},
				{
					nomeColuna: eixosCarretaValue?.nomeColuna,
					field: "numeroEixos",
				},
			],
			Avisos: [
				{
					nomeColuna: mensagemAvisoValue?.nomeColuna,
					field: "mensagem",
				},
				{
					nomeColuna: dataAvisoValue?.nomeColuna,
					field: "data",
				},
			],
			TipoCheckagem: [
				{
					nomeColuna: nomeTipoCheckagemValue?.nomeColuna,
					field: "nome",
				},
				{
					nomeColuna: notificarAutomaticoValue?.nomeColuna,
					field: "notificarAutomatico",
				},
				{
					nomeColuna: tipoNotificacaoValue?.nomeColuna,
					field: "tipoNotificacao",
				},
				{
					nomeColuna: notificarACadaDataValue?.nomeColuna,
					field: "notificarACadaData",
				},
				{
					nomeColuna: notificarACadaKmValue?.nomeColuna,
					field: "notificarACadaKm",
				},
			],
			Checkagem: [
				{
					nomeColuna: dadosCheckagemValue?.nomeColuna,
					field: "dados",
				},
				{
					nomeColuna: dataCheckagemValue?.nomeColuna,
					field: "dataCheckagem",
				},
				{
					nomeColuna: observacaoCheckagemValue?.nomeColuna,
					field: "observacao",
				},
				{
					nomeColuna: kmCheckagemValue?.nomeColuna,
					field: "km",
				},
				{
					nomeColuna: localCheckagemValue?.nomeColuna,
					field: "local",
				},
				{
					nomeColuna: tipoManutencaoCheckagemValue?.nomeColuna,
					field: "tipoManutencao",
				},
				{
					nomeColuna: proximaRevisaoDataValue?.nomeColuna,
					field: "proximaRevisaoData",
				},
				{
					nomeColuna: proximaRevisaoKMValue?.nomeColuna,
					field: "proximaRevisaoKm",
				},
				{
					nomeColuna: tipoCheckValue?.nomeColuna,
					field: "tipoCheck",
				},
			],
			TipoRastreamento: [
				{
					nomeColuna: nomeTipoRastreamentoValue?.nomeColuna,
					field: "nome",
				},
				{
					nomeColuna: ipValue?.nomeColuna,
					field: "ip",
				},
			],
			Rastreamento: [
				{
					nomeColuna: usuarioRastreamentoValue?.nomeColuna,
					field: "usuarioRastreamento",
				},
				{
					nomeColuna: senhaRastreamentoValue?.nomeColuna,
					field: "senha",
				},
				{
					nomeColuna: tipoVeiculoRastreamentoValue?.nomeColuna,
					field: "tipoVeiculo",
				},
				{
					nomeColuna: tipoRastreamentoValue?.nomeColuna,
					field: "tipoRastreamento",
					objetoRastreamento: "true",
				},
				{
					nomeColuna: veiculoRastreamentoValue?.nomeColuna,
					field1: "carreta",
					field2: "caminhao",
					objetoVeiculo: "true",
				},
				{
					nomeColuna: fabricanteRastreamentoValue?.nomeColuna,
					field: "fabricanteRastreamento",
				},
				{
					nomeColuna: numeroRastreadorValue?.nomeColuna,
					field: "numeroRastreador",
				},
			],
			GrupoClientes: [
				{
					nomeColuna: nomeGrupoClienteValue?.nomeColuna,
					field: "nome",
				},
			],
			Cockpit: [
				{
					nomeColuna: projetadoValue?.nomeColuna,
					field: "projetado",
				},
				{
					nomeColuna: estadoOrigemCockpitValue?.nomeColuna,
					field: "estadoOrigem",
				},
				{
					nomeColuna: estadoDestinoCockpitValue?.nomeColuna,
					field: "estadoDestino",
				},
				{
					nomeColuna: grupoClienteCockpitValue?.nomeColuna,
					field: "grupoCliente",
					objetoGrupoCliente: "true",
				},
			],
			GrupoComClientes: [
				{
					nomeColuna: clienteVinculoValue?.nomeColuna,
					field: "cliente",
					objetoCliente: "true",
				},
				{
					nomeColuna: grupoClienteVinculoValue?.nomeColuna,
					field: "grupoCliente",
					objetoGrupoCliente: "true",
				},
			],
			GrupoPrecificacao: [
				{
					nomeColuna: grupoPrecificacaoValue?.nomeColuna,
					field: "nome",
				},
			],
			ValorEmbarque: [
				{
					nomeColuna: eixosValorEmbarqueValue?.nomeColuna,
					field: "eixos",
				},
				{
					nomeColuna: kmValorEmbarqueValue?.nomeColuna,
					field: "km",
				},
				{
					nomeColuna: valorEixoValorEmbarqueValue?.nomeColuna,
					field: "valorEixo",
				},
				{
					nomeColuna: adicionalCargaDescargaValorEmbarqueValue?.nomeColuna,
					field: "adicionalCargaDescarga",
				},
				{
					nomeColuna: motoristaValorEmbarqueValue?.nomeColuna,
					field: "motorista",
				},
				{
					nomeColuna: empresaValorEmbarqueValue?.nomeColuna,
					field: "empresa",
				},
				{
					nomeColuna: icmsValorEmbarqueValue?.nomeColuna,
					field: "icms",
				},
				{
					nomeColuna: descargaValorEmbarqueValue?.nomeColuna,
					field: "descarga",
				},
				{
					nomeColuna: pedagioValorEmbarqueValue?.nomeColuna,
					field: "pedagio",
				},
				{
					nomeColuna: freteFiscalValorEmbarqueValue?.nomeColuna,
					field: "freteFiscal",
				},
				{
					nomeColuna: rotaValorEmbarqueValue?.nomeColuna,
					field: "rota",
					objetoRota: "true",
				},
				{
					nomeColuna: clienteValorEmbarqueValue?.nomeColuna,
					field: "cliente",
					objetoCliente: "true",
				},
				{
					nomeColuna: grupoPrecificacaoValorEmbarqueValue?.nomeColuna,
					field: "grupoPrecificacao",
					objetoGrupoPrecificacao: "true",
				},
			],
			MotivoOnTime: [
				{
					nomeColuna: motivoOnTimeValue?.nomeColuna,
					field: "motivo",
				},
			],
			GrupoCarga: [
				{
					nomeColuna: grupoCargaValue?.nomeColuna,
					field: "nomeGrupo",
				},
			],
			GrupoCargaVinculo: [
				{
					nomeColuna: grupoCargaValue?.nomeColuna,
					field: "grupoCarga",
					objetoGrupoCarga: "true",
				},
				{
					nomeColuna: motoristaGrupoCargaVinculoVinculoValue?.nomeColuna,
					field: "motorista",
					objetoMotorista: "true",
				},
				{
					nomeColuna: proprietarioGrupoCargaVinculoVinculoValue?.nomeColuna,
					field: "proprietario",
					objetoProprietario: "true",
				},
			],
			Cotacao: [
				{
					nomeColuna: unidadeEmbarqueCotacaoValue?.nomeColuna,
					field: "unidadeEmbarque",
					objetoUnidadeEmbarqueNome: "true",
				},
				{
					nomeColuna: rotaCotacaoValue?.nomeColuna,
					field: "rota",
					objetoRota: "true",
				},
				{
					nomeColuna: clienteCotacaoValue?.nomeColuna,
					field: "cliente",
					objetoCliente: "true",
				},
				{
					nomeColuna: valorCotacaoValue?.nomeColuna,
					field: "valor",
				},
				{
					nomeColuna: icmsCotacaoValue?.nomeColuna,
					field: "icms",
				},
				{
					nomeColuna: pedagioCotacaoValue?.nomeColuna,
					field: "pedagio",
				},
				{
					nomeColuna: distanciaKmCotacaoValue?.nomeColuna,
					field: "distanciaKm",
				},
				{
					nomeColuna: valorPorKmCotacaoValue?.nomeColuna,
					field: "valorPorKm",
				},
				{
					nomeColuna: valorDesejavelMotoristaCotacaoValue?.nomeColuna,
					field: "valorDesejavelMotorista",
				},
				{
					nomeColuna: descricaoRotaCotacaoValue?.nomeColuna,
					field: "descricaoRota",
				},
				{
					nomeColuna: foiCarregadoCotacaoValue?.nomeColuna,
					field: "foiCarregado",
				},
				{
					nomeColuna: tipoVeiculoCotacaoValue?.nomeColuna,
					field: "tipoVeiculo",
					objetoTipoVeiculo: "true",
				},
				{
					nomeColuna: tipoCarroceriaCotacaoValue?.nomeColuna,
					field: "cotacaoCarroceria",
					objetoTipoCarroceria: "true",
				},
				{
					nomeColuna: segmentoCliente?.nomeColuna,
					field: "segmentoCliente",
					objetoSegmentoCliente: "true",
				},
				{
					nomeColuna: motivoCotacaoValue?.nomeColuna,
					field: "motivoCotacao",
					objetoMotivo: "true",
				},
				{
					nomeColuna: dataCotacaoValue?.nomeColuna,
					field: "dataCotacao",
				},
				{
					nomeColuna: usuarioResponsavelCotacaoValue?.nomeColuna,
					field: "usuarioResponsavel",
				},
				{
					nomeColuna: nomeContatoCotacaoValue?.nomeColuna,
					field: "nomeContato",
				},
				{
					nomeColuna: telefoneContatoCotacaoValue?.nomeColuna,
					field: "telefoneContato",
				},
				{
					nomeColuna: emailContatoCotacaoValue?.nomeColuna,
					field: "emailContato",
				},
				{
					nomeColuna: observacaoCotacaoValue?.nomeColuna,
					field: "observacao",
				},
			],
			TipoVeiculo: [
				{
					nomeColuna: nomeTipoVeiculo?.nomeColuna,
					field: "nome",
				},
			],
			TipoCarroceria: [
				{
					nomeColuna: nomeTipoCarroceria?.nomeColuna,
					field: "nome",
				},
			],
			MotivoCotacao: [
				{
					nomeColuna: motivoCotacaoValue?.nomeColuna,
					field: "motivo",
				},
			],
			SegmentoCliente: [
				{
					nomeColuna: segmentoClienteValue?.nomeColuna,
					field: "nome",
				},
			],
			Ocorrencia: [
				{
					nomeColuna: ocorrenciaValue?.nomeColuna,
					field: "tipo",
				},
			],
			TipoOcorrencia: [
				{
					nomeColuna: tipoOcorrenciaValue?.nomeColuna,
					field: "nome",
				},
			],
			SubTipoOcorrencia: [
				{
					nomeColuna: subTipoOcorrenciaValue?.nomeColuna,
					field: "nome",
				},
				{
					nomeColuna: tipoOcorrenciaSubValue?.nomeColuna,
					field: "tipoOcorrencia",
					objetoTipoOcorrencia: "true",
				},
			],
			OcorrenciaEmbarque: [
				{
					nomeColuna: " Ocorrência",
					field: "ocorrencia",
				},
				{
					nomeColuna: "Sub Tipo Ocorrência",
					field: "tipoOcorrencia",
				},
				{
					nomeColuna: "Data Ocorrência",
					field: "dataOcorrencia",
				},
				{
					nomeColuna: "Observação",
					field: "observacao",
				},
			],
			Filiais: [
				{
					nomeColuna: "Nome",
					field: "nomeFilial",
				},
				{
					nomeColuna: "Sábado Dia Útil",
					field: "sabadoDiaUtil",
				},
			],
			Sorteio: [
				{
					nomeColuna: nomeSorteioValue?.nomeColuna,
					field: "nome",
				},
				{
					nomeColuna: apenasCpfValue?.nomeColuna,
					field: "apenasCpf",
				},
				{
					nomeColuna: cupomsValue?.nomeColuna,
					field: "cupoms",
				},
				{
					nomeColuna: cuponsPorViagem?.nomeColuna,
					field: "cuponsPorViagem",
				},
				{
					nomeColuna: dataSorteioValue?.nomeColuna,
					field: "dataSorteio",
				},
				{
					nomeColuna: encerradoValue?.nomeColuna,
					field: "encerrado",
				},
				{
					nomeColuna: fimBuscaValue?.nomeColuna,
					field: "fimBusca",
				},
				{
					nomeColuna: inicioBuscaValue?.nomeColuna,
					field: "inicioBusca",
				},
				{
					nomeColuna: motoristasValue?.nomeColuna,
					field: "motoristas",
				},
				{
					nomeColuna: numerosKmPorCupomValue?.nomeColuna,
					field: "numerosKmPorCupom",
				},
				{
					nomeColuna: proprietariosValue?.nomeColuna,
					field: "proprietarios",
				},
				{
					nomeColuna: sorteadosValue?.nomeColuna,
					field: "sorteados",
				},
			],
			ConfiguracaoEmpresa: [
				{
					nomeColuna: tempoDiariaMinutosValue?.nomeColuna,
					field: "tempoDiariaMinutos",
				},
				{
					nomeColuna: grupoClienteDiariaValue?.nomeColuna,
					field: "grupoCliente",
					objetoGrupoCliente: "true",
				},
				{
					nomeColuna: diariaEmbarqueValue?.nomeColuna,
					field: "diariaEmbarque",
				},
				{
					nomeColuna: diariaEntregaValue?.nomeColuna,
					field: "diariaEntrega",
				},
				{
					nomeColuna: somaDiariasValue?.nomeColuna,
					field: "somaDiarias",
				},
			],
			Documentacao: [
				{
					nomeColuna: placaDocumentacaoValue?.nomeColuna,
					field: "placa",
					objetoDocumentacao1: "true",
				},
				{
					nomeColuna: proprietarioDocumentacaoValue?.nomeColuna,
					field: "proprietario",
					objetoDocumentacao2: "true",
				},
				{
					nomeColuna: motoristaValue?.nomeColuna,
					field: "motorista",
					objetoDocumentacao3: "true",
				},
			],
			TipoDocumento: [
				{
					nomeColuna: nomeTipoDocValue?.nomeColuna,
					field: "nome",
				},
				{
					nomeColuna: tipoDocValue?.nomeColuna,
					field: "tipoDocumentoEnum",
					objetoTipoDocumento: "true",
				},
			],
			TipoContato: [
				{
					nomeColuna: contatoValue?.nomeColuna,
					field: "contato",
				},
				{
					nomeColuna: tipoContatoValue?.nomeColuna,
					field: "tipoContatoEnum",
					objetoTipoContato: "true",
				},
				{
					nomeColuna: proprietarioContatoValue?.nomeColuna,
					field: "proprietario",
					objetoProprietario: "true",
				},
				{
					nomeColuna: motoristaContatoValue?.nomeColuna,
					field: "motorista",
					objetoMotorista: "true",
				},
				{
					nomeColuna: nomeContatoValue?.nomeColuna,
					field: "nome",
				},
				{
					nomeColuna: observacaoContatoValue?.nomeColuna,
					field: "observacao",
				},
			],
			TipoObservacao: [
				{
					nomeColuna: tipoObservacaoValue?.nomeColuna,
					field: "observacao",
				},
			],
			StatusDiaria: [
				{
					nomeColuna: statusDiariaValue?.nomeColuna,
					field: "status",
				},
			],
			Estadia: [
				{
					nomeColuna: "Load",
					field: "load",
					objetoEmb: "true",
				},
				{
					nomeColuna: "Data/Hora Chegada",
					field: "dataHoraChegadaEmbarque",
					objetoEmb: "true",
				},
				{
					nomeColuna: "Data/Hora Saida",
					field: "dataHoraEmbarcado",
					objetoEmb: "true",
				},
				{
					nomeColuna: "Data/Hora Agendamento",
					field: "dataHoraEntregue",
					objetoEmb: "true",
				},
				{
					nomeColuna: "Placa",
					field: "veiculoEmbarque",
					objetoEmb: "true",
				},
				{
					nomeColuna: "Cliente",
					field: "cliente",
					objetoEmb: "true",
				},
				{
					nomeColuna: "Unidade de Embarque",
					field: "unidEmbarque",
					objetoEmb: "true",
				},
				{
					nomeColuna: "Status Diária",
					field: "statusEmbarque",
					objetoEmb: "true",
				},
				{
					nomeColuna: "CTE",
					field: "cte",
					objetoEmb: "true",
				},
				{
					nomeColuna: statusDiariaEstadiaValue?.nomeColuna,
					field: "statusDiariaId",
					objetoStatus: "true",
				},
				{
					nomeColuna: motivoEstadiaEstadiaValue?.nomeColuna,
					field: "motivoEstadiaId",
					objetoMotivo: "true",
				},
				{
					nomeColuna: tipoVeiculoEstadiaValue?.nomeColuna,
					field: "tipoVeiculoId",
					objetoTipoVeiculo: "true",
				},
				{
					nomeColuna: dasteEstadiaValue?.nomeColuna,
					field: "daste",
				},
				{
					nomeColuna: observacaoEstadiaValue?.nomeColuna,
					field: "observacao",
				},
				{
					nomeColuna: cteComplementarEstadiaValue?.nomeColuna,
					field: "cteComplementar",
				},
				{
					nomeColuna: tipoEstadiaEstadiaValue?.nomeColuna,
					field: "tipoEstadia",
				},
				{
					nomeColuna: freteEmpresaEstadiaValue?.nomeColuna,
					field: "freteEmpresa",
				},
				{
					nomeColuna: freteMotoristaEstadiaValue?.nomeColuna,
					field: "freteMotorista",
				},
			],
			MotivoEstadia: [
				{
					nomeColuna: motivoEstadiaValue?.nomeColuna,
					field: "motivo",
				},
			],
			Opcoes: [
				{
					opcao: "Sim",
				},
				{
					opcao: "Não",
				},
			],
			Contexto: [
				{
					nome: "Toledo",
				},
				{
					nome: "Glória de Dourados",
				},
				{
					nome: "Paranavaí",
				},
				{
					nome: "Rio Verde",
				},
			],
			DivergenciasSAT: [
				{
					nomeColuna: cteDivergenciasValue?.nomeColuna,
					field: "cte",
				},
				{
					nomeColuna: freteMotoristaGerenciadorDivergenciasValue?.nomeColuna,
					field: "freteMotoristaGerenciador",
					diferencaoFreteFiscal: false,
				},
				{
					nomeColuna: freteMotoristaSatDivergenciasValue?.nomeColuna,
					field: "freteMotoristaSat",
					diferencaoFreteFiscal: false,
				},
				{
					nomeColuna: freteFiscalGerenciadorDivergenciasValue?.nomeColuna,
					field: "freteFiscalGerenciador",
					diferencaoFreteFiscal: false,
				},
				{
					nomeColuna: freteFiscalSatDivergenciasValue?.nomeColuna,
					field: "freteFiscalSat",
					diferencaoFreteFiscal: false,
				},
				{
					nomeColuna: pedagioGerenciadorDivergenciasValue?.nomeColuna,
					field: "pedagioGerenciador",
					diferencaoFreteFiscal: false,
				},
				{
					nomeColuna: pedagioSatDivergenciasValue?.nomeColuna,
					field: "pedagioSat",
					diferencaoFreteFiscal: false,
				},
				{
					nomeColuna: icmsGerenciadorDivergenciasValue?.nomeColuna,
					field: "icmsGerenciador",
					diferencaoFreteFiscal: false,
				},
				{
					nomeColuna: icmsSatDivergenciasValue?.nomeColuna,
					field: "icmsSat",
					diferencaoFreteFiscal: false,
				},
				{
					nomeColuna:
						usuarioResponsavelGerenciadorDivergenciasValue?.nomeColuna,
					field: "usuarioResponsavel",
					diferencaoFreteFiscal: false,
				},
				{
					nomeColuna: temDiferencaDivergenciasValue?.nomeColuna,
					field: "temDiferenca",
					diferencaoFreteFiscal: false,
				},
				{
					nomeColuna: dataUltimaVerificacaoDivergenciasValue?.nomeColuna,
					field: "dataUltimaVerificacao",
					diferencaoFreteFiscal: false,
				},
			],
		};
	};

	const setaTabelaEmpresa = useCallback(async () => {
		setTabelaEmpresa(valorInicial());
		const objeto = {
			tenant: profile?.tenant,
			cores: JSON.stringify(coresEmpresa).replace(/"/g, `'`),
			colunas: JSON.stringify(valorInicial()).replace(/"/g, `'`),
		};
		await editaEmpresa(profile?.token, objeto)
			.then((result) => {
				if (result.status === 200) {
					if (!jaPassou) {
						setOpen(true);
					}
					setJaPassou(true);
					setTextoSucesso("Configurações Atualizadas com Sucesso!");
					setOpenToastSucesso(true);
				}
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
				}
			});
	}, [profile?.token, jaPassou]);

	const cadastrar = async () => {
		if (!profile) return;

		setLoading(true);

		const camposFormatados = JSON.stringify(valorInicialVisivel()).replace(
			/"/g,
			`'`
		);
		const usuarioTabela = {
			usuarioGerenId: profile?.usuario.idUsuario,
			campoVisiveis: camposFormatados,
		};
		await editaUsuarioTabelaPorId(usuarioTabela, profile?.token)
			.then((result) => {
				setDadosMenusRedux(valorInicialVisivel());
				setTabelaUsuario(valorInicialVisivel());
				setTextoSucesso("Sucesso");
				setTextoSucesso("Configurações Atualizadas com Sucesso!");
				setOpenToastSucesso(true);
				setaTabelaEmpresa();
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
				}
			});
		setLoading(false);
	};

	const [semAutorizacao, setSemAutorizacao] = useState(false);

	useEffect(() => {
		if (!profile?.usuario?.idUsuario) return;
		setSemAutorizacao(!hasRegra("Configuracoes"));
	}, [profile]);

	const closeDialog = () => {
		setShowCidadeEstado(false);
		setShowNotificacao(false);
		setShowMercadoria(false);
		setShowTaxaIcms(false);
		setShowEmbalagem(false);
		setShowEmbarcador(false);
		setShowEmbarque(false);
		setShowEmpresaSub(false);
		setShowFilial(false);
		setShowMeioPagamento(false);
		setShowMotorista(false);
		setShowPedido(false);
		setShowRota(false);
		setShowStatus(false);
		setShowUnidadeEmbarque(false);
		setShowUsuarioGeren(false);
		setShowVeiculo(false);
		setShowProprietario(false);
		setShowCotacao(false);
		setShowSolicitacao(false);
        setShowDivergenciasSat(false);
		setShowMotivo(false);
		setShowCaminhao(false);
		setShowCarreta(false);
		setShowAvisos(false);
		setShowTipoCheckagem(false);
		setShowCheckagem(false);
		setShowTipoRastreamento(false);
		setShowRastreamento(false);
		setShowGrupoClientes(false);
		setShowCockpit(false);
		setShowGrupoComClientes(false);
		setShowGrupoPrecificacao(false);
		setShowValorEmbarque(false);
		setShowMotivoOnTime(false);
		setShowGrupoCarga(false);
		setShowGrupoCargaVinculo(false);
		setShowCotacao(false);
		setShowTipoVeiculo(false);
		setShowTipoCarroceria(false);
		setShowMotivoCotacao(false);
		setShowSegmentoCliente(false);
		setShowOcorrencia(false);
		setShowTipoOcorrencia(false);
		setShowSubTipoOcorrencia(false);
		setShowSorteio(false);
		setShowConfiguracaoEmpresa(false);
		setShowDocumentacao(false);
		setShowTipoDocumento(false);
		setShowTipoContato(false);
		setShowTipoObservacao(false);
		setShowStatusDiaria(false);
		setShowMotivoEstadia(false);
		setShowEstadia(false);
	};

	if (semAutorizacao) {
		return <MotionSemAutorizacao />;
	}

	return (
		<motion.div
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
		>
			<NavbarV3 title="Colunas" />
			<div className="corpo-colunas">
				{/* Informações Gerais */}
				<CategoriaContainer titulo="Informações Gerais">
					<div className="corpo-cores">
						<CustomButton
							classCss="custom-button-giant"
							titulo="Cidade/Estado"
							cor={coresEmpresa.botaoPadrao}
							corTexto={coresEmpresa.textoBotaoPadrao}
							onClick={() => {
								setShowCidadeEstado(true);
							}}
						/>
					</div>
					{showCidadeEstado && (
						<div className="dialog-overlay" onClick={() => closeDialog()}>
							<div
								className="dialog-content"
								onClick={(e) => e.stopPropagation()}
							>
								<button className="botao-fechar" onClick={() => closeDialog()}>
									×
								</button>
								<h1>Cidade/Estado</h1>
								<div className="grid-container-coluna-empresa">
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Cidade" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setCidadeValue({
													nomeColuna: e.target.value,
													field: "cidade",
												});
											}}
											value={cidadeValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Estado" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setEstadoValue({
													nomeColuna: e.target.value,
													field: "estado",
												});
											}}
											value={estadoValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Abreviação" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setAbreviacaoValue({
													nomeColuna: e.target.value,
													field: "abreviacao",
												});
											}}
											value={abreviacaoValue.nomeColuna}
										/>
									</div>
								</div>
							</div>
						</div>
					)}
					<div className="corpo-cores">
						<CustomButton
							classCss="custom-button-giant"
							titulo="Embalagem"
							cor={coresEmpresa.botaoPadrao}
							corTexto={coresEmpresa.textoBotaoPadrao}
							onClick={() => {
								setShowEmbalagem((showEmbalagem) => !showEmbalagem);
							}}
						/>
					</div>
					{showEmbalagem && (
						<div className="dialog-overlay" onClick={() => closeDialog()}>
							<div
								className="dialog-content"
								onClick={(e) => e.stopPropagation()}
							>
								<button className="botao-fechar" onClick={() => closeDialog()}>
									×
								</button>
								<h1>Embalagem</h1>
								<div className="grid-container-coluna-embalagem">
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Embalagem" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setEmbalagemValue({
													nomeColuna: e.target.value,
													field: "nome",
												});
											}}
											value={embalagemValue.nomeColuna}
										/>
									</div>
								</div>
							</div>
						</div>
					)}
					<div className="corpo-cores">
						<CustomButton
							classCss="custom-button-giant"
							titulo="Mercadoria"
							cor={coresEmpresa.botaoPadrao}
							corTexto={coresEmpresa.textoBotaoPadrao}
							onClick={() => {
								setShowMercadoria((showMercadoria) => !showMercadoria);
							}}
						/>
					</div>
					{showMercadoria && (
						<div className="dialog-overlay" onClick={() => closeDialog()}>
							<div
								className="dialog-content"
								onClick={(e) => e.stopPropagation()}
							>
								<button className="botao-fechar" onClick={() => closeDialog()}>
									×
								</button>
								<h1>Mercadoria</h1>
								<div className="grid-container-coluna-embalagem">
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Mercadoria" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setMercadoriaNomeValue({
													nomeColuna: e.target.value,
													field: "nome",
												});
											}}
											value={mercadoriaNomeValue.nomeColuna}
										/>
									</div>
								</div>
							</div>
						</div>
					)}
					<div className="corpo-cores">
						<CustomButton
							classCss="custom-button-giant"
							titulo="Status"
							cor={coresEmpresa.botaoPadrao}
							corTexto={coresEmpresa.textoBotaoPadrao}
							onClick={() => {
								setShowStatus((showStatus) => !showStatus);
							}}
						/>
					</div>
					{showStatus && (
						<div className="dialog-overlay" onClick={() => closeDialog()}>
							<div
								className="dialog-content"
								onClick={(e) => e.stopPropagation()}
							>
								<button className="botao-fechar" onClick={() => closeDialog()}>
									×
								</button>
								<h1>Status</h1>
								<div className="grid-container-coluna-embalagem">
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Status" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setNomeStatusValue({
													nomeColuna: e.target.value,
													field: "nome",
												});
											}}
											value={nomeStatusValue.nomeColuna}
										/>
									</div>
								</div>
							</div>
						</div>
					)}
					<div className="corpo-cores">
						<CustomButton
							classCss="custom-button-giant"
							titulo="Motivo"
							cor={coresEmpresa.botaoPadrao}
							corTexto={coresEmpresa.textoBotaoPadrao}
							onClick={() => {
								setShowMotivo((showMotivo) => !showMotivo);
							}}
						/>
					</div>
					{showMotivo && (
						<div className="dialog-overlay" onClick={() => closeDialog()}>
							<div
								className="dialog-content"
								onClick={(e) => e.stopPropagation()}
							>
								<button className="botao-fechar" onClick={() => closeDialog()}>
									×
								</button>
								<h1>Motivo</h1>
								<div className="grid-container-coluna-cidade">
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="motivo">
											<Text texto="Motivo" />
										</InputLabel>
										<input
											type="text"
											id="motivo"
											className="input-text"
											onChange={(e) => {
												setMotivoValues({
													nomeColuna: e.target.value,
													field: "motivo",
												});
											}}
											value={motivoValue?.nomeColuna}
										/>
									</div>
								</div>
							</div>
						</div>
					)}
					<div className="corpo-cores">
						<CustomButton
							classCss="custom-button-giant"
							titulo="Meio Pagamento"
							cor={coresEmpresa.botaoPadrao}
							corTexto={coresEmpresa.textoBotaoPadrao}
							onClick={() => {
								setShowMeioPagamento((showMeioPagamento) => !showMeioPagamento);
							}}
						/>
					</div>
					{showMeioPagamento && (
						<div className="dialog-overlay" onClick={() => closeDialog()}>
							<div
								className="dialog-content"
								onClick={(e) => e.stopPropagation()}
							>
								<button className="botao-fechar" onClick={() => closeDialog()}>
									×
								</button>
								<h1>Meio Pagamento</h1>
								<div className="grid-container-coluna-embalagem">
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Meio Pagamento" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setNomeMeioPagamentoValue({
													nomeColuna: e.target.value,
													field: "nome",
												});
											}}
											value={nomeMeioPagamentoValue.nomeColuna}
										/>
									</div>
								</div>
							</div>
						</div>
					)}
				</CategoriaContainer>

				{/* Cadastro de Entidades */}
				<CategoriaContainer titulo="Cadastro de Entidades">
					<div className="corpo-cores">
						<CustomButton
							classCss="custom-button-giant"
							titulo="Clientes"
							cor={coresEmpresa.botaoPadrao}
							corTexto={coresEmpresa.textoBotaoPadrao}
							onClick={() => {
								setShowEmbarcador((showEmbarcador) => !showEmbarcador);
							}}
						/>
					</div>
					{showEmbarcador && (
						<div className="dialog-overlay" onClick={() => closeDialog()}>
							<div
								className="dialog-content"
								onClick={(e) => e.stopPropagation()}
							>
								<button className="botao-fechar" onClick={() => closeDialog()}>
									×
								</button>
								<h1>Clientes</h1>
								<div className="grid-container-coluna-cidade">
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Nome Fantasia" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setNomeFantasiaValue({
													nomeColuna: e.target.value,
													field: "nomeFantasia",
												});
											}}
											value={nomeFantasiaValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Razão Social" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setRazaoSocialValue({
													nomeColuna: e.target.value,
													field: "razaoSocial",
												});
											}}
											value={razaoSocialValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="CNPJ" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setCnpjClienteValue({
													nomeColuna: e.target.value,
													field: "cnpj",
												});
											}}
											value={cnpjClienteValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Endereço" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setEnderecoValue({
													nomeColuna: e.target.value,
													field: "endereco",
												});
											}}
											value={enderecoValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Apelido" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setApelidoValue({
													nomeColuna: e.target.value,
													field: "apelido",
												});
											}}
											value={apelidoValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Frete Fiscal" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setDiFreteFiscalValue({
													nomeColuna: e.target.value,
													field: "diFreteFiscal",
												});
											}}
											value={diFreteFiscalValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Pedágio" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setDiPedagioValue({
													nomeColuna: e.target.value,
													field: "diPedagio",
												});
											}}
											value={diPedagioValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Classificação/Descarga" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setDiClassificacaoValue({
													nomeColuna: e.target.value,
													field: "diClassificacao",
												});
											}}
											value={diClassificacaoValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Tempo Diária" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setTempoDiariaMinutosClientesValue({
													nomeColuna: e.target.value,
													field: "tempoDiariaMinutos",
												});
											}}
											value={tempoDiariaMinutosClienteValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Usuário" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setUsuarioClienteValue({
													nomeColuna: e.target.value,
													field: "usuarioClientes",
													objetoUsuarios: "true",
												});
											}}
											value={usuarioClienteValue?.nomeColuna}
										/>
									</div>
								</div>
							</div>
						</div>
					)}
					<div className="corpo-cores">
						<CustomButton
							classCss="custom-button-giant"
							titulo="Motorista"
							cor={coresEmpresa.botaoPadrao}
							corTexto={coresEmpresa.textoBotaoPadrao}
							onClick={() => {
								setShowMotorista((showMotorista) => !showMotorista);
							}}
						/>
					</div>
					{showMotorista && (
						<div className="dialog-overlay" onClick={() => closeDialog()}>
							<div
								className="dialog-content"
								onClick={(e) => e.stopPropagation()}
							>
								<button className="botao-fechar" onClick={() => closeDialog()}>
									×
								</button>
								<h1>Motorista</h1>
								<div className="grid-container-coluna-motorista">
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Nome" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setNomeMotoristaValue({
													nomeColuna: e.target.value,
													field: "nome",
												});
											}}
											value={nomeMotoristaValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Numero Documento" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setNumeroDocumentoValue({
													nomeColuna: e.target.value,
													field: "numeroDocumento",
												});
											}}
											value={numeroDocumentoValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Tipo Documento" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setTipoDocumentoValue({
													nomeColuna: e.target.value,
													field: "tipoDocumento",
												});
											}}
											value={tipoDocumentoValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Telefone" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setTelefoneMotoristaValue({
													nomeColuna: e.target.value,
													field: "telefone",
												});
											}}
											value={telefoneMotoristaValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Nome Emergência" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setNomeEmergenciaValue({
													nomeColuna: e.target.value,
													field: "nomeEmergencia",
												});
											}}
											value={nomeEmergenciaValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Telefone Emergência" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setTelefoneEmergenciaValue({
													nomeColuna: e.target.value,
													field: "telefoneEmergencia",
												});
											}}
											value={telefoneEmergenciaValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Endereço" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setEnderecoMotoristaValue({
													nomeColuna: e.target.value,
													field: "endereco",
													objetoEndereco: "true",
												});
											}}
											value={enderecoMotoristaValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Frota" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setFrotaMotoristaValue({
													nomeColuna: e.target.value,
													field: "frota",
												});
											}}
											value={frotaMotoristaValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Usuário" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setUsuarioMotoristaValue({
													nomeColuna: e.target.value,
													field: "usuarioClientes",
													objetoUsuarios: "true",
												});
											}}
											value={usuarioMotoristaValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Bloqueado" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setBloqueadoValue({
													nomeColuna: e.target.value,
													field: "bloqueado",
												});
											}}
											value={bloqueadoValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Motivo" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setMotivoBloqueadoValue({
													nomeColuna: e.target.value,
													field: "motivo",
												});
											}}
											value={motivoBloqueadoValue?.nomeColuna}
										/>
									</div>
								</div>
							</div>
						</div>
					)}
					<div className="corpo-cores">
						<CustomButton
							classCss="custom-button-giant"
							titulo="Proprietário"
							cor={coresEmpresa.botaoPadrao}
							corTexto={coresEmpresa.textoBotaoPadrao}
							onClick={() => {
								setShowProprietario((showProprietario) => !showProprietario);
							}}
						/>
					</div>
					{showProprietario && (
						<div className="dialog-overlay" onClick={() => closeDialog()}>
							<div
								className="dialog-content"
								onClick={(e) => e.stopPropagation()}
							>
								<button className="botao-fechar" onClick={() => closeDialog()}>
									×
								</button>
								<h1>Proprietério</h1>
								<div className="grid-container-coluna-cidade">
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Nome" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setProprietarioNomeValue({
													nomeColuna: e.target.value,
													field: "nome",
												});
											}}
											value={proprietarioNomeValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="CPF/CNPJ" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setCnpjProprietarioValue({
													nomeColuna: e.target.value,
													field: "cnpj",
												});
											}}
											value={cnpjProprietarioValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Usuário" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setUsuarioProprietarioValue({
													nomeColuna: e.target.value,
													field: "usuarioClientes",
													objetoUsuarios: "true",
												});
											}}
											value={usuarioProprietarioValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Tipo Proprietário" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setTipoProprietarioValue({
													nomeColuna: e.target.value,
													field: "tipoProprietario",
												});
											}}
											value={tipoProprietarioValue?.nomeColuna}
										/>
									</div>
								</div>
							</div>
						</div>
					)}
					<div className="corpo-cores">
						<CustomButton
							classCss="custom-button-giant"
							titulo="Usuário"
							cor={coresEmpresa.botaoPadrao}
							corTexto={coresEmpresa.textoBotaoPadrao}
							onClick={() => {
								setShowUsuarioGeren((showUsuarioGeren) => !showUsuarioGeren);
							}}
						/>
					</div>
					{showUsuarioGeren && (
						<div className="dialog-overlay" onClick={() => closeDialog()}>
							<div
								className="dialog-content"
								onClick={(e) => e.stopPropagation()}
							>
								<button className="botao-fechar" onClick={() => closeDialog()}>
									×
								</button>
								<h1>Usuário</h1>
								<div className="grid-container-coluna-empresa">
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Usuário" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setNomeUsuarioGerenValue({
													nomeColuna: e.target.value,
													field: "usuario",
												});
											}}
											value={nomeUsuarioGerenValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Senha" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setSenhaUsuarioGerenValue({
													nomeColuna: e.target.value,
													field: "",
												});
											}}
											value={senhaUsuarioGerenValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Email" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setEmailUsuarioGerenValue({
													nomeColuna: e.target.value,
													field: "email",
												});
											}}
											value={emailUsuarioGerenValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Telefone" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setTelefoneUsuarioGerenValue({
													nomeColuna: e.target.value,
													field: "telefone",
												});
											}}
											value={telefoneUsuarioGerenValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Cargo" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setCargoUsuarioGerenValue({
													nomeColuna: e.target.value,
													field: "cargo",
												});
											}}
											value={cargoUsuarioGerenValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Nascimento" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setNascimentoUsuarioGerenValue({
													nomeColuna: e.target.value,
													field: "nascimento",
												});
											}}
											value={nascimentoUsuarioGerenValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Permissões" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setPermissoesUsuarioGerenValue({
													nomeColuna: e.target.value,
													field: "permissoes",
												});
											}}
											value={permissoesUsuarioGerenValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Último Login" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setUltimoLoginValue({
													nomeColuna: e.target.value,
													field: "ultimoLogin",
												});
											}}
											value={ultimoLoginValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Último Logout" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setUltimoLogoutValue({
													nomeColuna: e.target.value,
													field: "ultimoLogout",
												});
											}}
											value={ultimoLogoutValue?.nomeColuna}
										/>
									</div>
								</div>
							</div>
						</div>
					)}
					<div className="corpo-cores">
						<CustomButton
							classCss="custom-button-giant"
							titulo="Empresas Subsidiárias"
							cor={coresEmpresa.botaoPadrao}
							corTexto={coresEmpresa.textoBotaoPadrao}
							onClick={() => {
								setShowEmpresaSub((showEmpresaSub) => !showEmpresaSub);
							}}
						/>
					</div>
					{showEmpresaSub && (
						<div className="dialog-overlay" onClick={() => closeDialog()}>
							<div
								className="dialog-content"
								onClick={(e) => e.stopPropagation()}
							>
								<button className="botao-fechar" onClick={() => closeDialog()}>
									×
								</button>
								<h1>Empresas Subsidiárias</h1>
								<div className="grid-container-coluna-empresa">
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Nome" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setNomeValue({
													nomeColuna: e.target.value,
													field: "nome",
												});
											}}
											value={nomeValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Cnpj" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setCnpjValue({
													nomeColuna: e.target.value,
													field: "cnpj",
												});
											}}
											value={cnpjValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Cidade" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setCidadeEmpresaSubValue({
													nomeColuna: e.target.value,
													field: "cidade",
												});
											}}
											value={cidadeEmpresaSubValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Regime Tributário" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setegimeTributarioValue({
													nomeColuna: e.target.value,
													field: "regimeTributario",
												});
											}}
											value={regimeTributarioValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="nomeSocial">
											<Text texto="Nome Social" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setNomeSocialValue({
													nomeColuna: e.target.value,
													field: "nomeSocial",
												});
											}}
											value={nomeSocialValue?.nomeColuna || ""}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="enderecoEmpresaSub">
											<Text texto="Endereço" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setEnderecoEmpresaSubValue({
													nomeColuna: e.target.value,
													field: "enderecoEmpresaSub",
												});
											}}
											value={enderecoEmpresaSubValue?.nomeColuna || ""}
										/>
									</div>
								</div>
							</div>
						</div>
					)}
					<div className="corpo-cores">
						<CustomButton
							classCss="custom-button-giant"
							titulo="Filial"
							cor={coresEmpresa.botaoPadrao}
							corTexto={coresEmpresa.textoBotaoPadrao}
							onClick={() => {
								setShowFilial((showFilial) => !showFilial);
							}}
						/>
					</div>
					{showFilial && (
						<div className="dialog-overlay" onClick={() => closeDialog()}>
							<div
								className="dialog-content"
								onClick={(e) => e.stopPropagation()}
							>
								<button className="botao-fechar" onClick={() => closeDialog()}>
									×
								</button>
								<h1>Filial</h1>
								<div className="grid-container-coluna-embarque">
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Filial" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setNomeFilialValue({
													nomeColuna: e.target.value,
													field: "nome",
												});
											}}
											value={nomeFiliaValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Complemento Localização" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setComplementoLocalizacaoValue({
													nomeColuna: e.target.value,
													field: "complementoLocalizacao",
												});
											}}
											value={complementoLocalizacaoValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Responsável" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setResponsavelValue({
													nomeColuna: e.target.value,
													field: "responsavel",
												});
											}}
											value={responsavelValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Telefone" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setTelefoneValue({
													nomeColuna: e.target.value,
													field: "telefone",
												});
											}}
											value={telefoneValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Email" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setEmailValue({
													nomeColuna: e.target.value,
													field: "email",
												});
											}}
											value={emailValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="CidadeFilial" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setCidadeFilialValue({
													nomeColuna: e.target.value,
													field: "cidade",
												});
											}}
											value={cidadeFilialValue.nomeColuna}
										/>
									</div>
								</div>
							</div>
						</div>
					)}
				</CategoriaContainer>

				{/* Operações */}
				<CategoriaContainer titulo="Operações">
					<div className="corpo-cores">
						<CustomButton
							classCss="custom-button-giant"
							titulo="Embarque"
							cor={coresEmpresa.botaoPadrao}
							corTexto={coresEmpresa.textoBotaoPadrao}
							onClick={() => {
								setShowEmbarque((showEmbarque) => !showEmbarque);
							}}
						/>
					</div>
					{showEmbarque && (
						<div className="dialog-overlay" onClick={() => closeDialog()}>
							<div
								className="dialog-content"
								onClick={(e) => e.stopPropagation()}
							>
								<button className="botao-fechar" onClick={() => closeDialog()}>
									×
								</button>
								<h1>Embarque</h1>
								<div className="grid-container-coluna-embarque">
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Descrição" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setDescricaoValue({
													nomeColuna: e.target.value,
													field: "descricao",
												});
											}}
											value={descricaoValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Unidade Embarque" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setUnidEmbarqueValue({
													nomeColuna: e.target.value,
													field: "unidEmbarque",
												});
											}}
											value={unidEmbarqueValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Empresa" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setEmpresaValue({
													nomeColuna: e.target.value,
													field: "empresa",
												});
											}}
											value={empresaValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Filial" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setFilialValue({
													nomeColuna: e.target.value,
													field: "filial",
												});
											}}
											value={filialValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Rota" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setRotaEmbarqueValue({
													nomeColuna: e.target.value,
													field: "rota",
												});
											}}
											value={rotaEmbarqueValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Pedido" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setPedidoValue({
													nomeColuna: e.target.value,
													field: "pedido",
												});
											}}
											value={pedidoValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Cte" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setCteValue({
													nomeColuna: e.target.value,
													field: "cte",
												});
											}}
											value={cteValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Previsão Viagem" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setPrevisaoEmbarqueValue({
													nomeColuna: e.target.value,
													field: "previsaoEmbarque",
												});
											}}
											value={previsaoEmbarqueValue.nomeColuna}
										/>
									</div>
									{/* <div className="grid-item-coluna-cidade">
																					<InputLabel htmlFor="cidade"><Text texto="Data de Viagem" /></InputLabel>
																					<input
																							type="text"
																							className="input-text"
																							onChange={(e) => {
																									setDataEmbarqueValue(
																											{
																													nomeColuna: e.target.value,
																													field: 'dataEmbarque',
																											},
																									)
																							}}
																							value={dataEmbarqueValue.nomeColuna}
																					/>
																			</div> */}
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Previsão de Entrega" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setPrevisaoEntregaValue({
													nomeColuna: e.target.value,
													field: "previsaoEntrega",
												});
											}}
											value={previsaoEntregaValue.nomeColuna}
										/>
									</div>
									{/* <div className="grid-item-coluna-cidade">
																					<InputLabel htmlFor="cidade"><Text texto="Data de Entrega" /></InputLabel>
																					<input
																							type="text"
																							className="input-text"
																							onChange={(e) => {
																									setDataEntregaValue(
																											{
																													nomeColuna: e.target.value,
																													field: 'dataEntrega',
																											},
																									)
																							}}
																							value={dataEntregaValue.nomeColuna}
																					/>
																			</div> */}
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Data Hora Chegada Viagem" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setDataHoraChegadaEmbarqueValue({
													nomeColuna: e.target.value,
													field: "dataHoraChegadaEmbarque",
												});
											}}
											value={dataHoraChegadaEmbarqueValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Data Hora Embarcado" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setDataHoraEmbarcadoValue({
													nomeColuna: e.target.value,
													field: "dataHoraEmbarcado",
												});
											}}
											value={dataHoraEmbarcadoValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Data Hora Chegada Entrega" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setDataHoraChegadaEntregaValue({
													nomeColuna: e.target.value,
													field: "dataHoraChegadaEntrega",
												});
											}}
											value={dataHoraChegadaEntregaValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Data Hora Entregue" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setDataHoraEntregueValue({
													nomeColuna: e.target.value,
													field: "dataHoraEntregue",
												});
											}}
											value={dataHoraEntregueValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Aceite" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setAceiteValue({
													nomeColuna: e.target.value,
													field: "aceite",
												});
											}}
											value={aceiteValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Status" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setStatusValue({
													nomeColuna: e.target.value,
													field: "status",
												});
											}}
											value={statusValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Placa Cavalo" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setPlacaCavaloValue({
													nomeColuna: e.target.value,
													field: "placaCavalo",
												});
											}}
											value={placaCavaloValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Placa Carreta" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setPlacaCarretaValue({
													nomeColuna: e.target.value,
													field: "placaCarreta",
												});
											}}
											value={placaCarretaValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Placa Carreta 2" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setPlacaCarreta2Value({
													nomeColuna: e.target.value,
													field: "placaCarreta2",
												});
											}}
											value={placaCarreta2Value.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Proprietário" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setProprietarioValue({
													nomeColuna: e.target.value,
													field: "proprietario",
												});
											}}
											value={proprietarioValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Motorista" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setMotoristaValue({
													nomeColuna: e.target.value,
													field: "veiculoMotorista",
												});
											}}
											value={motoristaValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Frete Fiscal" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setFreteFiscalValue({
													nomeColuna: e.target.value,
													field: "freteFiscal",
													tipo: "number",
												});
											}}
											value={freteFiscalValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="ICMS" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setIcmsValue({
													nomeColuna: e.target.value,
													field: "icms",
													tipo: "number",
												});
											}}
											value={icmsValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Frete Motorista" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setFreteMotoristaValue({
													nomeColuna: e.target.value,
													field: "freteMotorista",
													tipo: "number",
												});
											}}
											value={freteMotoristaValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Adicional Empresa" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setAdicionalEmpresaValue({
													nomeColuna: e.target.value,
													field: "adicionalEmpresa",
													tipo: "number",
												});
											}}
											value={adicionalEmpresaValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Adicional Motorista" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setAdicionalMotoristaValue({
													nomeColuna: e.target.value,
													field: "adicionalMotorista",
													tipo: "number",
												});
											}}
											value={adicionalMotoristaValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Eixos" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setNumeroEixosEmbarqueValue({
													nomeColuna: e.target.value,
													field: "numeroEixos",
													tipo: "number",
												});
											}}
											value={numeroEixosEmbarqueValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Pedagio" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setPedagioValue({
													nomeColuna: e.target.value,
													field: "pedagio",
													tipo: "number",
												});
											}}
											value={pedagioValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Classificação" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setClassificacaoValue({
													nomeColuna: e.target.value,
													field: "classificacao",
													tipo: "number",
												});
											}}
											value={classificacaoValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Margem" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setMargemValue({
													nomeColuna: e.target.value,
													field: "margem",
												});
											}}
											value={margemValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Adiamento" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setAdiamentoValue({
													nomeColuna: e.target.value,
													field: "adiantamento",
													tipo: "number",
												});
											}}
											value={adiantamentoValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Saldo" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setSaldoValue({
													nomeColuna: e.target.value,
													field: "saldo",
													tipo: "number",
												});
											}}
											value={saldoValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Meio Pagamento" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setMeioPagamentoValue({
													nomeColuna: e.target.value,
													field: "meioPagamento",
												});
											}}
											value={meioPagamentoValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Meio Pagamento 2" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setMeioPagamento2Value({
													nomeColuna: e.target.value,
													field: "meioPagamento2",
												});
											}}
											value={meioPagamento2Value.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="KM" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setKmValue({
													nomeColuna: e.target.value,
													field: "km",
													tipo: "number",
												});
											}}
											value={kmValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Cliente" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setClienteValue({
													nomeColuna: e.target.value,
													field: "cliente",
												});
											}}
											value={clienteValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Embarcador" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setEmbarcadorEmbValue({
													nomeColuna: e.target.value,
													field: "embarcador",
												});
											}}
											value={embarcadorEmbValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Destinatário" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setDestinatarioEmbValue({
													nomeColuna: e.target.value,
													field: "destinatario",
												});
											}}
											value={destinatarioEmbValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Load" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setLoadValue({
													nomeColuna: e.target.value,
													field: "load",
												});
											}}
											value={loadValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Mercadoria" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setMercadoriaValue({
													nomeColuna: e.target.value,
													field: "mercadoria",
												});
											}}
											value={mercadoriaValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Peso" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setPesoValue({
													nomeColuna: e.target.value,
													field: "peso",
													tipo: "number",
												});
											}}
											value={pesoValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Embalagem" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setEmbalagemEmbValue({
													nomeColuna: e.target.value,
													field: "embalagem",
												});
											}}
											value={embalagemEmbValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Observação" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setObservacaoValue({
													nomeColuna: e.target.value,
													field: "observacao",
												});
											}}
											value={observacaoValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Frota" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setFrotaValue({
													nomeColuna: e.target.value,
													field: "frota",
												});
											}}
											value={frotaValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Cancelado" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setCanceladoValue({
													nomeColuna: e.target.value,
													field: "cancelado",
												});
											}}
											value={canceladoValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Motivo" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setMotivoEmbarqueValue({
													nomeColuna: e.target.value,
													field: "motivo",
												});
											}}
											value={motivoEmbarqueValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Usuário Responsável" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setUsuarioResponsavelValue({
													nomeColuna: e.target.value,
													field: "usuarioResponsavel",
												});
											}}
											value={usuarioResponsavelValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Entregas" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setNEntregasValue({
													nomeColuna: e.target.value,
													field: "nEntregas",
												});
											}}
											value={nEntregasValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Comprovante" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setComprovanteValue({
													nomeColuna: e.target.value,
													field: "comprovante",
												});
											}}
											value={comprovanteValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Check-In" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setCheckinValue({
													nomeColuna: e.target.value,
													field: "checkInFeito",
												});
											}}
											value={checkinValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-embarquepedido">
										<input
											type="checkbox"
											checked={quebraTabelaEmbarque?.quebraColunaEmbarque}
											onChange={(e) => {
												setQuebraTabelaEmbarqueValue({
													quebraColunaEmbarque: e.target.checked,
												});
											}}
										></input>
										<InputLabel htmlFor="cidade">
											<Text texto="Quebra Linha" />
										</InputLabel>
									</div>
								</div>
							</div>
						</div>
					)}
					<div className="corpo-cores">
						<CustomButton
							classCss="custom-button-giant"
							titulo="Pedido"
							cor={coresEmpresa.botaoPadrao}
							corTexto={coresEmpresa.textoBotaoPadrao}
							onClick={() => {
								setShowPedido((showPedido) => !showPedido);
							}}
						/>
					</div>
					{showPedido && (
						<div className="dialog-overlay" onClick={() => closeDialog()}>
							<div
								className="dialog-content"
								onClick={(e) => e.stopPropagation()}
							>
								<button className="botao-fechar" onClick={() => closeDialog()}>
									×
								</button>
								<h1>Pedido</h1>
								<div className="grid-container-coluna-embarque">
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Pedido" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setPedidoPValue({
													nomeColuna: e.target.value,
													field: "pedido",
												});
											}}
											value={pedidoPValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Tipo Rota" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setTipoRotaValue({
													nomeColuna: e.target.value,
													field: "tipoRota",
												});
											}}
											value={tipoRotaValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Frete Fiscal" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setFreteFiscalPValue({
													nomeColuna: e.target.value,
													field: "freteFiscal",
													tipo: "number",
												});
											}}
											value={freteFiscalPValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="ICMS" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setIcmsPValue({
													nomeColuna: e.target.value,
													field: "icms",
													tipo: "number",
												});
											}}
											value={icmsPValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Pedágio" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setPedagioPValue({
													nomeColuna: e.target.value,
													field: "pedagio",
													tipo: "number",
												});
											}}
											value={pedagioPValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Classificação" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setClassificacaoPValue({
													nomeColuna: e.target.value,
													field: "classificacao",
													tipo: "number",
												});
											}}
											value={classificacaoPValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="KM" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setKmPValue({
													nomeColuna: e.target.value,
													field: "km",
													tipo: "number",
												});
											}}
											value={kmPValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Cliente" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setClientePValue({
													nomeColuna: e.target.value,
													field: "cliente",
												});
											}}
											value={clientePValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Embarcador" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setEmbarcadorPValue({
													nomeColuna: e.target.value,
													field: "embarcador",
												});
											}}
											value={embarcadorPValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Destinatário" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setDestinatarioPValue({
													nomeColuna: e.target.value,
													field: "destinatario",
												});
											}}
											value={destinatarioPValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Frete Motorista" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setFreteMotoristaPValue({
													nomeColuna: e.target.value,
													field: "freteMotorista",
													tipo: "number",
												});
											}}
											value={freteMotoristaPValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Observação" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setObservacaoPValue({
													nomeColuna: e.target.value,
													field: "observacao",
												});
											}}
											value={observacaoPValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Permitir Alterar Frete Fiscal" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setPermiteAlterarFreteFiscalValue({
													nomeColuna: e.target.value,
													field: "permiteAlterarFreteFiscal",
												});
											}}
											value={permiteAlterarFreteFiscalValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Valor Viagem" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setValorEmbarquePedidoValue({
													nomeColuna: e.target.value,
													field: "valorEmbarque",
												});
											}}
											value={valorEmbarquePedidoValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="ICMS Embutido" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setIcmsEmbutidoValue({
													nomeColuna: e.target.value,
													field: "icmsEmbutido",
												});
											}}
											value={icmsEmbutido?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="ICMS Embarcador" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setIcmsEmbarcadorValue({
													nomeColuna: e.target.value,
													field: "icmsEmbarcador",
												});
											}}
											value={icmsEmbarcador?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Frete Normal" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setFreteNormalValue({
													nomeColuna: e.target.value,
													field: "freteNormal",
												});
											}}
											value={freteNormal?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-embarquepedido">
										<input
											type="checkbox"
											checked={quebraTabelaPedido?.quebraColunaPedido}
											onChange={(e) => {
												setQuebraTabelaPedidoValue({
													quebraColunaPedido: e.target.checked,
												});
											}}
										></input>
										<InputLabel htmlFor="cidade">
											<Text texto="Quebra Linha" />
										</InputLabel>
									</div>
								</div>
							</div>
						</div>
					)}
					<div className="corpo-cores">
						<CustomButton
							classCss="custom-button-giant"
							titulo="Rota"
							cor={coresEmpresa.botaoPadrao}
							corTexto={coresEmpresa.textoBotaoPadrao}
							onClick={() => {
								setShowRota((showRota) => !showRota);
							}}
						/>
					</div>
					{showRota && (
						<div className="dialog-overlay" onClick={() => closeDialog()}>
							<div
								className="dialog-content"
								onClick={(e) => e.stopPropagation()}
							>
								<button className="botao-fechar" onClick={() => closeDialog()}>
									×
								</button>
								<h1>Rota</h1>
								<div className="grid-container-coluna-embarque">
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Rota" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setNomeRotaValue({
													nomeColuna: e.target.value,
													field: "nome",
												});
											}}
											value={nomeRotaValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Cidade Origem" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setCidadeOrigemRotaValue({
													nomeColuna: e.target.value,
													field: "cidadeOrigem",
												});
											}}
											value={cidadeOrigemRotaValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Estado Origem" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setEstadoOrigemRotaValue({
													nomeColuna: e.target.value,
													field: "estadoOrigem",
												});
											}}
											value={estadoOrigemRotaValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Cidade Destino" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setCidadeDestinoRotaValue({
													nomeColuna: e.target.value,
													field: "cidadeDestino",
												});
											}}
											value={cidadeDestinoRotaValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Estado Destino" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setEstadoDestinoRotaValue({
													nomeColuna: e.target.value,
													field: "estadoDestino",
												});
											}}
											value={estadoDestinoRotaValue.nomeColuna}
										/>
									</div>
								</div>
							</div>
						</div>
					)}
					<div className="corpo-cores">
						<CustomButton
							classCss="custom-button-giant"
							titulo="Unidade Embarque"
							cor={coresEmpresa.botaoPadrao}
							corTexto={coresEmpresa.textoBotaoPadrao}
							onClick={() => {
								setShowUnidadeEmbarque(
									(showUnidadeEmbarque) => !showUnidadeEmbarque
								);
							}}
						/>
					</div>
					{showUnidadeEmbarque && (
						<div className="dialog-overlay" onClick={() => closeDialog()}>
							<div
								className="dialog-content"
								onClick={(e) => e.stopPropagation()}
							>
								<button className="botao-fechar" onClick={() => closeDialog()}>
									×
								</button>
								<h1>Unidade Embarque</h1>
								<div className="grid-container-coluna-cidade">
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Unidade Embarque" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setNomeUnidadeEmbarqueValue({
													nomeColuna: e.target.value,
													field: "nome",
												});
											}}
											value={nomeUnidadeEmbarqueValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Cidade" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setCidadeUnidadeEmbarqueValue({
													nomeColuna: e.target.value,
													field: "usuario",
												});
											}}
											value={cidadeUnidadeEmbarqueValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Frota" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setFrotaUnidadeEmbarqueValue({
													nomeColuna: e.target.value,
													field: "frota",
												});
											}}
											value={frotaUnidadeEmbarqueValue?.nomeColuna}
										/>
									</div>
								</div>
							</div>
						</div>
					)}
					<div className="corpo-cores">
						<CustomButton
							classCss="custom-button-giant"
							titulo="Notificações"
							cor={coresEmpresa.botaoPadrao}
							corTexto={coresEmpresa.textoBotaoPadrao}
							onClick={() => {
								setShowNotificacao((showNotificacao) => !showNotificacao);
							}}
						/>
					</div>
					{showNotificacao && (
						<div className="dialog-overlay" onClick={() => closeDialog()}>
							<div
								className="dialog-content"
								onClick={(e) => e.stopPropagation()}
							>
								<button className="botao-fechar" onClick={() => closeDialog()}>
									×
								</button>
								<h1>Notificações</h1>
								<div className="grid-container-coluna-motorista">
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Título" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setTituloNotificaoValue({
													nomeColuna: e.target.value,
													field: "titulo",
												});
											}}
											value={tituloNotificaoValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Mensagem" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setMensagemNotificacaoValue({
													nomeColuna: e.target.value,
													field: "mensagem",
												});
											}}
											value={mensagemNotificacaoValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Ação" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setAcaoNotificacaoValue({
													nomeColuna: e.target.value,
													field: "acao",
												});
											}}
											value={acaoNotificacaoValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Número de Visualizações" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setNumeroVisualizacoesNotificacaoValueValue({
													nomeColuna: e.target.value,
													field: "numeroVisualizacoes",
												});
											}}
											value={numeroVisualizacoesNotificacaoValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Data" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setDataNotificacaoValuValue({
													nomeColuna: e.target.value,
													field: "data",
												});
											}}
											value={dataNotificacaoValue?.nomeColuna}
										/>
									</div>
								</div>
							</div>
						</div>
					)}
					<div className="corpo-cores">
						<CustomButton
							classCss="custom-button-giant"
							titulo="Solicitações"
							cor={coresEmpresa.botaoPadrao}
							corTexto={coresEmpresa.textoBotaoPadrao}
							onClick={() => {
								setShowSolicitacao((showSolicitacao) => !showSolicitacao);
							}}
						/>
					</div>
					{showSolicitacao && (
						<div className="dialog-overlay" onClick={() => closeDialog()}>
							<div
								className="dialog-content"
								onClick={(e) => e.stopPropagation()}
							>
								<button className="botao-fechar" onClick={() => closeDialog()}>
									×
								</button>
								<h1>Solicitações</h1>
								<div className="grid-container-coluna-motorista">
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Usuário" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setUsuarioSolicitacaoValue({
													nomeColuna: e.target.value,
													field: "usuario",
												});
											}}
											value={usuarioSolicitacaoValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Email" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setEmailSolicitacaoValue({
													nomeColuna: e.target.value,
													field: "email",
												});
											}}
											value={emailSolicitacaoValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Telefone" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setTelefoneSolicitacaoValue({
													nomeColuna: e.target.value,
													field: "telefone",
												});
											}}
											value={telefoneSolicitacaoValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Nascimento" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setNascimentoSolicitacaoValue({
													nomeColuna: e.target.value,
													field: "nascimento",
												});
											}}
											value={nascimentoSolicitacaoValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Aceitar" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setAceitarSolicitacaoValue({
													nomeColuna: e.target.value,
													field: "aceitar",
												});
											}}
											value={aceitarSolicitacaoValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Recusar" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setRecusarSolicitacaoValue({
													nomeColuna: e.target.value,
													field: "recusar",
												});
											}}
											value={recusarSolicitacaoValue?.nomeColuna}
										/>
									</div>
								</div>
							</div>
						</div>
					)}
                    
					<div className="corpo-cores">
						<CustomButton
							classCss="custom-button-giant"
							titulo="Divergencias SAT"
							cor={coresEmpresa.botaoPadrao}
							corTexto={coresEmpresa.textoBotaoPadrao}
							onClick={() => {
								setShowDivergenciasSat(
									(showDivergenciasSat) => !showDivergenciasSat
								);
							}}
						/>
					</div>
                    {showDivergenciasSat && (
						<div className="dialog-overlay" onClick={() => closeDialog()}>
							<div
								className="dialog-content"
								onClick={(e) => e.stopPropagation()}
							>
								<button className="botao-fechar" onClick={() => closeDialog()}>
									×
								</button>
								<h1>Divergencias SAT</h1>
								<div className="grid-container-coluna-motorista">
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cte">
											<Text texto="CTE" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) =>
												setCteDivergenciasValue({
													nomeColuna: e.target.value,
													field: "cte",
												})
											}
											value={cteDivergenciasValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="freteMotoristaGerenciador">
											<Text texto="Frete Motorista (Gerenciador)" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) =>
												setFreteMotoristaGerenciadorDivergenciasValue({
													nomeColuna: e.target.value,
													field: "freteMotoristaGerenciador",
													diferencaoFreteFiscal: false,
												})
											}
											value={freteMotoristaGerenciadorDivergenciasValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="freteMotoristaSat">
											<Text texto="Frete Motorista (SAT)" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) =>
												setFreteMotoristaSatDivergenciasValue({
													nomeColuna: e.target.value,
													field: "freteMotoristaSat",
													diferencaoFreteFiscal: false,
												})
											}
											value={freteMotoristaSatDivergenciasValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="freteFiscalGerenciador">
											<Text texto="Frete Fiscal (Gerenciador)" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) =>
												setFreteFiscalGerenciadorDivergenciasValue({
													nomeColuna: e.target.value,
													field: "freteFiscalGerenciador",
													diferencaoFreteFiscal: false,
												})
											}
											value={freteFiscalGerenciadorDivergenciasValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="freteFiscalSat">
											<Text texto="Frete Fiscal (SAT)" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) =>
												setFreteFiscalSatDivergenciasValue({
													nomeColuna: e.target.value,
													field: "freteFiscalSat",
													diferencaoFreteFiscal: false,
												})
											}
											value={freteFiscalSatDivergenciasValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="pedagioGerenciador">
											<Text texto="Pedágio (Gerenciador)" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) =>
												setPedagioGerenciadorDivergenciasValue({
													nomeColuna: e.target.value,
													field: "pedagioGerenciador",
													diferencaoFreteFiscal: false,
												})
											}
											value={pedagioGerenciadorDivergenciasValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="pedagioSat">
											<Text texto="Pedágio (SAT)" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) =>
												setPedagioSatDivergenciasValue({
													nomeColuna: e.target.value,
													field: "pedagioSat",
													diferencaoFreteFiscal: false,
												})
											}
											value={pedagioSatDivergenciasValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="icmsGerenciador">
											<Text texto="ICMS (Gerenciador)" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) =>
												setIcmsGerenciadorDivergenciasValue({
													nomeColuna: e.target.value,
													field: "icmsGerenciador",
													diferencaoFreteFiscal: false,
												})
											}
											value={icmsGerenciadorDivergenciasValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="icmsSat">
											<Text texto="ICMS (SAT)" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) =>
												setIcmsSatDivergenciasValue({
													nomeColuna: e.target.value,
													field: "icmsSat",
													diferencaoFreteFiscal: false,
												})
											}
											value={icmsSatDivergenciasValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="usuarioResponsavel">
											<Text texto="Usuário responsável (Gerenciador)" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) =>
												setUsuarioResponsavelGerenciadorDivergenciasValue({
													nomeColuna: e.target.value,
													field: "usuarioResponsavel",
													diferencaoFreteFiscal: false,
												})
											}
											value={usuarioResponsavelGerenciadorDivergenciasValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="temDiferenca">
											<Text texto="Tem Diferença (Sim/Não)" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) =>
												setTemDiferencaDivergenciasValue({
													nomeColuna: e.target.value,
													field: "temDiferenca",
													diferencaoFreteFiscal: false,
												})
											}
											value={temDiferencaDivergenciasValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="dataUltimaVerificacao">
											<Text texto="Data da última verificação" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) =>
												setDataUltimaVerificacaoDivergenciasValue({
													nomeColuna: e.target.value,
													field: "dataUltimaVerificacao",
													diferencaoFreteFiscal: false,
												})
											}
											value={dataUltimaVerificacaoDivergenciasValue?.nomeColuna}
										/>
									</div>
								</div>
							</div>
						</div>
					)}
				</CategoriaContainer>

				{/* Financeiro e Fiscal */}
				<CategoriaContainer titulo="Financeiro e Fiscal">
					<div className="corpo-cores">
						<CustomButton
							classCss="custom-button-giant"
							titulo="Taxa Icms"
							cor={coresEmpresa.botaoPadrao}
							corTexto={coresEmpresa.textoBotaoPadrao}
							onClick={() => {
								setShowTaxaIcms((showTaxaIcms) => !showTaxaIcms);
							}}
						/>
					</div>
					{showTaxaIcms && (
						<div className="dialog-overlay" onClick={() => closeDialog()}>
							<div
								className="dialog-content"
								onClick={(e) => e.stopPropagation()}
							>
								<button className="botao-fechar" onClick={() => closeDialog()}>
									×
								</button>
								<h1>Taxa Icms</h1>
								<div className="grid-container-coluna-empresa">
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Taxa ICMS" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setTaxaIcmsValue({
													nomeColuna: e.target.value,
													field: "taxa",
													tipo: "number",
												});
											}}
											value={taxaIcmsValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="UF Origem" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setUfOrigemTaxaValue({
													nomeColuna: e.target.value,
													field: "ufOrigem",
												});
											}}
											value={ufOrigemTaxaValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="UF Destino" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setUfDestinoTaxaValue({
													nomeColuna: e.target.value,
													field: "ufDestino",
												});
											}}
											value={ufDestinoTaxaValue.nomeColuna}
										/>
									</div>
								</div>
							</div>
						</div>
					)}
					<div className="corpo-cores">
						<CustomButton
							classCss="custom-button-giant"
							titulo="Precificação"
							cor={coresEmpresa.botaoPadrao}
							corTexto={coresEmpresa.textoBotaoPadrao}
							onClick={() => {
								setShowValorEmbarque((showValorEmbarque) => !showValorEmbarque);
							}}
						/>
					</div>
					{showValorEmbarque && (
						<div className="dialog-overlay" onClick={() => closeDialog()}>
							<div
								className="dialog-content"
								onClick={(e) => e.stopPropagation()}
							>
								<button className="botao-fechar" onClick={() => closeDialog()}>
									×
								</button>
								<h1>Precificação</h1>
								<div className="grid-container-coluna-embarque">
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Eixos" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setEixosValorEmbarqueValue({
													nomeColuna: e.target.value,
													field: "eixos",
												});
											}}
											value={eixosValorEmbarqueValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="KM" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setKmValorEmbarqueValue({
													nomeColuna: e.target.value,
													field: "km",
												});
											}}
											value={kmValorEmbarqueValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Valor Eixo" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setValorEixoValorEmbarqueValue({
													nomeColuna: e.target.value,
													field: "valorEixo",
												});
											}}
											value={valorEixoValorEmbarqueValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Adicional Carga Descarga" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setAdicionalCargaDescargaValorEmbarqueValue({
													nomeColuna: e.target.value,
													field: "adicionalCargaDescarga",
												});
											}}
											value={
												adicionalCargaDescargaValorEmbarqueValue?.nomeColuna
											}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Motorista" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setMotoristaValorEmbarqueValue({
													nomeColuna: e.target.value,
													field: "motorista",
												});
											}}
											value={motoristaValorEmbarqueValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Empresa" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setEmpresaValorEmbarqueValue({
													nomeColuna: e.target.value,
													field: "empresa",
												});
											}}
											value={empresaValorEmbarqueValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="ICMS" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setIcmsValorEmbarqueValue({
													nomeColuna: e.target.value,
													field: "icms",
												});
											}}
											value={icmsValorEmbarqueValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Descarga" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setDescargaValorEmbarqueValue({
													nomeColuna: e.target.value,
													field: "descarga",
												});
											}}
											value={descargaValorEmbarqueValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Pedágio" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setPedagioValorEmbarqueValue({
													nomeColuna: e.target.value,
													field: "pedagio",
												});
											}}
											value={pedagioValorEmbarqueValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Frete Fiscal" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setFreteFiscalValorEmbarqueValue({
													nomeColuna: e.target.value,
													field: "freteFiscal",
												});
											}}
											value={freteFiscalValorEmbarqueValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Rota" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setRotaValorEmbarqueValue({
													nomeColuna: e.target.value,
													field: "rota",
													objetoRota: "true",
												});
											}}
											value={rotaValorEmbarqueValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Cliente" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setClienteValorEmbarqueValue({
													nomeColuna: e.target.value,
													field: "cliente",
													objetoCliente: "true",
												});
											}}
											value={clienteValorEmbarqueValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Grupo Precificação" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setGrupoPrecificacaoValorEmbarqueValue({
													nomeColuna: e.target.value,
													field: "grupoPrecificacao",
													objetoGrupoPrecificacao: "true",
												});
											}}
											value={grupoPrecificacaoValorEmbarqueValue?.nomeColuna}
										/>
									</div>
								</div>
							</div>
						</div>
					)}
				</CategoriaContainer>

				{/* Gerenciamento de Frota */}
				<CategoriaContainer titulo="Gerenciamento de Frota">
					<div className="corpo-cores">
						<CustomButton
							classCss="custom-button-giant"
							titulo="Conjuntos"
							cor={coresEmpresa.botaoPadrao}
							corTexto={coresEmpresa.textoBotaoPadrao}
							onClick={() => {
								setShowVeiculo((showVeiculo) => !showVeiculo);
							}}
						/>
					</div>
					{showVeiculo && (
						<div className="dialog-overlay" onClick={() => closeDialog()}>
							<div
								className="dialog-content"
								onClick={(e) => e.stopPropagation()}
							>
								<button className="botao-fechar" onClick={() => closeDialog()}>
									×
								</button>
								<h1>Conjuntos</h1>
								<div className="grid-container-coluna-motorista">
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Placa Cavalo" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setPlacaCavaloVeiculoValue({
													nomeColuna: e.target.value,
													field: "placaCavalo",
												});
											}}
											value={placaCavaloVeiculoValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Placa Carreta" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setPlacaCarretaVeiculoValue({
													nomeColuna: e.target.value,
													field: "placaCarreta",
												});
											}}
											value={placaCarretaVeiculoValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Placa Carreta 2" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setPlacaCarreta2VeiculoValue({
													nomeColuna: e.target.value,
													field: "placaCarreta2",
												});
											}}
											value={placaCarreta2VeiculoValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Proprietário" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setProprietarioVeiculoValue({
													nomeColuna: e.target.value,
													field: "proprietario",
												});
											}}
											value={proprietarioVeiculoValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Motorista" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setMotoristaVeiculoValue({
													nomeColuna: e.target.value,
													field: "motorista",
												});
											}}
											value={motoristaVeiculoValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Motorista 2" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setMotorista2VeiculoValue({
													nomeColuna: e.target.value,
													field: "motorista2",
												});
											}}
											value={motorista2VeiculoValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Eixos" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setEixosValue({
													nomeColuna: e.target.value,
													field: "eixos",
												});
											}}
											value={eixosValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Tipo Veiculo APISUL" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setTipoVeiculoValue({
													nomeColuna: e.target.value,
													field: "tipoVeiculo",
												});
											}}
											value={tipoVeiculoValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Tipo Carroceria" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setTipoCarroceriaValue({
													nomeColuna: e.target.value,
													field: "tipoCarroceria",
													objetoTipoCarroceria: "true",
												});
											}}
											value={tipoCarroceriaValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Tipo Veículo" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setTipoVeiculoConjuntosValue({
													nomeColuna: e.target.value,
													field: "tipoVeiculoConjuntos",
													objetoTipoVeiculo: "true",
												});
											}}
											value={tipoVeiculoConjuntosValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Ativo Diária" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setAtivoDiariaValue({
													nomeColuna: e.target.value,
													field: "ativoDiaria",
												});
											}}
											value={ativoDiariaValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Elegível BRF" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setElegivelBrfValue({
													nomeColuna: e.target.value,
													field: "elegivelBrf",
												});
											}}
											value={elegivelBrfValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Cidade" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setCidadeEstadoConjuntoValue({
													nomeColuna: e.target.value,
													field: "cidadeEstado",
													objetoCidadeEstado: true,
												});
											}}
											value={cidadeEstadoConjuntoValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Data Última Localização" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setDataAtualizacaoLocalizacaoValue({
													nomeColuna: e.target.value,
													field: "dataAtualizacaoLocalizacao",
												});
											}}
											value={dataAtualizacaoLocalizacaoValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Agregado" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setAgregadoValue({
													nomeColuna: e.target.value,
													field: "agregado",
												});
											}}
											value={agregadoValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="Telemetria">
											<Text texto="Telemetria" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setTelemetriaValue({
													nomeColuna: e.target.value,
													field: "telemetria",
												});
											}}
											value={telemetriaValue?.nomeColuna}
										/>
									</div>
								</div>
							</div>
						</div>
					)}
					<div className="corpo-cores">
						<CustomButton
							classCss="custom-button-giant"
							titulo="Caminhão"
							cor={coresEmpresa.botaoPadrao}
							corTexto={coresEmpresa.textoBotaoPadrao}
							onClick={() => {
								setShowCaminhao((showCaminhao) => !showCaminhao);
							}}
						/>
					</div>
					{showCaminhao && (
						<div className="dialog-overlay" onClick={() => closeDialog()}>
							<div
								className="dialog-content"
								onClick={(e) => e.stopPropagation()}
							>
								<button className="botao-fechar" onClick={() => closeDialog()}>
									×
								</button>
								<h1>Caminhão</h1>
								<div className="grid-container-coluna-motorista">
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Placa" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setPlacaCaminhaoValue({
													nomeColuna: e.target.value,
													field: "placa",
												});
											}}
											value={placaCaminhaoValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Ano" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setAnoCaminhaoValue({
													nomeColuna: e.target.value,
													field: "ano",
												});
											}}
											value={anoCaminhaoValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Renavam" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setRenavamCaminhaoValue({
													nomeColuna: e.target.value,
													field: "renavam",
												});
											}}
											value={renavamCaminhaoValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Marca" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setMarcaCaminhaoValue({
													nomeColuna: e.target.value,
													field: "marca",
												});
											}}
											value={marcaCaminhaoValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Modelo" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setModeloCaminhaoValue({
													nomeColuna: e.target.value,
													field: "modelo",
												});
											}}
											value={modeloCaminhaoValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Frota" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setFrotaCaminhaoValue({
													nomeColuna: e.target.value,
													field: "frota",
												});
											}}
											value={frotaCaminhaoValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="KM" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setKmCaminhaoValue({
													nomeColuna: e.target.value,
													field: "km",
												});
											}}
											value={kmCaminhaoValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Eixos" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setEixosCaminhaoValue({
													nomeColuna: e.target.value,
													field: "numeroEixos",
												});
											}}
											value={eixosCaminhaoValue?.nomeColuna}
										/>
									</div>
								</div>
							</div>
						</div>
					)}
					<div className="corpo-cores">
						<CustomButton
							classCss="custom-button-giant"
							titulo="Carreta"
							cor={coresEmpresa.botaoPadrao}
							corTexto={coresEmpresa.textoBotaoPadrao}
							onClick={() => {
								setShowCarreta((showCarreta) => !showCarreta);
							}}
						/>
					</div>
					{showCarreta && (
						<div className="dialog-overlay" onClick={() => closeDialog()}>
							<div
								className="dialog-content"
								onClick={(e) => e.stopPropagation()}
							>
								<button className="botao-fechar" onClick={() => closeDialog()}>
									×
								</button>
								<h1>Carreta</h1>
								<div className="grid-container-coluna-motorista">
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Placa" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setPlacaCarretaCaminhaoValue({
													nomeColuna: e.target.value,
													field: "placa",
												});
											}}
											value={placaCarretaCaminhaoValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Ano" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setAnoCarretaCaminhaoValue({
													nomeColuna: e.target.value,
													field: "ano",
												});
											}}
											value={anoCarretaCaminhaoValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Renavam" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setRenavamCarretaCaminhaoValue({
													nomeColuna: e.target.value,
													field: "renavam",
												});
											}}
											value={renavamCarretaCaminhaoValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Marca" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setMarcaCarretaCaminhaoValue({
													nomeColuna: e.target.value,
													field: "marca",
												});
											}}
											value={marcaCarretaCaminhaoValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Modelo" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setModeloCarretaCaminhaoValue({
													nomeColuna: e.target.value,
													field: "modelo",
												});
											}}
											value={modeloCarretaCaminhaoValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Frota" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setFrotaCarretaValue({
													nomeColuna: e.target.value,
													field: "frota",
												});
											}}
											value={frotaCarretaValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="KM" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setKmCarretaValue({
													nomeColuna: e.target.value,
													field: "km",
												});
											}}
											value={kmCarretaValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Eixos" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setEixosCarretaValue({
													nomeColuna: e.target.value,
													field: "numeroEixos",
												});
											}}
											value={eixosCarretaValue?.nomeColuna}
										/>
									</div>
								</div>
							</div>
						</div>
					)}
					<div className="corpo-cores">
						<CustomButton
							classCss="custom-button-giant"
							titulo="Checkagem"
							cor={coresEmpresa.botaoPadrao}
							corTexto={coresEmpresa.textoBotaoPadrao}
							onClick={() => {
								setShowCheckagem((showCheckagem) => !showCheckagem);
							}}
						/>
					</div>
					{showCheckagem && (
						<div className="dialog-overlay" onClick={() => closeDialog()}>
							<div
								className="dialog-content"
								onClick={(e) => e.stopPropagation()}
							>
								<button className="botao-fechar" onClick={() => closeDialog()}>
									×
								</button>
								<h1>Checkagem</h1>
								<div className="grid-container-coluna-embarque">
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Dados" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setDadosCheckagemValue({
													nomeColuna: e.target.value,
													field: "dados",
												});
											}}
											value={dadosCheckagemValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Data" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setDataCheckagemValue({
													nomeColuna: e.target.value,
													field: "dataCheckagem",
												});
											}}
											value={dataCheckagemValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Observação" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setObservacaoCheckagemValue({
													nomeColuna: e.target.value,
													field: "observacao",
												});
											}}
											value={observacaoCheckagemValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="KM" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setKmCheckagemValue({
													nomeColuna: e.target.value,
													field: "km",
												});
											}}
											value={kmCheckagemValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Local" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setLocalCheckagemValue({
													nomeColuna: e.target.value,
													field: "local",
												});
											}}
											value={localCheckagemValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Tipo Manutenção" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setTipoManutencaoCheckagemValue({
													nomeColuna: e.target.value,
													field: "tipoManutencao",
												});
											}}
											value={tipoManutencaoCheckagemValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Proxima Revisão Data" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setProximaRevisaoDataValue({
													nomeColuna: e.target.value,
													field: "proximaRevisaoData",
												});
											}}
											value={proximaRevisaoDataValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Proxima Revisão KM" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setProximaRevisaoKMValue({
													nomeColuna: e.target.value,
													field: "proximaRevisaoKm",
												});
											}}
											value={proximaRevisaoKMValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Tipo Check" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setTipoCheckValue({
													nomeColuna: e.target.value,
													field: "tipoCheck",
												});
											}}
											value={tipoCheckValue?.nomeColuna}
										/>
									</div>
								</div>
							</div>
						</div>
					)}
					<div className="corpo-cores">
						<CustomButton
							classCss="custom-button-giant"
							titulo="Tipo Veículo"
							cor={coresEmpresa.botaoPadrao}
							corTexto={coresEmpresa.textoBotaoPadrao}
							onClick={() => {
								setShowTipoVeiculo((showTipoVeiculo) => !showTipoVeiculo);
							}}
						/>
					</div>
					{showTipoVeiculo && (
						<div className="dialog-overlay" onClick={() => closeDialog()}>
							<div
								className="dialog-content"
								onClick={(e) => e.stopPropagation()}
							>
								<button className="botao-fechar" onClick={() => closeDialog()}>
									×
								</button>
								<h1>Tipo Veículo</h1>
								<div className="grid-container-coluna-embalagem">
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Tipo Veículo" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setNomeTipoVeiculo({
													nomeColuna: e.target.value,
													field: "nome",
												});
											}}
											value={nomeTipoVeiculo?.nomeColuna}
										/>
									</div>
								</div>
							</div>
						</div>
					)}
					<div className="corpo-cores">
						<CustomButton
							classCss="custom-button-giant"
							titulo="Tipo Carroceria"
							cor={coresEmpresa.botaoPadrao}
							corTexto={coresEmpresa.textoBotaoPadrao}
							onClick={() => {
								setShowTipoCarroceria(
									(showTipoCarroceria) => !showTipoCarroceria
								);
							}}
						/>
					</div>
					{showTipoCarroceria && (
						<div className="dialog-overlay" onClick={() => closeDialog()}>
							<div
								className="dialog-content"
								onClick={(e) => e.stopPropagation()}
							>
								<button className="botao-fechar" onClick={() => closeDialog()}>
									×
								</button>
								<h1>Tipo Carroceria</h1>
								<div className="grid-container-coluna-embalagem">
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Tipo Carroceria" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setNomeTipoCarroceria({
													nomeColuna: e.target.value,
													field: "nome",
												});
											}}
											value={nomeTipoCarroceria?.nomeColuna}
										/>
									</div>
								</div>
							</div>
						</div>
					)}
				</CategoriaContainer>

				{/* Monitoramento e Rastreamento */}
				<CategoriaContainer titulo="Monitoramento e Rastreamento">
					<div className="corpo-cores">
						<CustomButton
							classCss="custom-button-giant"
							titulo="Rastreamento"
							cor={coresEmpresa.botaoPadrao}
							corTexto={coresEmpresa.textoBotaoPadrao}
							onClick={() => {
								setShowRastreamento((showRastreamento) => !showRastreamento);
							}}
						/>
					</div>
					{showRastreamento && (
						<div className="dialog-overlay" onClick={() => closeDialog()}>
							<div
								className="dialog-content"
								onClick={(e) => e.stopPropagation()}
							>
								<button className="botao-fechar" onClick={() => closeDialog()}>
									×
								</button>
								<h1>Rastreamento</h1>
								<div className="grid-container-coluna-cidade">
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Usuário Rastreamento" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setUsuarioRastreamentoValue({
													nomeColuna: e.target.value,
													field: "usuarioRastreamento",
												});
											}}
											value={usuarioRastreamentoValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Senha" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setSenhaRastreamentoValue({
													nomeColuna: e.target.value,
													field: "senha",
												});
											}}
											value={senhaRastreamentoValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Tipo Veículo" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setTipoVeiculoRastreamentoValue({
													nomeColuna: e.target.value,
													field: "tipoVeiculo",
												});
											}}
											value={tipoVeiculoRastreamentoValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Tipo Rastreamento" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setTipoRastreamentoValue({
													nomeColuna: e.target.value,
													field: "tipoRastreamento",
												});
											}}
											value={tipoRastreamentoValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Veículo" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setVeiculoRastreamentoValue({
													nomeColuna: e.target.value,
													field1: "carreta",
													field2: "caminhao",
												});
											}}
											value={veiculoRastreamentoValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Fabricante Rastreamento" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setFabricanteRastreamentoValue({
													nomeColuna: e.target.value,
													field: "fabricanteRastreamento",
												});
											}}
											value={fabricanteRastreamentoValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Número Rastreador" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setNumeroRastreadorValue({
													nomeColuna: e.target.value,
													field: "numeroRastreador",
												});
											}}
											value={numeroRastreadorValue?.nomeColuna}
										/>
									</div>
								</div>
							</div>
						</div>
					)}
					<div className="corpo-cores">
						<CustomButton
							classCss="custom-button-giant"
							titulo="Tipo Rastreamento"
							cor={coresEmpresa.botaoPadrao}
							corTexto={coresEmpresa.textoBotaoPadrao}
							onClick={() => {
								setShowTipoRastreamento(
									(showTipoRastreamento) => !showTipoRastreamento
								);
							}}
						/>
					</div>
					{showTipoRastreamento && (
						<div className="dialog-overlay" onClick={() => closeDialog()}>
							<div
								className="dialog-content"
								onClick={(e) => e.stopPropagation()}
							>
								<button className="botao-fechar" onClick={() => closeDialog()}>
									×
								</button>
								<h1>Tipo Rastreamento</h1>
								<div className="grid-container-coluna-cidade">
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Nome" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setNomeTipoRastreamentoValue({
													nomeColuna: e.target.value,
													field: "nome",
												});
											}}
											value={nomeTipoRastreamentoValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="IP" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setIpValue({
													nomeColuna: e.target.value,
													field: "ip",
												});
											}}
											value={ipValue?.nomeColuna}
										/>
									</div>
								</div>
							</div>
						</div>
					)}
					<div className="corpo-cores">
						<CustomButton
							classCss="custom-button-giant"
							titulo="Cockpit"
							cor={coresEmpresa.botaoPadrao}
							corTexto={coresEmpresa.textoBotaoPadrao}
							onClick={() => {
								setShowCockpit((showCockpit) => !showCockpit);
							}}
						/>
					</div>
					{showCockpit && (
						<div className="dialog-overlay" onClick={() => closeDialog()}>
							<div
								className="dialog-content"
								onClick={(e) => e.stopPropagation()}
							>
								<button className="botao-fechar" onClick={() => closeDialog()}>
									×
								</button>
								<h1>Cockpit</h1>
								<div className="grid-container-coluna-motorista">
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Projetado" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setProjetadoValue({
													nomeColuna: e.target.value,
													field: "projetado",
												});
											}}
											value={projetadoValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Estado Origem" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setEstadoOrigemCockpitValue({
													nomeColuna: e.target.value,
													field: "estadoOrigem",
												});
											}}
											value={estadoOrigemCockpitValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Estado Destino" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setEstadoDestinoCockpitValue({
													nomeColuna: e.target.value,
													field: "estadoDestino",
												});
											}}
											value={estadoDestinoCockpitValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Grupo Cliente" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setGrupoClienteCockpitValue({
													nomeColuna: e.target.value,
													field: "grupoCliente",
												});
											}}
											value={grupoClienteCockpitValue?.nomeColuna}
										/>
									</div>
								</div>
							</div>
						</div>
					)}
					<div className="corpo-cores">
						<CustomButton
							classCss="custom-button-giant"
							titulo="Tipo de Checkagem"
							cor={coresEmpresa.botaoPadrao}
							corTexto={coresEmpresa.textoBotaoPadrao}
							onClick={() => {
								setShowTipoCheckagem((showTipoCheckagem) => !showTipoCheckagem);
							}}
						/>
					</div>
					{showTipoCheckagem && (
						<div className="dialog-overlay" onClick={() => closeDialog()}>
							<div
								className="dialog-content"
								onClick={(e) => e.stopPropagation()}
							>
								<button className="botao-fechar" onClick={() => closeDialog()}>
									×
								</button>
								<h1>Tipo de Checkagem</h1>
								<div className="grid-container-coluna-embarque">
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Tipo de Checkagem" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setNomeTipoCheckagemValue({
													nomeColuna: e.target.value,
													field: "nome",
												});
											}}
											value={nomeTipoCheckagemValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Notificar Automatico" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setNotificarAutomaticoValue({
													nomeColuna: e.target.value,
													field: "notificarAutomatico",
												});
											}}
											value={notificarAutomaticoValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Tipo Notificação" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setTipoNotificacaoValue({
													nomeColuna: e.target.value,
													field: "tipoNotificacao",
												});
											}}
											value={tipoNotificacaoValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Notificar Data" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setNotificarACadaDataValue({
													nomeColuna: e.target.value,
													field: "notificarACadaData",
												});
											}}
											value={notificarACadaDataValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Notificar KM" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setNotificarACadaKMValue({
													nomeColuna: e.target.value,
													field: "notificarACadaKm",
												});
											}}
											value={notificarACadaKmValue?.nomeColuna}
										/>
									</div>
								</div>
							</div>
						</div>
					)}
					<div className="corpo-cores">
						<CustomButton
							classCss="custom-button-giant"
							titulo="Status Diária"
							cor={coresEmpresa.botaoPadrao}
							corTexto={coresEmpresa.textoBotaoPadrao}
							onClick={() => {
								setShowStatusDiaria((showStatusDiaria) => !showStatusDiaria);
							}}
						/>
					</div>
					{showStatusDiaria && (
						<div className="dialog-overlay" onClick={() => closeDialog()}>
							<div
								className="dialog-content"
								onClick={(e) => e.stopPropagation()}
							>
								<button className="botao-fechar" onClick={() => closeDialog()}>
									×
								</button>
								<h1>Status Diária</h1>
								<div className="grid-container-coluna-motorista">
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Status Diária" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setStatusDiariaValue({
													nomeColuna: e.target.value,
													field: "status",
												});
											}}
											value={statusDiariaValue?.nomeColuna}
										/>
									</div>
								</div>
							</div>
						</div>
					)}
				</CategoriaContainer>

				{/* Relacionamentos e Agrupamentos */}
				<CategoriaContainer titulo="Relacionamentos e Agrupamentos">
					<div className="corpo-cores">
						<CustomButton
							classCss="custom-button-giant"
							titulo="Grupo Clientes"
							cor={coresEmpresa.botaoPadrao}
							corTexto={coresEmpresa.textoBotaoPadrao}
							onClick={() => {
								setShowGrupoClientes((showGrupoClientes) => !showGrupoClientes);
							}}
						/>
					</div>
					{showGrupoClientes && (
						<div className="dialog-overlay" onClick={() => closeDialog()}>
							<div
								className="dialog-content"
								onClick={(e) => e.stopPropagation()}
							>
								<button className="botao-fechar" onClick={() => closeDialog()}>
									×
								</button>
								<h1>Grupo Clientes</h1>
								<div className="grid-container-coluna-embalagem">
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Nome" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setNomeGrupoClienteValue({
													nomeColuna: e.target.value,
													field: "nome",
												});
											}}
											value={nomeGrupoClienteValue?.nomeColuna}
										/>
									</div>
								</div>
							</div>
						</div>
					)}
					<div className="corpo-cores">
						<CustomButton
							classCss="custom-button-giant"
							titulo="Vincular Clientes"
							cor={coresEmpresa.botaoPadrao}
							corTexto={coresEmpresa.textoBotaoPadrao}
							onClick={() => {
								setShowGrupoComClientes(
									(showGrupoComClientes) => !showGrupoComClientes
								);
							}}
						/>
					</div>
					{showGrupoComClientes && (
						<div className="dialog-overlay" onClick={() => closeDialog()}>
							<div
								className="dialog-content"
								onClick={(e) => e.stopPropagation()}
							>
								<button className="botao-fechar" onClick={() => closeDialog()}>
									×
								</button>
								<h1>Vincular Clientes</h1>
								<div className="grid-container-coluna-motorista">
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Cliente" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setClienteVinculoValue({
													nomeColuna: e.target.value,
													field: "cliente",
												});
											}}
											value={clienteVinculoValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Grupo Cliente" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setGrupoClienteVinculoValue({
													nomeColuna: e.target.value,
													field: "grupoCliente",
												});
											}}
											value={grupoClienteVinculoValue?.nomeColuna}
										/>
									</div>
								</div>
							</div>
						</div>
					)}
					<div className="corpo-cores">
						<CustomButton
							classCss="custom-button-giant"
							titulo="Grupo Precificação"
							cor={coresEmpresa.botaoPadrao}
							corTexto={coresEmpresa.textoBotaoPadrao}
							onClick={() => {
								setShowGrupoPrecificacao(
									(showGrupoPrecificacao) => !showGrupoPrecificacao
								);
							}}
						/>
					</div>
					{showGrupoPrecificacao && (
						<div className="dialog-overlay" onClick={() => closeDialog()}>
							<div
								className="dialog-content"
								onClick={(e) => e.stopPropagation()}
							>
								<button className="botao-fechar" onClick={() => closeDialog()}>
									×
								</button>
								<h1>Grupo Precificação</h1>
								<div className="grid-container-coluna-embalagem">
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Nome" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setGrupoPrecificacaoValue({
													nomeColuna: e.target.value,
													field: "nome",
												});
											}}
											value={grupoPrecificacaoValue?.nomeColuna}
										/>
									</div>
								</div>
							</div>
						</div>
					)}
					<div className="corpo-cores">
						<CustomButton
							classCss="custom-button-giant"
							titulo="Grupo Carga Vinculo"
							cor={coresEmpresa.botaoPadrao}
							corTexto={coresEmpresa.textoBotaoPadrao}
							onClick={() => {
								setShowGrupoCarga((showGrupoCarga) => !showGrupoCarga);
							}}
						/>
					</div>
					{showGrupoCarga && (
						<div className="dialog-overlay" onClick={() => closeDialog()}>
							<div
								className="dialog-content"
								onClick={(e) => e.stopPropagation()}
							>
								<button className="botao-fechar" onClick={() => closeDialog()}>
									×
								</button>
								<h1>Grupo Carga Vinculo</h1>
								<div className="grid-container-coluna-embalagem">
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Nome Grupo" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setGrupoCargaValue({
													nomeColuna: e.target.value,
													field: "nomeGrupo",
												});
											}}
											value={grupoCargaValue?.nomeColuna}
										/>
									</div>
								</div>
							</div>
						</div>
					)}

					<div className="corpo-cores">
						<CustomButton
							classCss="custom-button-giant"
							titulo="Vincular Grupo Carga"
							cor={coresEmpresa.botaoPadrao}
							corTexto={coresEmpresa.textoBotaoPadrao}
							onClick={() => {
								setShowGrupoCargaVinculo(
									(showGrupoCargaVinculo) => !showGrupoCargaVinculo
								);
							}}
						/>
					</div>
					{showGrupoCargaVinculo && (
						<div className="dialog-overlay" onClick={() => closeDialog()}>
							<div
								className="dialog-content"
								onClick={(e) => e.stopPropagation()}
							>
								<button className="botao-fechar" onClick={() => closeDialog()}>
									×
								</button>
								<h1>Vincular Grupo Carga</h1>
								<div className="grid-container-coluna-motorista">
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Grupo Carga" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setGrupoCargaVinculoValue({
													nomeColuna: e.target.value,
													field: "grupoCarga",
													objetoGrupoCarga: "true",
												});
											}}
											value={grupoCargaVinculoValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Motorista" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setMotoristaGrupoCargaVinculoValue({
													nomeColuna: e.target.value,
													field: "motorista",
													objetoMotorista: "true",
												});
											}}
											value={motoristaGrupoCargaVinculoVinculoValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Proprietário" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setProprietarioGrupoCargaVinculoValue({
													nomeColuna: e.target.value,
													field: "proprietario",
													objetoProprietario: "true",
												});
											}}
											value={
												proprietarioGrupoCargaVinculoVinculoValue?.nomeColuna
											}
										/>
									</div>
								</div>
							</div>
						</div>
					)}
				</CategoriaContainer>

				{/* Documentos e Comunicação */}
				<CategoriaContainer titulo="Documentos e Comunicação">
					<div className="corpo-cores">
						<CustomButton
							classCss="custom-button-giant"
							titulo="Tipo Documento"
							cor={coresEmpresa.botaoPadrao}
							corTexto={coresEmpresa.textoBotaoPadrao}
							onClick={() => {
								setShowTipoDocumento((showTipoDocumento) => !showTipoDocumento);
							}}
						/>
					</div>
					{showTipoDocumento && (
						<div className="dialog-overlay" onClick={() => closeDialog()}>
							<div
								className="dialog-content"
								onClick={(e) => e.stopPropagation()}
							>
								<button className="botao-fechar" onClick={() => closeDialog()}>
									×
								</button>
								<h1>Tipo Documento</h1>
								<div className="grid-container-coluna-motorista">
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Nome" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setNomeTipoDocValue({
													nomeColuna: e.target.value,
													field: "nome",
												});
											}}
											value={nomeTipoDocValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Tipo" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setTipoDocValue({
													nomeColuna: e.target.value,
													field: "tipoDocumentoEnum",
													objetoTipoDocumento: "true",
												});
											}}
											value={tipoDocValue?.nomeColuna}
										/>
									</div>
								</div>
							</div>
						</div>
					)}
					<div className="corpo-cores">
						<CustomButton
							classCss="custom-button-giant"
							titulo="Tipo Observação"
							cor={coresEmpresa.botaoPadrao}
							corTexto={coresEmpresa.textoBotaoPadrao}
							onClick={() => {
								setShowTipoObservacao(
									(showTipoObservacao) => !showTipoObservacao
								);
							}}
						/>
					</div>
					{showTipoObservacao && (
						<div className="dialog-overlay" onClick={() => closeDialog()}>
							<div
								className="dialog-content"
								onClick={(e) => e.stopPropagation()}
							>
								<button className="botao-fechar" onClick={() => closeDialog()}>
									×
								</button>
								<h1>Tipo Observação</h1>
								<div className="grid-container-coluna-motorista">
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Observação" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setTipoObservacaoValue({
													nomeColuna: e.target.value,
													field: "observacao",
												});
											}}
											value={tipoObservacaoValue?.nomeColuna}
										/>
									</div>
								</div>
							</div>
						</div>
					)}
					<div className="corpo-cores">
						<CustomButton
							classCss="custom-button-giant"
							titulo="Tipo Contato"
							cor={coresEmpresa.botaoPadrao}
							corTexto={coresEmpresa.textoBotaoPadrao}
							onClick={() => {
								setShowTipoContato((showTipoContato) => !showTipoContato);
							}}
						/>
					</div>
					{showTipoContato && (
						<div className="dialog-overlay" onClick={() => closeDialog()}>
							<div
								className="dialog-content"
								onClick={(e) => e.stopPropagation()}
							>
								<button className="botao-fechar" onClick={() => closeDialog()}>
									×
								</button>
								<h1>Tipo Contato</h1>
								<div className="grid-container-coluna-motorista">
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Contato" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setContatoValue({
													nomeColuna: e.target.value,
													field: "contato",
												});
											}}
											value={contatoValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Tipo Contato" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setTipoContatoValue({
													nomeColuna: e.target.value,
													field: "tipoContatoEnum",
													objetoTipoContato: "true",
												});
											}}
											value={tipoContatoValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Proprietário" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setProprietarioContatoValue({
													nomeColuna: e.target.value,
													field: "proprietario",
													objetoProprietario: "true",
												});
											}}
											value={proprietarioContatoValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Motorista" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setMotoristaContatoValue({
													nomeColuna: e.target.value,
													field: "motorista",
													objetoMotorista: "true",
												});
											}}
											value={motoristaContatoValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Nome" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setNomeContatoValue({
													nomeColuna: e.target.value,
													field: "nome",
												});
											}}
											value={nomeContatoValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Observação" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setObservacaoContatoValue({
													nomeColuna: e.target.value,
													field: "observacao",
												});
											}}
											value={observacaoContatoValue?.nomeColuna}
										/>
									</div>
								</div>
							</div>
						</div>
					)}
					<div className="corpo-cores">
						<CustomButton
							classCss="custom-button-giant"
							titulo="Documentação"
							cor={coresEmpresa.botaoPadrao}
							corTexto={coresEmpresa.textoBotaoPadrao}
							onClick={() => {
								setShowDocumentacao((showDocumentacao) => !showDocumentacao);
							}}
						/>
					</div>
					{showDocumentacao && (
						<div className="dialog-overlay" onClick={() => closeDialog()}>
							<div
								className="dialog-content"
								onClick={(e) => e.stopPropagation()}
							>
								<button className="botao-fechar" onClick={() => closeDialog()}>
									×
								</button>
								<h1>Documentação</h1>
								<div className="grid-container-coluna-motorista">
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Placa" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setPlacaDocumentacaoValue({
													nomeColuna: e.target.value,
													field: "placa",
													objetoDocumentacao1: "true",
												});
											}}
											value={placaDocumentacaoValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Proprietário" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setProprietarioDocumentacaoValue({
													nomeColuna: e.target.value,
													field: "proprietario",
													objetoDocumentacao2: "true",
												});
											}}
											value={proprietarioDocumentacaoValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Motorista" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setMotoristaDocumentacaoValue({
													nomeColuna: e.target.value,
													field: "motorista",
													objetoDocumentacao3: "true",
												});
											}}
											value={motoristaDocumentacaoValue?.nomeColuna}
										/>
									</div>
								</div>
							</div>
						</div>
					)}
					<div className="corpo-cores">
						<CustomButton
							classCss="custom-button-giant"
							titulo="Avisos"
							cor={coresEmpresa.botaoPadrao}
							corTexto={coresEmpresa.textoBotaoPadrao}
							onClick={() => {
								setShowAvisos((showAvisos) => !showAvisos);
							}}
						/>
					</div>
					{showAvisos && (
						<div className="dialog-overlay" onClick={() => closeDialog()}>
							<div
								className="dialog-content"
								onClick={(e) => e.stopPropagation()}
							>
								<button className="botao-fechar" onClick={() => closeDialog()}>
									×
								</button>
								<h1>Avisos</h1>
								<div className="grid-container-coluna-cidade">
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Mensagem" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setMensagemAvisoValue({
													nomeColuna: e.target.value,
													field: "mensagem",
												});
											}}
											value={mensagemAvisoValue.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Data" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setDataAvisoValue({
													nomeColuna: e.target.value,
													field: "data",
												});
											}}
											value={dataAvisoValue.nomeColuna}
										/>
									</div>
								</div>
							</div>
						</div>
					)}
				</CategoriaContainer>

				{/* Ocorrências e Segmentações */}
				<CategoriaContainer titulo="Ocorrências e Segmentações">
					<div className="corpo-cores">
						<CustomButton
							classCss="custom-button-giant"
							titulo="Ocorrência"
							cor={coresEmpresa.botaoPadrao}
							corTexto={coresEmpresa.textoBotaoPadrao}
							onClick={() => {
								setShowOcorrencia((showOcorrencia) => !showOcorrencia);
							}}
						/>
					</div>
					{showOcorrencia && (
						<div className="dialog-overlay" onClick={() => closeDialog()}>
							<div
								className="dialog-content"
								onClick={(e) => e.stopPropagation()}
							>
								<button className="botao-fechar" onClick={() => closeDialog()}>
									×
								</button>
								<h1>Ocorrencia</h1>
								<div className="grid-container-coluna-embalagem">
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Ocorrência" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setOcorrenciaValue({
													nomeColuna: e.target.value,
													field: "tipo",
												});
											}}
											value={ocorrenciaValue?.nomeColuna}
										/>
									</div>
								</div>
							</div>
						</div>
					)}
					<div className="corpo-cores">
						<CustomButton
							classCss="custom-button-giant"
							titulo="Tipo Ocorrência"
							cor={coresEmpresa.botaoPadrao}
							corTexto={coresEmpresa.textoBotaoPadrao}
							onClick={() => {
								setShowTipoOcorrencia(
									(showTipoOcorrencia) => !showTipoOcorrencia
								);
							}}
						/>
					</div>
					{showTipoOcorrencia && (
						<div className="dialog-overlay" onClick={() => closeDialog()}>
							<div
								className="dialog-content"
								onClick={(e) => e.stopPropagation()}
							>
								<button className="botao-fechar" onClick={() => closeDialog()}>
									×
								</button>
								<h1>Tipo Ocorrencia</h1>
								<div className="grid-container-coluna-embalagem">
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Tipo Ocorrência" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setTipoOcorrenciaValue({
													nomeColuna: e.target.value,
													field: "nome",
												});
											}}
											value={tipoOcorrenciaValue?.nomeColuna}
										/>
									</div>
								</div>
							</div>
						</div>
					)}
					<div className="corpo-cores">
						<CustomButton
							classCss="custom-button-giant"
							titulo="Sub Tipo Ocorrência"
							cor={coresEmpresa.botaoPadrao}
							corTexto={coresEmpresa.textoBotaoPadrao}
							onClick={() => {
								setShowSubTipoOcorrencia(
									(showSubTipoOcorrencia) => !showSubTipoOcorrencia
								);
							}}
						/>
					</div>
					{showSubTipoOcorrencia && (
						<div className="dialog-overlay" onClick={() => closeDialog()}>
							<div
								className="dialog-content"
								onClick={(e) => e.stopPropagation()}
							>
								<button className="botao-fechar" onClick={() => closeDialog()}>
									×
								</button>
								<h1>Sub Tipo Ocorrencia</h1>
								<div className="grid-container-coluna-cidade">
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Sub Tipo Ocorrência" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setSubTipoOcorrenciaValue({
													nomeColuna: e.target.value,
													field: "nome",
												});
											}}
											value={subTipoOcorrenciaValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Tipo Ocorrência" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setTipoOcorrenciaSubValue({
													nomeColuna: e.target.value,
													field: "tipoOcorrencia",
													objetoTipoOcorrencia: "true",
												});
											}}
											value={tipoOcorrenciaSubValue?.nomeColuna}
										/>
									</div>
								</div>
							</div>
						</div>
					)}
					<div className="corpo-cores">
						<CustomButton
							classCss="custom-button-giant"
							titulo="Motivo On Time"
							cor={coresEmpresa.botaoPadrao}
							corTexto={coresEmpresa.textoBotaoPadrao}
							onClick={() => {
								setShowMotivoOnTime((showMotivoOnTime) => !showMotivoOnTime);
							}}
						/>
					</div>
					{showMotivoOnTime && (
						<div className="dialog-overlay" onClick={() => closeDialog()}>
							<div
								className="dialog-content"
								onClick={(e) => e.stopPropagation()}
							>
								<button className="botao-fechar" onClick={() => closeDialog()}>
									×
								</button>
								<h1>Motivo On Time</h1>
								<div className="grid-container-coluna-embalagem">
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Motivo" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setMotivoOnTimeValue({
													nomeColuna: e.target.value,
													field: "motivo",
												});
											}}
											value={motivoOnTimeValue?.nomeColuna}
										/>
									</div>
								</div>
							</div>
						</div>
					)}
					<div className="corpo-cores">
						<CustomButton
							classCss="custom-button-giant"
							titulo="Motivo Cotação"
							cor={coresEmpresa.botaoPadrao}
							corTexto={coresEmpresa.textoBotaoPadrao}
							onClick={() => {
								setShowMotivoCotacao((showMotivoCotacao) => !showMotivoCotacao);
							}}
						/>
					</div>
					{showMotivoCotacao && (
						<div className="dialog-overlay" onClick={() => closeDialog()}>
							<div
								className="dialog-content"
								onClick={(e) => e.stopPropagation()}
							>
								<button className="botao-fechar" onClick={() => closeDialog()}>
									×
								</button>
								<h1>Motivo Cotação</h1>
								<div className="grid-container-coluna-embalagem">
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Motivo Cotação" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setMotivoCotacaoValue({
													nomeColuna: e.target.value,
													field: "motivo",
												});
											}}
											value={motivoCotacaoValue?.nomeColuna}
										/>
									</div>
								</div>
							</div>
						</div>
					)}
					<div className="corpo-cores">
						<CustomButton
							classCss="custom-button-giant"
							titulo="Segmento Cliente"
							cor={coresEmpresa.botaoPadrao}
							corTexto={coresEmpresa.textoBotaoPadrao}
							onClick={() => {
								setShowSegmentoCliente(
									(showSegmentoCliente) => !showSegmentoCliente
								);
							}}
						/>
					</div>
					{showSegmentoCliente && (
						<div className="dialog-overlay" onClick={() => closeDialog()}>
							<div
								className="dialog-content"
								onClick={(e) => e.stopPropagation()}
							>
								<button className="botao-fechar" onClick={() => closeDialog()}>
									×
								</button>
								<h1>Segmento Cliente</h1>
								<div className="grid-container-coluna-embalagem">
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Segmento Cliente" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setSegmentoClienteValue({
													nomeColuna: e.target.value,
													field: "nome",
												});
											}}
											value={segmentoClienteValue?.nomeColuna}
										/>
									</div>
								</div>
							</div>
						</div>
					)}
				</CategoriaContainer>

				{/* Outros */}
				<CategoriaContainer titulo="Outros">
					<div className="corpo-cores">
						<CustomButton
							classCss="custom-button-giant"
							titulo="Estadia"
							cor={coresEmpresa.botaoPadrao}
							corTexto={coresEmpresa.textoBotaoPadrao}
							onClick={() => {
								setShowEstadia((showEstadia) => !showEstadia);
							}}
						/>
					</div>
					{showEstadia && (
						<div className="dialog-overlay" onClick={() => closeDialog()}>
							<div
								className="dialog-content"
								onClick={(e) => e.stopPropagation()}
							>
								<button className="botao-fechar" onClick={() => closeDialog()}>
									×
								</button>
								<h1>Estadia</h1>
								<div className="grid-container-coluna-motorista">
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Status Diária" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setStatusDiariaEstadiaValue({
													nomeColuna: e.target.value,
													field: "statusDiariaId",
													objetoStatus: "true",
												});
											}}
											value={statusDiariaEstadiaValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Motivo Estadia" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setMotivoEstadiaEstadiaValue({
													nomeColuna: e.target.value,
													field: "motivoEstadiaId",
													objetoMotivo: "true",
												});
											}}
											value={motivoEstadiaEstadiaValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Tipo Veículo" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setTipoVeiculoEstadiaValue({
													nomeColuna: e.target.value,
													field: "tipoVeiculoId",
													objetoTipoVeiculo: "true",
												});
											}}
											value={tipoVeiculoEstadiaValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Daste" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setDasteEstadiaValue({
													nomeColuna: e.target.value,
													field: "daste",
												});
											}}
											value={dasteEstadiaValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Observação" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setObservacaoEstadiaValue({
													nomeColuna: e.target.value,
													field: "observacao",
												});
											}}
											value={observacaoEstadiaValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="CTE Complementar" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setCteComplementarEstadiaValue({
													nomeColuna: e.target.value,
													field: "cteComplementar",
												});
											}}
											value={cteComplementarEstadiaValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Tipo Estadia" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setTipoEstadiaEstadiaValue({
													nomeColuna: e.target.value,
													field: "tipoEstadia",
												});
											}}
											value={tipoEstadiaEstadiaValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Frete Empresa" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setFreteEmpresaEstadiaValue({
													nomeColuna: e.target.value,
													field: "freteEmpresa",
												});
											}}
											value={freteEmpresaEstadiaValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Frete Motorista" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setFreteMotoristaEstadiaValue({
													nomeColuna: e.target.value,
													field: "freteMotorista",
												});
											}}
											value={freteMotoristaEstadiaValue?.nomeColuna}
										/>
									</div>
								</div>
							</div>
						</div>
					)}
					<div className="corpo-cores">
						<CustomButton
							classCss="custom-button-giant"
							titulo="Cotação"
							cor={coresEmpresa.botaoPadrao}
							corTexto={coresEmpresa.textoBotaoPadrao}
							onClick={() => {
								setShowCotacao((showCotacao) => !showCotacao);
							}}
						/>
					</div>
					{showCotacao && (
						<div className="dialog-overlay" onClick={() => closeDialog()}>
							<div
								className="dialog-content"
								onClick={(e) => e.stopPropagation()}
							>
								<button className="botao-fechar" onClick={() => closeDialog()}>
									×
								</button>
								<h1>Cotação</h1>
								<div className="grid-container-coluna-motorista">
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Unidade Embarque" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setUnidadeEmbarqueCotacaoValue({
													nomeColuna: e.target.value,
													field: "unidadeEmbarque",
													objetoUnidadeEmbarqueNome: "true",
												});
											}}
											value={unidadeEmbarqueCotacaoValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Rota" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setRotaCotacaoValue({
													nomeColuna: e.target.value,
													field: "rota",
													objetoRota: "true",
												});
											}}
											value={rotaCotacaoValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Cliente" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setClienteCotacaoValue({
													nomeColuna: e.target.value,
													field: "cliente",
													objetoCliente: "true",
												});
											}}
											value={clienteCotacaoValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Valor" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setValorCotacaoValue({
													nomeColuna: e.target.value,
													field: "valor",
												});
											}}
											value={valorCotacaoValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="ICMS" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setIcmsCotacaoValue({
													nomeColuna: e.target.value,
													field: "icms",
												});
											}}
											value={icmsCotacaoValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Pedágio" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setPedagioCotacaoValue({
													nomeColuna: e.target.value,
													field: "pedagio",
												});
											}}
											value={pedagioCotacaoValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Distância KM" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setDistanciaKmCotacaoValue({
													nomeColuna: e.target.value,
													field: "distanciaKm",
												});
											}}
											value={distanciaKmCotacaoValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Valor Por KM" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setValorPorKmCotacaoValue({
													nomeColuna: e.target.value,
													field: "valorPorKm",
												});
											}}
											value={valorPorKmCotacaoValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Valor Desejavel Motorista" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setValorDesejavelMotoristaCotacaoValue({
													nomeColuna: e.target.value,
													field: "valorDesejavelMotorista",
												});
											}}
											value={valorDesejavelMotoristaCotacaoValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Descrição Rota" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setDescricaoRotaCotacaoValue({
													nomeColuna: e.target.value,
													field: "descricaoRota",
												});
											}}
											value={descricaoRotaCotacaoValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Foi Carregado" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setFoiCarregadoCotacaoValue({
													nomeColuna: e.target.value,
													field: "foiCarregado",
												});
											}}
											value={foiCarregadoCotacaoValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Tipo Veículo" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setTipoVeiculoCotacaoValue({
													nomeColuna: e.target.value,
													field: "tipoVeiculo",
													objetoTipoVeiculo: "true",
												});
											}}
											value={tipoVeiculoCotacaoValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Tipo Carroceria" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setTipoCarroceriaCotacaoValue({
													nomeColuna: e.target.value,
													field: "segmentoCliente",
													objetoTipoCarroceria: "true",
												});
											}}
											value={tipoCarroceriaCotacaoValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Segmento Cliente" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setSegmentoCliente({
													nomeColuna: e.target.value,
													field: "cotacaoCarroceria",
													objetoSegmentoCliente: "true",
												});
											}}
											value={segmentoCliente?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Motivo" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setMotivoCotacao({
													nomeColuna: e.target.value,
													field: "motivoCotacao",
													objetoMotivo: "true",
												});
											}}
											value={motivoCotacao?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Data Cotação" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setDataCotacaoValue({
													nomeColuna: e.target.value,
													field: "dataCotacao",
												});
											}}
											value={dataCotacaoValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Usuário Responsável" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setUsuarioResponsavelCotacaoValue({
													nomeColuna: e.target.value,
													field: "usuarioResponsavel",
												});
											}}
											value={usuarioResponsavelCotacaoValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Nome" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setNomeContatoCotacaoValue({
													nomeColuna: e.target.value,
													field: "nomeContato",
												});
											}}
											value={nomeContatoCotacaoValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Telefone" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setTelefoneContatoCotacaoValue({
													nomeColuna: e.target.value,
													field: "telefoneContato",
												});
											}}
											value={telefoneContatoCotacaoValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Email" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setEmailContatoCotacaoValue({
													nomeColuna: e.target.value,
													field: "emailContato",
												});
											}}
											value={emailContatoCotacaoValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Observação" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setObservacaoCotacaoValue({
													nomeColuna: e.target.value,
													field: "observacao",
												});
											}}
											value={observacaoCotacaoValue?.nomeColuna}
										/>
									</div>
								</div>
							</div>
						</div>
					)}
					<div className="corpo-cores">
						<CustomButton
							classCss="custom-button-giant"
							titulo="Motivo Estadia"
							cor={coresEmpresa.botaoPadrao}
							corTexto={coresEmpresa.textoBotaoPadrao}
							onClick={() => {
								setShowMotivoEstadia((showMotivoEstadia) => !showMotivoEstadia);
							}}
						/>
					</div>
					{showMotivoEstadia && (
						<div className="dialog-overlay" onClick={() => closeDialog()}>
							<div
								className="dialog-content"
								onClick={(e) => e.stopPropagation()}
							>
								<button className="botao-fechar" onClick={() => closeDialog()}>
									×
								</button>
								<h1>Motivo Estadia</h1>
								<div className="grid-container-coluna-motorista">
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Motivo Estadia" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setMotivoEstadiaValue({
													nomeColuna: e.target.value,
													field: "motivos",
												});
											}}
											value={motivoEstadiaValue?.nomeColuna}
										/>
									</div>
								</div>
							</div>
						</div>
					)}
					<div className="corpo-cores">
						<CustomButton
							classCss="custom-button-giant"
							titulo="Sorteio"
							cor={coresEmpresa.botaoPadrao}
							corTexto={coresEmpresa.textoBotaoPadrao}
							onClick={() => {
								setShowSorteio((showSorteio) => !showSorteio);
							}}
						/>
					</div>
					{showSorteio && (
						<div className="dialog-overlay" onClick={() => closeDialog()}>
							<div
								className="dialog-content"
								onClick={(e) => e.stopPropagation()}
							>
								<button className="botao-fechar" onClick={() => closeDialog()}>
									×
								</button>
								<h1>Sorteio</h1>
								<div className="grid-container-coluna-motorista">
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Nome" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setNomeSorteioValue({
													nomeColuna: e.target.value,
													field: "nome",
												});
											}}
											value={nomeSorteioValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Apenas CPF" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setApenasCpfValue({
													nomeColuna: e.target.value,
													field: "apenasCpf",
												});
											}}
											value={apenasCpfValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Cupoms" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setCupomsValue({
													nomeColuna: e.target.value,
													field: "cupoms",
												});
											}}
											value={cupomsValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Cupons Por Viagem" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setCuponsPorViagemValue({
													nomeColuna: e.target.value,
													field: "cuponsPorViagem",
												});
											}}
											value={cuponsPorViagem?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Data Sorteio" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setDataSorteioValue({
													nomeColuna: e.target.value,
													field: "dataSorteio",
												});
											}}
											value={dataSorteioValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Encerrado" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setEncerradoValue({
													nomeColuna: e.target.value,
													field: "encerrado",
												});
											}}
											value={encerradoValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Fim Busca" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setFimBuscaValue({
													nomeColuna: e.target.value,
													field: "fimBusca",
												});
											}}
											value={fimBuscaValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Início Busca" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setInicioBuscaValue({
													nomeColuna: e.target.value,
													field: "inicioBusca",
												});
											}}
											value={inicioBuscaValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Motoristas" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setMotoristasValue({
													nomeColuna: e.target.value,
													field: "motoristas",
												});
											}}
											value={motoristasValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Números KM por Cupom" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setNumerosKmPorCupomValue({
													nomeColuna: e.target.value,
													field: "numerosKmPorCupom",
												});
											}}
											value={numerosKmPorCupomValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Proprietários" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setProprietariosValue({
													nomeColuna: e.target.value,
													field: "proprietarios",
												});
											}}
											value={proprietariosValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Sorteados" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setSorteadosValue({
													nomeColuna: e.target.value,
													field: "sorteados",
												});
											}}
											value={sorteadosValue?.nomeColuna}
										/>
									</div>
								</div>
							</div>
						</div>
					)}
					<div className="corpo-cores">
						<CustomButton
							classCss="custom-button-giant"
							titulo="Configuração Empresa"
							cor={coresEmpresa.botaoPadrao}
							corTexto={coresEmpresa.textoBotaoPadrao}
							onClick={() => {
								setShowConfiguracaoEmpresa(
									(showConfiguracaoEmpresa) => !showConfiguracaoEmpresa
								);
							}}
						/>
					</div>
					{showConfiguracaoEmpresa && (
						<div className="dialog-overlay" onClick={() => closeDialog()}>
							<div
								className="dialog-content"
								onClick={(e) => e.stopPropagation()}
							>
								<button className="botao-fechar" onClick={() => closeDialog()}>
									×
								</button>
								<h1>Configuração Empresa</h1>
								<div className="grid-container-coluna-motorista">
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Tempo Diaria Minutos" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setTempoDiariaMinutosValue({
													nomeColuna: e.target.value,
													field: "tempoDiariaMinutos",
												});
											}}
											value={tempoDiariaMinutosValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Grupo Cliente" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setGrupoClienteDiariaValue({
													nomeColuna: e.target.value,
													field: "grupoCliente",
													objetoGrupoCliente: true,
												});
											}}
											value={grupoClienteDiariaValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Diária Viagem" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setDiariaEmbarqueValue({
													nomeColuna: e.target.value,
													field: "diariaEmbarque",
												});
											}}
											value={diariaEmbarqueValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Diária Entrega" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setDiariaEntregaValue({
													nomeColuna: e.target.value,
													field: "diariaEntrega",
												});
											}}
											value={diariaEntregaValue?.nomeColuna}
										/>
									</div>
									<div className="grid-item-coluna-cidade">
										<InputLabel htmlFor="cidade">
											<Text texto="Diária Destino" />
										</InputLabel>
										<input
											type="text"
											className="input-text"
											onChange={(e) => {
												setSomaDiariasValue({
													nomeColuna: e.target.value,
													field: "somaDiarias",
												});
											}}
											value={somaDiariasValue?.nomeColuna}
										/>
									</div>
								</div>
							</div>
						</div>
					)}
				</CategoriaContainer>
			</div>
			<div className="corpo-cores" style={{ marginBottom: "20px" }}>
				<CustomButton
					classCss="custom-button-giant"
					titulo="Salvar"
					cor="#008000"
					corTexto={coresEmpresa.textoBotaoPadrao}
					onClick={() => {
						cadastrar();
					}}
				/>
			</div>
			<div>
				<ModalAtualizar
					titulo="Colunas"
					texto="Clique no botão para atualizar a Página!"
					open={open}
					onClose={handleClose}
					onClick={cadastrar}
				/>
				<ToastSucesso
					texto={textoSucesso}
					open={openToastSucesso}
					onClose={handleCloseToastSucesso}
				/>
				<ToastErro
					texto={textoErro}
					open={openToastErro}
					onClose={handleCloseToastErro}
				/>
			</div>
		</motion.div>
	);
}

export default ConfiguracoesColunas;
